var $i = Object.defineProperty;
var zi = (e, t, n) => t in e ? $i(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var we = (e, t, n) => zi(e, typeof t != "symbol" ? t + "" : t, n);
import { defineComponent as V, ref as _, createElementBlock as k, openBlock as p, mergeProps as pe, mergeModels as ie, useModel as he, computed as x, createBlock as $, withKeys as at, normalizeClass as z, createElementVNode as R, createCommentVNode as A, withModifiers as $e, toDisplayString as G, resolveDynamicComponent as Le, withCtx as j, resolveComponent as Mi, useAttrs as ut, toValue as Q, isRef as Fi, getCurrentScope as So, onScopeDispose as Ao, onMounted as xn, nextTick as Oi, watch as le, getCurrentInstance as Cn, hasInjectionContext as Io, inject as Ni, toRef as kn, readonly as Li, customRef as Bi, shallowRef as ze, watchEffect as Di, unref as T, Comment as Ri, Text as Vi, Fragment as be, useSlots as re, renderSlot as O, createVNode as te, createTextVNode as Tn, shallowReadonly as De, useTemplateRef as He, withDirectives as Me, Transition as Lt, normalizeStyle as Wn, useId as Ce, vModelCheckbox as Eo, vModelText as $o, createSlots as zo, renderList as We, vShow as Mo, onBeforeUnmount as Pi, Teleport as Hi } from "vue";
const ji = "groover", Ui = 1746441930, Wi = {
  charts: {
    body: '<path fill="currentColor" d="M14.968 7.08q0-.215.093-.413.094-.198.265-.35.173-.152.397-.235c.148-.054.307-.082.468-.082h5.587c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.23.203-.54.317-.864.317H16.19c-.16 0-.32-.028-.468-.082a1.2 1.2 0 01-.397-.235c-.113-.1-.203-.22-.265-.35a1 1 0 01-.093-.414m6.81 7.563H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316m0-4.36H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316M10.603 8.16H7.635v6.907c0 .58-.194 1.147-.559 1.629a3.26 3.26 0 01-1.489 1.08 3.7 3.7 0 01-1.917.167 3.47 3.47 0 01-1.698-.803 2.85 2.85 0 01-.908-1.501 2.62 2.62 0 01.189-1.695 3.04 3.04 0 011.221-1.316 3.64 3.64 0 011.844-.494c.295.004.589.043.873.116V7.08c0-.287.128-.562.358-.765S6.089 6 6.413 6h4.19c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.229.203-.54.317-.864.317"/>',
    width: 24,
    height: 24
  },
  "groover-plus": {
    body: '<g fill="currentColor"><path fill-opacity="15.5%" d="m11.395 23.685-9.771-8.802-1.265-1.265a1.227 1.227 0 010-1.735L11.873.36c.257-.257.615-.387.978-.354l10.035.913A1.226 1.226 0 0124 2.14v9.586c0 .316-.122.62-.34.848L13.1 23.62a1.225 1.225 0 01-1.705.064"/><path d="M19.323 5.881H21.6v1.473h-2.277v2.254h-1.445V7.354H15.6V5.881h2.278V3.603h1.445zM14.222 17.74l-.258-1.225h-.032c-.725 1.048-1.901 1.5-3.303 1.5-1.547 0-2.868-.532-3.802-1.532-1.064-1.129-1.595-2.677-1.595-4.467 0-3.402 2.159-6.014 5.72-6.014 3.012 0 4.913 1.564 5.284 4.128H12.98c-.177-.742-.87-1.355-1.9-1.355-1.612 0-2.434 1.355-2.434 3.241s.935 3.29 2.562 3.29c1.225 0 1.82-.661 2.03-1.435h-1.53v-2.387h4.752v6.257z"/></g>',
    width: 24,
    height: 24
  },
  "groover-plus-logo": {
    body: '<path fill="currentColor" d="M20.55 5.32h3.321v2.147H20.55v3.283h-2.108V7.467h-3.32V5.32h3.32V2h2.108zM13.11 22.6l-.375-1.785h-.047C11.63 22.342 9.915 23 7.87 23c-2.256 0-4.182-.775-5.545-2.232C.776 19.123 0 16.868 0 14.259c0-4.957 3.148-8.763 8.341-8.763 4.394 0 7.166 2.279 7.707 6.015h-4.746c-.259-1.081-1.27-1.974-2.773-1.974-2.35 0-3.548 1.973-3.548 4.722s1.363 4.794 3.736 4.794c1.786 0 2.655-.964 2.96-2.091H9.445v-3.478h6.932v9.117z"/>',
    width: 24,
    height: 24
  },
  logo: {
    body: '<path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M101.447 30.545c0 13.948-6.004 25.907-14.596 31.045a3 3 0 01-1.539.41h-15.73a3.03 3.03 0 01-1.539-.41c-4.795-2.869-8.789-7.881-11.375-14.162a.35.35 0 00-.67.056c-1.407 5.836-3.529 10.54-6.08 13.472a3.05 3.05 0 01-2.299 1.04H40.04a3.03 3.03 0 01-2.309-1.05c-3.224-3.73-5.765-10.33-7.052-18.411-.066-.42-.658-.4-.703.02-.815 7.662-2.41 13.995-4.431 17.792-.538 1.008-1.574 1.65-2.704 1.65h-3.499a3.05 3.05 0 01-2.697-1.626c-1.803-3.366-3.266-8.725-4.136-15.234-.056-.43-.673-.41-.714.021-.552 6.235-1.443 11.392-2.552 14.782C8.837 61.18 7.66 62 6.362 62h-.264c-1.352 0-2.53-.82-2.936-2.07C1.266 54.14 0 43.155 0 30.545c-.01-11.9 1.11-22.341 2.826-28.352A3.05 3.05 0 015.752 0h.87a3.06 3.06 0 012.937 2.203c.956 3.366 1.726 8.116 2.222 13.717.031.431.659.442.714.021.78-5.835 2.035-10.75 3.585-14.127C16.597.708 17.675 0 18.874 0h4.424c1.2 0 2.278.697 2.784 1.793 1.772 3.875 3.159 9.756 3.904 16.74.045.42.638.431.704.021 1.165-7.341 3.377-13.475 6.181-17.328A3.01 3.01 0 0139.323 0h9.042c.967 0 1.879.441 2.45 1.23 2.147 2.945 3.96 7.24 5.19 12.378a.353.353 0 00.673.056c2.299-5.58 5.697-10.15 9.791-13.121A3 3 0 0168.22 0H86.7c.627 0 1.245.179 1.75.553 7.722 5.612 13.002 16.93 13.002 29.992"/>',
    width: 101.45,
    height: 62
  },
  "opportunity-advice": {
    body: '<g fill="currentColor"><path d="M25.386 25.526a2.49 2.49 0 002.489-2.489v-9.55a2.49 2.49 0 00-2.489-2.49H12.492a2.49 2.49 0 00-2.49 2.49v9.55a2.49 2.49 0 002.49 2.49h.375v3.262c0 .23.139.444.358.53a.57.57 0 00.63-.12l3.672-3.673zm-11.358-.577a.58.58 0 00-.578-.578h-.952c-.734 0-1.334-.6-1.334-1.334v-9.55c0-.734.6-1.335 1.334-1.335h12.894c.734 0 1.334.601 1.334 1.334v9.551c0 .734-.6 1.334-1.334 1.334h-8.095a.6.6 0 00-.22.046.6.6 0 00-.19.127l-2.853 2.853v-2.442z"/><path d="M33.505 18.643H29.21a.58.58 0 00-.578.577c0 .318.26.578.578.578h4.296c.733 0 1.334.6 1.334 1.334v9.55c0 .734-.6 1.335-1.334 1.335h-.953a.58.58 0 00-.577.577v2.443l-2.853-2.853a.55.55 0 00-.19-.127.6.6 0 00-.22-.046h-8.095c-.734 0-1.334-.6-1.334-1.334v-3.823a.58.58 0 00-.578-.577.58.58 0 00-.577.577v3.823a2.49 2.49 0 002.489 2.489h7.859l3.672 3.672a.581.581 0 00.988-.41v-3.262h.375A2.49 2.49 0 0036 30.677v-9.551a2.49 2.49 0 00-2.489-2.489z"/><path d="M32.553 27.715H21.09a.58.58 0 00-.577.577c0 .318.26.578.577.578h11.463a.58.58 0 00.577-.578.58.58 0 00-.578-.577m-3.343-1.235h3.343a.58.58 0 00.578-.578.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577m-.001-2.385h3.343a.58.58 0 00.578-.577.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577M12.273 9.549a.58.58 0 00.577-.578V6.39a.58.58 0 00-.577-.577.58.58 0 00-.578.577v2.58c0 .318.26.578.578.578M7.815 7.995a.575.575 0 10-.814.814l1.825 1.825a.59.59 0 00.82 0 .575.575 0 000-.814L7.82 7.995zm.155 4.701H5.39a.58.58 0 00-.578.577c0 .318.26.578.577.578h2.582a.58.58 0 00.577-.578.58.58 0 00-.577-.577m10.971 8.748 2.223 1.172a.6.6 0 00.272.064.578.578 0 00.572-.676l-.428-2.477 1.802-1.756a.58.58 0 00-.324-.987l-2.489-.364-1.114-2.252c-.196-.393-.843-.393-1.034 0l-1.114 2.252-2.489.364a.58.58 0 00-.468.393.58.58 0 00.145.594l1.801 1.756-.427 2.477a.58.58 0 00.231.566.59.59 0 00.606.046l2.224-1.172zm-2.795-3.684 1.629-.237a.56.56 0 00.433-.318l.727-1.478.728 1.478a.58.58 0 00.433.318l1.628.237-1.178 1.149a.58.58 0 00-.167.514l.277 1.622-1.455-.768a.59.59 0 00-.537 0l-1.455.768.277-1.622a.57.57 0 00-.167-.514l-1.178-1.15z"/></g>'
  },
  "opportunity-article": {
    body: '<g fill="currentColor"><path d="M33.848 5.839H8.155A3.156 3.156 0 005.004 8.99v24.202a3.156 3.156 0 003.152 3.151h25.692A3.156 3.156 0 0037 33.194V8.99a3.16 3.16 0 00-3.152-3.152M8.155 6.899h25.691c1.153 0 2.091.94 2.091 2.092v1.48H6.064v-1.48c0-1.154.938-2.092 2.09-2.092m25.693 28.387H8.155a2.093 2.093 0 01-2.092-2.092V11.531H35.94v21.662a2.094 2.094 0 01-2.091 2.093"/><path d="M8.677 9.423h1.862a.53.53 0 100-1.06H8.677a.53.53 0 100 1.06m4.535 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m4.537 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m15.791 4.025H8.46a.53.53 0 00-.53.53v5.77c0 .293.238.53.53.53h25.084a.53.53 0 00.53-.53V13.98a.53.53 0 00-.532-.531m-.528 5.77H8.99v-4.71h24.022zm.528 6.017h-7.165a.53.53 0 00-.53.53v7.164c0 .293.237.53.53.53h7.165a.53.53 0 00.53-.53l.001-7.164a.53.53 0 00-.531-.53m-.529 7.166H26.91v-6.105h6.105zm.529-9.984H8.46a.53.53 0 100 1.06h25.084a.53.53 0 10-.002-1.06M22.84 25.617H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.203H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.199H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06"/></g>'
  },
  "opportunity-audio-interview": {
    body: '<g fill="currentColor"><path d="M12.886 17.76a.66.66 0 00.065-.931 3.9 3.9 0 01-.953-2.567c0-.948.339-1.86.953-2.567a.66.66 0 10-.996-.865 5.23 5.23 0 00-1.275 3.432c0 1.267.452 2.485 1.275 3.432a.656.656 0 00.93.064zm17.203-6.93a.66.66 0 00-.995.866c.614.707.953 1.619.953 2.567s-.34 1.86-.953 2.567a.66.66 0 00.996.866 5.23 5.23 0 001.276-3.432 5.23 5.23 0 00-1.276-3.432z"/><path d="M32.094 9.114a.66.66 0 10-1.001.859 6.58 6.58 0 011.588 4.29 6.58 6.58 0 01-1.588 4.29.66.66 0 001.001.86 7.906 7.906 0 000-10.298M9.361 14.263c0-1.576.564-3.098 1.587-4.29a.66.66 0 00-1-.859 7.9 7.9 0 00-1.906 5.149c0 1.89.678 3.719 1.906 5.149a.659.659 0 101-.86 6.58 6.58 0 01-1.587-4.29zm19.571 6.952a.66.66 0 00-.659.66 4.813 4.813 0 01-4.808 4.807H18.58a4.813 4.813 0 01-4.808-4.808.659.659 0 10-1.317 0A6.133 6.133 0 0018.579 28h1.784v2.637h-3.296a1.98 1.98 0 00-1.977 1.977 1.98 1.98 0 001.977 1.978h7.91a1.98 1.98 0 001.977-1.978 1.98 1.98 0 00-1.977-1.977h-3.296V28h1.783a6.133 6.133 0 006.127-6.126.66.66 0 00-.66-.659m-3.296 11.399a.66.66 0 01-.66.659h-7.91a.66.66 0 010-1.318h7.91a.66.66 0 01.66.659"/><path d="M18.579 25.363h4.886a3.493 3.493 0 003.489-3.49V10.397a3.493 3.493 0 00-3.489-3.489h-4.887a3.493 3.493 0 00-3.488 3.49v11.477a3.493 3.493 0 003.488 3.489m0-17.139h4.886c1.198 0 2.172.974 2.172 2.17v1.125h-1.978a.659.659 0 100 1.318h1.978v2.636h-1.978a.658.658 0 100 1.317h1.978v2.637h-1.978a.659.659 0 100 1.317h1.978v1.125a2.174 2.174 0 01-2.172 2.171h-4.887a2.173 2.173 0 01-2.17-2.171v-1.125h1.978a.66.66 0 000-1.317h-1.978V16.79h1.978a.66.66 0 000-1.317h-1.978v-2.636h1.978a.66.66 0 000-1.318h-1.978v-1.124c0-1.198.974-2.17 2.17-2.17"/></g>'
  },
  "opportunity-channel": {
    body: '<g fill="currentColor" stroke="currentColor" stroke-width=".1"><path d="M6.526 29.012H35.78l.003.004h.02c.56 0 1.011-.455 1.011-1.011V8.019c0-.56-.455-1.01-1.01-1.01H6.526c-.56 0-1.01.455-1.01 1.01v19.982c0 .56.454 1.011 1.01 1.011Zm29.12-20.84v19.677H6.68V8.172z"/><path d="M17.614 22.685h.05v-.005a.6.6 0 00.24-.076l7.094-4.094a.584.584 0 000-1.008l-7.093-4.094a.584.584 0 00-.873.504v8.192c0 .21.113.4.29.504h.001a.6.6 0 00.29.077Zm.581-7.769 5.349 3.09-5.349 3.09zm-4.763 19.549H36.23a.581.581 0 100-1.163H13.432a.581.581 0 100 1.163Zm-7.335 0h3.215a.581.581 0 100-1.163H6.097a.581.581 0 100 1.163Z"/><path d="M8.734 33.883a2.64 2.64 0 002.638 2.637 2.643 2.643 0 002.638-2.637 2.643 2.643 0 00-2.638-2.638 2.643 2.643 0 00-2.638 2.638Zm1.164-.004c0-.812.661-1.474 1.474-1.474s1.474.662 1.474 1.474c0 .813-.662 1.474-1.474 1.474a1.476 1.476 0 01-1.474-1.474Z"/></g>'
  },
  "opportunity-detailed-feedback": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M33.011 24.616A1.397 1.397 0 0034.4 23.22v-7.905a1.396 1.396 0 00-1.388-1.397H19.573a1.397 1.397 0 00-1.388 1.397V25.96c.32-.043.961-.37 1.575-.682.662-.338 1.295-.66 1.64-.66zm-5.049-5.349-3.64-2.115v4.23zm.75-.261a.303.303 0 010 .522l-4.521 2.627a.3.3 0 01-.169.052.3.3 0 01-.3-.302v-5.276a.3.3 0 01.041-.15.3.3 0 01.41-.11zm-2.12 6.215v7.275A1.503 1.503 0 0125.1 34H10.67a1.505 1.505 0 01-1.494-1.504V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59zm-.6-11.909V7.384a.9.9 0 00-.893-.898H10.67a.9.9 0 00-.893.899v25.111a.9.9 0 00.893.9h14.429a.9.9 0 00.893-.899V25.22H21.4c-.206 0-.776.29-1.372.594-.72.368-1.476.753-1.908.753-.337 0-.537-.15-.537-.516V15.314a2 2 0 01.584-1.412c.362-.365.86-.59 1.405-.59zM15.748 9.014a.302.302 0 010-.605h4.27a.302.302 0 010 .605z"/><path fill="currentColor" fill-rule="evenodd" d="M33.778 23.995c.199-.2.32-.474.32-.776v-7.905a1.096 1.096 0 00-1.087-1.097H19.573a1.1 1.1 0 00-1.088 1.097v10.241q.113-.045.253-.109c.27-.123.577-.28.885-.436l.008-.004c.326-.167.656-.335.949-.461.282-.122.579-.229.82-.229h11.611c.299 0 .57-.123.767-.32m-15.293 1.881a1.5 1.5 0 01-.3.082V15.315a1.397 1.397 0 011.388-1.397H33.01a1.396 1.396 0 011.388 1.397v7.906a1.397 1.397 0 01-1.388 1.396H21.4c-.345 0-.978.323-1.64.66h-.001c-.458.234-.931.476-1.275.6m7.244 7.256a.9.9 0 01-.63.263H10.67a.9.9 0 01-.893-.899V7.384a.9.9 0 01.893-.898h14.429a.9.9 0 01.893.899v5.927h-6.42c-.544 0-1.042.225-1.404.59a2 2 0 00-.584 1.412v10.738c0 .366.2.516.537.516.432 0 1.187-.385 1.907-.752h.001c.596-.304 1.166-.595 1.372-.595h4.59v7.275a.9.9 0 01-.262.636m-.038-7.61v6.974a.6.6 0 01-.592.6H10.67a.6.6 0 01-.593-.599V7.383a.6.6 0 01.593-.598h14.429a.6.6 0 01.593.599v5.627h-6.12c-.629 0-1.201.26-1.617.678a2.3 2.3 0 00-.671 1.624v10.738c0 .236.066.46.24.618.17.153.39.198.597.198.284 0 .631-.12.964-.263.342-.146.718-.337 1.074-.519l.007-.003c.299-.153.584-.298.82-.406a4 4 0 01.296-.122c.076-.027.11-.032.117-.034h4.292m-1.368-9.413c.088.051 4.703 2.763 4.758 2.857a.603.603 0 01-.219.821L24.35 22.41a.602.602 0 01-.927-.505v-5.282a.6.6 0 01.08-.294m.689 5.826 4.52-2.627a.303.303 0 000-.522l-4.538-2.638a.3.3 0 00-.41.11.3.3 0 00-.041.151v5.276a.302.302 0 00.469.25m.132-6.046a.6.6 0 00-.82.22ZM9.616 33.559a1.5 1.5 0 01-.44-1.063V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59h-6.419v7.274A1.503 1.503 0 0125.1 34H10.67c-.41 0-.783-.169-1.054-.441m17.276-8.038v6.975c0 .496-.201.947-.525 1.273a1.8 1.8 0 01-1.268.531H10.67a1.806 1.806 0 01-1.794-1.804V7.384a1.803 1.803 0 011.794-1.803h14.429a1.806 1.806 0 011.794 1.804v5.627h6.118c.63 0 1.203.26 1.616.677.415.418.673.993.673 1.625v7.906a2.3 2.3 0 01-.671 1.623 2.28 2.28 0 01-1.618.678zm-2.57-8.369v4.23l3.64-2.115zm.3.521 2.743 1.594-2.742 1.593zM15.75 9.315a.602.602 0 010-1.205h4.27a.602.602 0 010 1.205zm-.3-.602c0 .167.135.302.3.302h4.27a.302.302 0 000-.605h-4.27c-.165 0-.3.136-.3.303" clip-rule="evenodd"/><path fill="currentColor" d="M19 31a1 1 0 11-2 0 1 1 0 012 0"/></g>'
  },
  "opportunity-dj-set": {
    body: '<g fill="currentColor"><path d="M18.616 13.769a7.23 7.23 0 107.23 7.23 7.243 7.243 0 00-7.23-7.23m0 13.184a5.954 5.954 0 115.953-5.954 5.96 5.96 0 01-5.953 5.954"/><path d="M18.616 18.447a2.553 2.553 0 100 5.105 2.553 2.553 0 000-5.105m0 3.829a1.276 1.276 0 110-2.553 1.276 1.276 0 010 2.553"/><path d="M34.92 7.478h-1.972a2.086 2.086 0 00-2.08 2.086v4.352a2.08 2.08 0 002.08 2.08h.344v1.06a2.73 2.73 0 01-1.276 2.22A13.438 13.438 0 1032.138 21v-.293l.638-.383a3.83 3.83 0 001.831-3.267v-1.06h.351A2.08 2.08 0 0037 13.916V9.564a2.087 2.087 0 00-2.08-2.086M18.616 33.245A12.245 12.245 0 1130.804 20.01l-1.276.779a2.074 2.074 0 10.65 1.097l.639-.395a12.25 12.25 0 01-12.201 11.754M28.96 22.339a.804.804 0 11-1.608 0 .804.804 0 011.608 0m6.764-8.423a.81.81 0 01-.804.804h-1.972a.804.804 0 01-.804-.804V9.564a.804.804 0 01.804-.81h1.972a.81.81 0 01.804.81z"/><path d="M21.213 12.149a.639.639 0 10-.364 1.225c.602.179 1.18.427 1.723.74a.64.64 0 00.32.083.64.64 0 00.555-.32.64.64 0 00-.236-.867 9.4 9.4 0 00-1.998-.861"/><path d="M13.339 12.48a.64.64 0 00.319-.083 9.93 9.93 0 019.91 0 .64.64 0 00.867-.236.64.64 0 00-.197-.867 11.3 11.3 0 00-8.462-1.143c-.964.257-1.891.639-2.756 1.136a.638.638 0 00.319 1.187zm5.277 17.74a.638.638 0 000-1.276 7.9 7.9 0 01-3.95-1.06.639.639 0 10-.638 1.104 9.17 9.17 0 004.588 1.232"/><path d="M23.6 29.601a9.93 9.93 0 01-9.91 0 .638.638 0 00-.639 1.104c.855.497 1.771.881 2.725 1.142a11.2 11.2 0 008.462-1.142.638.638 0 00-.639-1.104"/></g>'
  },
  "opportunity-live-events": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M35.878 22.982a.32.32 0 00.322-.323V18.1a.32.32 0 00-.322-.323h-3.223l-.334-.718c-.072-.168-.263-.227-.43-.156a1.627 1.627 0 01-2.148-.801 1.64 1.64 0 01-.048-1.256c.155-.407.442-.718.836-.898a.28.28 0 00.167-.18.3.3 0 00-.012-.25L28.764 9.39a.31.31 0 00-.43-.155L23.048 11.7h-.012L5.383 19.907a.33.33 0 00-.155.431l1.91 4.127c.071.168.262.228.43.156a1.624 1.624 0 012.147.802c.18.394.203.837.06 1.244-.143.406-.441.73-.835.92a.33.33 0 00-.155.432l1.91 4.14c.035.07.095.143.178.167.036.011.072.023.108.023a.24.24 0 00.13-.035l1.875-.874h22.892a.32.32 0 00.322-.323V26.56a.32.32 0 00-.322-.323c-.895 0-1.611-.73-1.611-1.627s.727-1.627 1.61-1.627m-24.742 8.602L9.488 28.02a2.24 2.24 0 00.883-1.125 2.3 2.3 0 00-.072-1.735 2.25 2.25 0 00-2.697-1.22l-1.647-3.565 17.067-7.956.43.921c.06.12.167.192.287.192a.24.24 0 00.13-.036c.156-.072.228-.263.156-.431l-.43-.921 4.727-2.202 1.659 3.566a2.23 2.23 0 00-.883 1.1 2.25 2.25 0 00.071 1.759 2.284 2.284 0 002.697 1.22l1.66 3.566-4.727 2.2-.43-.92a.32.32 0 00-.43-.156c-.154.072-.226.263-.154.43l.43.922zm22.486-6.975a2.27 2.27 0 001.934 2.25v3.935H14.37l14.394-6.7h.012l.012-.011 5.3-2.465c.071-.036.143-.096.166-.18a.37.37 0 00-.011-.25l-1.29-2.764h2.602v3.936a2.27 2.27 0 00-1.933 2.249"/><path fill="currentColor" d="M24.695 14.5a.31.31 0 00-.43-.155.33.33 0 00-.155.43l.56 1.22c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.156-.43zm1.23 2.656a.31.31 0 00-.43-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.155-.431zm1.215 2.643a.32.32 0 00-.429-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.191.287.191a.24.24 0 00.132-.035.33.33 0 00.155-.431zm-7.196 2.058 1.456-2.62a.31.31 0 00-.048-.37.31.31 0 00-.37-.072l-2.71 1.256-2.04-2.201a.31.31 0 00-.37-.072.306.306 0 00-.18.335l.359 2.979-2.71 1.268a.306.306 0 00-.178.335.304.304 0 00.262.275l2.936.574.358 2.98c.012.143.12.25.263.274h.06c.119 0 .226-.06.286-.167l1.456-2.62 2.936.574a.33.33 0 00.346-.155.31.31 0 00-.047-.371zM18.63 23.33a.33.33 0 00-.346.155l-1.086 1.962-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64z"/><path fill="currentColor" fill-rule="evenodd" d="M31.891 16.904c.167-.071.358-.012.43.156l.334.718h3.223a.32.32 0 01.322.323v4.558a.32.32 0 01-.322.323c-.883 0-1.611.73-1.611 1.627s.716 1.627 1.61 1.627c.18 0 .323.144.323.323v4.558a.32.32 0 01-.322.323H12.986l-1.874.874a.24.24 0 01-.131.035.4.4 0 01-.108-.023c-.083-.024-.143-.096-.179-.168l-1.91-4.14a.33.33 0 01.156-.43 1.624 1.624 0 00.775-2.166 1.624 1.624 0 00-2.148-.801c-.167.072-.358.012-.43-.156l-1.91-4.127a.33.33 0 01.156-.43L23.035 11.7h.012l5.288-2.464a.31.31 0 01.43.155l1.92 4.128a.3.3 0 01.013.25.28.28 0 01-.167.18c-.394.18-.68.49-.836.898-.155.406-.131.861.048 1.256a1.627 1.627 0 002.148.801m-1.966-.885a1.43 1.43 0 001.883.703l.005-.002c.25-.108.567-.025.69.258l.28.6h3.095a.52.52 0 01.522.523v4.558c0 .29-.233.523-.522.523-.772 0-1.411.64-1.411 1.427 0 .788.628 1.427 1.41 1.427.29 0 .523.233.523.523v4.558c0 .29-.233.524-.522.524H13.03l-1.822.85a.45.45 0 01-.227.059.5.5 0 01-.165-.032l-.003-.001a.5.5 0 01-.298-.27l-.003-.005-1.911-4.144a.53.53 0 01.253-.691c.348-.17.608-.453.733-.807a1.46 1.46 0 00-.054-1.094 1.424 1.424 0 00-1.883-.703l-.004.002c-.251.108-.568.025-.691-.258l-1.911-4.13a.53.53 0 01.255-.692m24.625-3.706a1.44 1.44 0 01-.042-1.1c.137-.36.386-.63.73-.786a.48.48 0 00.274-.296.5.5 0 00-.016-.397l-1.923-4.131a.51.51 0 00-.699-.254L23.003 11.5h-.012L5.3 19.725m5.073 7.17a2.23 2.23 0 01-.883 1.124l1.647 3.565 17.08-7.956-.43-.921a.33.33 0 01.155-.43.32.32 0 01.43.155l.43.92 4.726-2.2-1.66-3.566a2.284 2.284 0 01-2.697-1.22 2.25 2.25 0 01-.072-1.759c.168-.454.478-.837.884-1.1l-1.66-3.566-4.726 2.202.43.921a.33.33 0 01-.155.43.24.24 0 01-.131.037.32.32 0 01-.287-.192l-.43-.921-17.067 7.956 1.647 3.565a2.25 2.25 0 012.697 1.22 2.3 2.3 0 01.072 1.735m-2.658-3.193a2.45 2.45 0 012.768 1.374 2.5 2.5 0 01.079 1.885c-.162.45-.447.842-.82 1.125l1.492 3.231L27.95 23.53l-.347-.745a.53.53 0 01.252-.69.52.52 0 01.698.25l.345.74 4.364-2.032-1.505-3.232a2.49 2.49 0 01-2.766-1.37l-.001-.001a2.45 2.45 0 01-.078-1.914c.162-.44.447-.819.818-1.098l-1.503-3.231-4.364 2.032.348.745a.53.53 0 01-.242.685.44.44 0 01-.229.061.52.52 0 01-.465-.302l-.002-.005-.345-.74L6.22 20.471zm21.062.393h-.012l-14.394 6.7h21.186v-3.937a2.27 2.27 0 01-1.934-2.249 2.27 2.27 0 011.934-2.25v-3.935h-2.602l1.289 2.763a.37.37 0 01.011.252c-.023.083-.095.143-.167.18l-5.299 2.464zm.129.154c-.022.01-.229.122-.229.122l-13.4 6.223h20.08v-3.568a2.47 2.47 0 01-1.934-2.417c0-1.188.834-2.177 1.934-2.417v-3.568h-2.088l1.159 2.484m.02.386a.5.5 0 01-.27.303l-.005.003-5.267 2.45m-4.795-9.475a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.431.24.24 0 01-.13.036.32.32 0 01-.287-.191zm1.075 1.552a.44.44 0 01-.228.06.52.52 0 01-.465-.302l-.003-.005-.563-1.226a.53.53 0 01.252-.69.51.51 0 01.7.255l.55 1.223a.53.53 0 01-.243.685m.716 2.324-.561-1.22a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.43.24.24 0 01-.13.037.32.32 0 01-.287-.192m.514.331a.53.53 0 00.242-.685l-.55-1.222a.51.51 0 00-.699-.256.53.53 0 00-.252.69l.563 1.226.003.006c.088.177.26.302.465.302a.44.44 0 00.228-.06m.907.733.001.001.55 1.224a.53.53 0 01-.242.685.44.44 0 01-.228.06.52.52 0 01-.465-.301l-.003-.006-.563-1.225a.53.53 0 01.252-.69.52.52 0 01.698.252m-.611-.072a.32.32 0 01.43.155l.549 1.22a.33.33 0 01-.155.431.24.24 0 01-.132.036.32.32 0 01-.286-.191l-.561-1.22a.33.33 0 01.155-.431m-5.729-.848a.31.31 0 01.37.071c.096.096.12.252.048.371l-1.456 2.62 2.065 2.202a.306.306 0 01.047.37.33.33 0 01-.346.156l-2.936-.574-1.456 2.62a.32.32 0 01-.286.168h-.06a.305.305 0 01-.263-.276l-.358-2.979-2.936-.574a.305.305 0 01-.262-.275.306.306 0 01.179-.335l2.709-1.268-.358-2.98a.306.306 0 01.179-.334.31.31 0 01.37.072l2.04 2.2zm-2.661 1.013-1.941-2.093a.51.51 0 00-.6-.12m2.54 2.213 2.58-1.196a.51.51 0 01.598.117.51.51 0 01.075.608l-1.383 2.49 1.962 2.092a.51.51 0 01.076.614.53.53 0 01-.55.25l-.006-.001-2.794-.547-1.385 2.493a.52.52 0 01-.461.27h-.077l-.016-.002a.505.505 0 01-.429-.452l-.34-2.83-2.79-.547a.505.505 0 01-.426-.447.506.506 0 01.294-.542l2.577-1.206-.34-2.831a.506.506 0 01.294-.546m2.89 5.537 1.598.305-1.1-1.19a.51.51 0 01-.077-.61l.787-1.42-1.47.685a.51.51 0 01-.604-.118l-1.11-1.19.19 1.614a.506.506 0 01-.293.544l-1.47.685 1.59.312a.505.505 0 01.425.452l.19 1.605.788-1.425a.53.53 0 01.55-.25zm-1.47 2.314-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64-2.196-.419a.33.33 0 00-.346.155z" clip-rule="evenodd"/><path fill="currentColor" d="M34.204 21.818c.352-.198.293-.558.22-.714l-2.388.714-3.486 2.607c1.738-.786 5.303-2.41 5.654-2.607"/></g>'
  },
  "opportunity-management-deal": {
    body: '<g fill="currentColor"><path d="M14.14 35.264h-3.533a1.735 1.735 0 01-1.767-1.766V8.767C8.84 7.765 9.606 7 10.607 7h14.132c1 0 1.766.765 1.766 1.767V12.3c0 .353-.235.588-.589.588-.353 0-.588-.235-.588-.588V8.767c0-.354-.236-.59-.59-.59h-14.13c-.354 0-.59.236-.59.59v24.73c0 .354.236.59.59.59h3.533c.353 0 .588.235.588.588 0 .354-.235.59-.588.59"/><path d="M22.972 36.442a11.183 11.183 0 01-11.188-11.188 11.183 11.183 0 0111.188-11.188A11.183 11.183 0 0134.16 25.254a11.183 11.183 0 01-11.188 11.188m0-21.198a10 10 0 00-10.01 10.01c0 5.535 4.475 10.01 10.01 10.01s10.01-4.475 10.01-10.01-4.475-10.01-10.01-10.01m-2.709-4.711h-5.24c-.825 0-1.531-.53-1.708-1.354L12.785 7h9.775l-.53 2.179c-.236.824-.942 1.354-1.767 1.354m-5.947-2.355.177.706c.059.236.294.471.589.471h5.24c.295 0 .53-.176.59-.47l.117-.707z"/><path d="M19.145 33.203a2.916 2.916 0 01-2.945-2.944 2.916 2.916 0 012.945-2.945 2.916 2.916 0 012.944 2.945 2.916 2.916 0 01-2.944 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .766 1.766 1.767 1.766a1.735 1.735 0 001.766-1.766 1.735 1.735 0 00-1.766-1.767m7.655 1.767a2.916 2.916 0 01-2.945-2.944A2.916 2.916 0 0126.8 24.37a2.916 2.916 0 012.945 2.944 2.916 2.916 0 01-2.945 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .765 1.766 1.766 1.766a1.735 1.735 0 001.767-1.766 1.735 1.735 0 00-1.767-1.767"/><path d="M22.089 30.259H20.91v-9.245l8.833-2.767v9.068h-1.178v-7.42l-6.477 1.944z"/></g>'
  },
  "opportunity-permanent-social-media-share": {
    body: '<g fill="currentColor"><path d="M13.089 14.625a.62.62 0 00.62-.621v-1.76c0-.932.76-1.69 1.69-1.69h4.935a.62.62 0 00.622-.622.62.62 0 00-.622-.621h-4.968a2.915 2.915 0 00-2.897 2.897v1.76c.033.38.274.657.62.657m15.045 6.52a.62.62 0 00-.621.621v9.524H13.71v-2.38a.62.62 0 00-.62-.622.62.62 0 00-.622.621v5.14a2.915 2.915 0 002.897 2.898H25.82a2.915 2.915 0 002.898-2.897l.001-12.284c0-.345-.241-.621-.586-.621M25.856 35.74H15.368c-.931 0-1.69-.76-1.69-1.69v-1.553h13.835v1.553c0 .93-.76 1.69-1.657 1.69"/><path d="M21.924 33.496H19.3a.62.62 0 00-.621.621c0 .346.276.622.621.622h2.623a.62.62 0 00.621-.622.62.62 0 00-.621-.62M34.377 5.895h-9.522a2.62 2.62 0 00-2.623 2.623v7.314a2.63 2.63 0 002.553 2.623v2.38c0 .241.138.448.38.552a.6.6 0 00.241.035c.138 0 .31-.068.414-.172l3.037-2.83h5.52A2.62 2.62 0 0037 15.799v-7.28a2.62 2.62 0 00-2.623-2.623m1.415 9.937a1.4 1.4 0 01-1.415 1.415l-5.761-.001a.64.64 0 00-.414.172l-2.208 2.035v-1.587a.62.62 0 00-.621-.622h-.553a1.4 1.4 0 01-1.415-1.415l.002-7.311a1.4 1.4 0 011.415-1.415h9.523a1.4 1.4 0 011.415 1.415l-.002 7.314zM15.816 28.527a.7.7 0 00.241-.07.61.61 0 00.346-.552v-2.139a2.63 2.63 0 002.552-2.622v-4.59a2.62 2.62 0 00-2.623-2.622l-9.487.001a2.62 2.62 0 00-2.622 2.623v4.588a2.62 2.62 0 002.622 2.622h5.556l3.037 2.623c.102.103.24.138.378.138m-.587-3.348v1.449L13.02 24.73a.52.52 0 00-.38-.137l-5.796-.002c-.793-.033-1.415-.654-1.415-1.448v-4.59a1.4 1.4 0 011.415-1.415h9.524a1.4 1.4 0 011.415 1.415l-.001 4.59a1.4 1.4 0 01-1.416 1.415h-.552c-.31 0-.586.275-.586.62"/><path d="M32.825 8.862c-.931-.655-2.347-.553-3.243.276a2.47 2.47 0 00-1.966-.725c-.725.068-1.415.449-1.83 1.035-.654.931-.517 2.45.346 3.313l3.037 3.036a.64.64 0 00.413.173.64.64 0 00.414-.173l3.14-3.14a2.47 2.47 0 00.725-1.966c-.035-.726-.415-1.382-1.036-1.83m-.518 2.966-2.725 2.692-2.623-2.623c-.448-.45-.552-1.277-.207-1.725a1.4 1.4 0 01.966-.553h.104c.345 0 .655.137.931.38l.45.449a.64.64 0 00.413.172.57.57 0 00.414-.172l.38-.38c.449-.449 1.276-.553 1.725-.208.31.242.517.553.553.967 0 .346-.138.725-.38 1.001m-24.703 8.25h8.004a.62.62 0 00.621-.622.62.62 0 00-.621-.621H7.605a.62.62 0 00-.622.621c.035.345.277.622.622.622m8.591 2.173a.62.62 0 00-.622-.621l-7.97.001a.62.62 0 00-.62.622c0 .345.276.62.62.62h8.005c.31-.034.586-.31.586-.622"/></g>'
  },
  "opportunity-publishing-deal": {
    body: '<g fill="currentColor"><path d="M21.22 33.364a6.203 6.203 0 006.199-6.199 6.203 6.203 0 00-6.199-6.199 6.203 6.203 0 00-6.199 6.2 6.2 6.2 0 006.199 6.198m0-11.27a5.08 5.08 0 015.072 5.071 5.08 5.08 0 01-5.072 5.072 5.08 5.08 0 01-5.072-5.072 5.08 5.08 0 015.072-5.071"/><path d="M9.386 19.84v15.604L8 37.163c-.276.338-.327.8-.14 1.195.185.394.58.642 1.013.642H33.58a1.12 1.12 0 001.014-.637c.192-.394.14-.85-.13-1.189l-1.408-1.78V19.84c0-.93-.761-1.69-1.691-1.69H11.077c-.93 0-1.69.76-1.69 1.69m24.198 18.033H8.874l1.363-1.69h22l1.342 1.69zM31.928 19.84v15.215H10.513V19.84c0-.31.254-.564.564-.564h20.287c.31 0 .564.254.564.564"/><path d="M19.23 29.9a.56.56 0 00.553.022l4.508-2.254a.563.563 0 000-1.003l-4.508-2.255a.57.57 0 00-.547.023.56.56 0 00-.265.479v4.508c0 .197.102.378.265.48zm.863-4.075 2.682 1.341-2.682 1.341zm1.69-11.057V6.315l.677.901.901-.676-1.69-2.254c-.215-.282-.688-.282-.902 0l-1.69 2.254.901.676.676-.901v8.453zm4.582.327 3.601-7.016.192 1.11 1.11-.191-.474-2.779a.56.56 0 00-.298-.405.54.54 0 00-.502 0l-2.536 1.234.496 1.014 1.015-.496-3.601 7.016 1.003.513zm9.991-4.255-2.79.39.159 1.115 1.115-.158-3.595 3.579.795.8 3.595-3.579-.163 1.116 1.115.164.406-2.79a.56.56 0 00-.158-.479.58.58 0 00-.479-.163zM14.982 7.042l-2.536-1.234a.555.555 0 00-.8.406l-.474 2.778 1.11.191.192-1.11 3.6 7.016 1.004-.513-3.601-7.016 1.014.496.496-1.014zm-9.378 3.956a.56.56 0 00-.157.479l.405 2.79 1.116-.164-.163-1.116 3.595 3.579.795-.8-3.596-3.579 1.116.158.158-1.116-2.79-.389a.55.55 0 00-.479.164zm24.069 21.803H30.8v1.127h-1.127zm-2.254 0h1.127v1.127h-1.127zm-15.779 0h3.381v1.127H11.64z"/></g>'
  },
  "opportunity-radio-broadcast": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="M8.518 31.872A1.73 1.73 0 017 30.152V19.089a14.43 14.43 0 014.237-10.214 14.48 14.48 0 0110.23-4.231h.066c3.837 0 7.517 1.521 10.23 4.231A14.43 14.43 0 0136 19.09v11.065c0 .882-.66 1.611-1.518 1.72v2.03a.58.58 0 01-.578.576h-2.033v2.03c0 .318-.26.577-.578.577h-4.066a1.734 1.734 0 01-1.735-1.734v-8.117c0-.958.776-1.734 1.735-1.734h4.066c.319 0 .578.259.578.577v2.03h2.033c.32 0 .578.258.578.58v2a.58.58 0 00.362-.535V19.089c0-3.524-1.403-6.904-3.9-9.398a13.33 13.33 0 00-9.411-3.893h-.066c-3.53 0-6.914 1.402-9.411 3.893a13.28 13.28 0 00-3.9 9.398v11.063c0 .243.15.45.362.537v-2c0-.322.259-.58.578-.58h2.033v-2.03c0-.318.26-.577.578-.577h4.066c.959 0 1.735.776 1.735 1.734v8.117c0 .958-.776 1.734-1.735 1.734h-4.066a.58.58 0 01-.578-.577v-2.03H9.096a.58.58 0 01-.578-.577zm23.353 1.452h1.454v-4.059H31.87zm-1.158 2.609v-9.274h-3.486c-.32 0-.58.258-.58.577v8.117c0 .321.26.58.58.58zM11.13 29.265H9.675v4.059h1.454zm1.158 4.638v2.03h3.486a.58.58 0 00.58-.58v-8.117a.58.58 0 00-.58-.577h-3.486zm8.635-11.7a5.784 5.784 0 01-5.209-5.75.578.578 0 011.158 0 4.63 4.63 0 004.629 4.624 4.63 4.63 0 004.63-4.623.578.578 0 011.157 0 5.784 5.784 0 01-5.209 5.75v1.377a7.3 7.3 0 012.412.604.577.577 0 11-.465 1.059c-1.584-.692-3.273-.699-5.07.009a.579.579 0 01-.425-1.077 8.7 8.7 0 012.392-.584zm4.527-10.646v4.899a3.944 3.944 0 01-3.948 3.942H21.5a3.944 3.944 0 01-3.948-3.942v-4.899a3.944 3.944 0 013.948-3.94h.002a3.944 3.944 0 013.948 3.94m-1.158 0a2.787 2.787 0 00-2.79-2.786H21.5a2.787 2.787 0 00-2.79 2.786v4.899a2.787 2.787 0 002.79 2.786h.002a2.787 2.787 0 002.79-2.786zm-3.949 5.169a.578.578 0 110-1.156h2.327a.578.578 0 110 1.156zm.02-2.753a.579.579 0 010-1.156h2.328a.578.578 0 010 1.156zm-.02-2.754a.578.578 0 110-1.154h2.327c.32 0 .58.258.58.577s-.26.577-.58.577z" clip-rule="evenodd"/>'
  },
  "opportunity-record-deal": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="m15.09 23.218 9.334-2.075v6.583a3.501 3.501 0 00-5.833 2.608c0 1.931 1.567 3.5 3.5 3.5 1.931 0 3.5-1.569 3.5-3.5v-14a.584.584 0 00-.71-.57l-10.5 2.333a.584.584 0 00-.457.57v10.225A3.501 3.501 0 008.09 31.5a3.5 3.5 0 007 0zM13.924 31.5a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m10.5-1.167a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m0-10.384V17.06l-9.334 2.075v2.888zm.583-11.782a7.59 7.59 0 017.583 7.583.584.584 0 001.167 0c0-4.829-3.921-8.75-8.75-8.75a.584.584 0 000 1.167m0 2.916a4.67 4.67 0 014.667 4.667.583.583 0 001.166 0 5.835 5.835 0 00-5.833-5.833.584.584 0 000 1.166m0 2.917c.966 0 1.75.784 1.75 1.75a.583.583 0 001.167 0 2.92 2.92 0 00-2.917-2.917.584.584 0 000 1.167" clip-rule="evenodd"/>'
  },
  "opportunity-share-to-my-team": {
    body: '<path fill="currentColor" d="M35.218 21.003c-.642 0-1.263.227-1.76.64a2.85 2.85 0 00-.968 1.626h-4.743c.28-.993.31-2.042.089-3.05a6.2 6.2 0 00-1.354-2.723l3.369-5.388a4.1 4.1 0 003.06.175 4.2 4.2 0 002.353-2 4.32 4.32 0 00.377-3.097 4.25 4.25 0 00-1.803-2.523 4.1 4.1 0 00-3.01-.59 4.17 4.17 0 00-2.595 1.663 4.306 4.306 0 00.677 5.764l-3.247 5.197a6.02 6.02 0 00-4.071-1.352 6.04 6.04 0 00-3.94 1.71l-3.34-3.4a3.4 3.4 0 00.844-2.286 3.4 3.4 0 00-.899-2.265 3.266 3.266 0 00-4.46-.331 3.38 3.38 0 00-1.211 2.107c-.13.833.05 1.685.508 2.387a3.3 3.3 0 001.96 1.409 3.26 3.26 0 002.38-.313l3.484 3.547a6.3 6.3 0 00-1.18 3.636 6.3 6.3 0 001.136 3.65l-6.012 3.569a4.15 4.15 0 00-2.935-.958 4.17 4.17 0 00-2.788 1.34A4.32 4.32 0 004 32.063a4.32 4.32 0 001.124 2.922 4.17 4.17 0 002.78 1.355 4.15 4.15 0 002.941-.943 4.3 4.3 0 001.517-2.732 4.34 4.34 0 00-.724-3.05l5.978-3.55a6.1 6.1 0 002.016 1.309v4.964a1.7 1.7 0 00-1.123.049c-.36.142-.661.403-.86.74a1.79 1.79 0 00.258 2.15l1.725 1.816v.34c0 .15.059.295.163.401a.55.55 0 00.394.166h8.906c.147 0 .289-.06.393-.166a.57.57 0 00.163-.4v-9.632c0-.328-.093-.65-.269-.924a1.7 1.7 0 00-.72-.627 1.64 1.64 0 00-1.794.285 1.65 1.65 0 00-.838-.408 6.2 6.2 0 001.279-1.726h5.181a2.85 2.85 0 00.72 1.396c.364.387.83.66 1.34.788a2.74 2.74 0 001.548-.063c.5-.17.941-.48 1.275-.895a2.88 2.88 0 00.359-3.006 2.8 2.8 0 00-1.027-1.18 2.75 2.75 0 00-1.487-.439m-6.68-12.748c0-.616.18-1.219.516-1.731a3.07 3.07 0 011.374-1.148 3 3 0 011.769-.177c.594.12 1.14.417 1.567.853s.72.99.838 1.595a3.17 3.17 0 01-.174 1.8 3.1 3.1 0 01-1.128 1.4 3 3 0 01-1.7.524c-.812 0-1.59-.33-2.164-.913a3.15 3.15 0 01-.898-2.203M11.84 13.638a2.2 2.2 0 01-1.237-.382 2.26 2.26 0 01-.82-1.017 2.3 2.3 0 01-.127-1.31 2.3 2.3 0 01.61-1.16 2.2 2.2 0 011.14-.62 2.2 2.2 0 011.286.129c.407.171.754.462 1 .834a2.296 2.296 0 01-.278 2.862 2.2 2.2 0 01-1.574.664m-3.618 21.53a3 3 0 01-1.7-.526 3.1 3.1 0 01-1.128-1.399 3.17 3.17 0 01-.175-1.8c.118-.604.41-1.16.838-1.595a3.05 3.05 0 011.568-.853 3 3 0 011.768.177c.56.236 1.038.635 1.374 1.148a3.156 3.156 0 01-.381 3.934 3.04 3.04 0 01-2.164.913m18.09-7.366v1.7c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v9.065h-7.792a.57.57 0 00-.157-.393l-1.887-1.99a.64.64 0 01-.006-.882.62.62 0 01.865-.04l.184.248a.56.56 0 00.621.194.56.56 0 00.275-.206.57.57 0 00.105-.33v-9.066a.56.56 0 01.062-.248l.588-.299c.128.02.245.087.33.188.084.1.132.227.133.36v5.099c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v1.7c0 .15.059.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7c0-.15.06-.295.163-.4a.55.55 0 01.788 0 .57.57 0 01.163.4m-5.566-4.995V20.22l2.651 1.35-2.262 1.15a1.6 1.6 0 00-.39.087m3.228 3.379a1.66 1.66 0 00-1.002.013v-1.797a1.7 1.7 0 00-.431-1.13l2.35-1.192a.56.56 0 00.308-.508.57.57 0 00-.308-.507L20.438 18.8a.55.55 0 00-.734.23.6.6 0 00-.072.274v4.533q.002.105.042.2-.04.18-.042.366v1.737a5.07 5.07 0 01-2.322-2.41 5.2 5.2 0 01-.34-3.357 5.12 5.12 0 011.793-2.84 4.96 4.96 0 013.142-1.081 4.96 4.96 0 013.118 1.149 5.12 5.12 0 011.733 2.878 5.2 5.2 0 01-.41 3.35 5.06 5.06 0 01-2.372 2.358m11.244-.65c-.33 0-.654-.1-.928-.287a1.7 1.7 0 01-.615-.763 1.73 1.73 0 01.362-1.852 1.64 1.64 0 011.82-.368c.305.128.565.346.749.625a1.72 1.72 0 01-.208 2.147 1.66 1.66 0 01-1.18.497"/>'
  },
  "opportunity-spotify-playlist": {
    body: '<g fill="currentColor"><path d="M7.236 22.068a.6.6 0 01-.596-.545 5 5 0 01-.016-.42c0-6.516 5.3-11.816 11.816-11.816a.6.6 0 110 1.2c-5.852 0-10.616 4.76-10.616 10.617q-.002.154.008.308a.6.6 0 01-.54.652h-.056zM18.44 23.79a2.683 2.683 0 01-2.68-2.68 2.685 2.685 0 012.68-2.68 2.685 2.685 0 012.68 2.68 2.685 2.685 0 01-2.68 2.68m0-4.16c-.816 0-1.48.664-1.48 1.48s.664 1.48 1.48 1.48 1.48-.664 1.48-1.48-.664-1.48-1.48-1.48"/><path d="M18.446 27.374a6.276 6.276 0 01-6.268-6.268 6.276 6.276 0 016.268-6.268 6.276 6.276 0 016.268 6.268 6.276 6.276 0 01-6.268 6.268m0-11.332a5.075 5.075 0 00-5.068 5.068 5.07 5.07 0 005.068 5.068 5.07 5.07 0 005.068-5.068 5.07 5.07 0 00-5.068-5.068m7.31 18.12a.6.6 0 01-.268-1.136 13.85 13.85 0 006.604-9.588.6.6 0 01.692-.493.6.6 0 01.492.692 15.05 15.05 0 01-6.928 10.273c-.088.06-.204.132-.316.188a.6.6 0 01-.268.064z"/><path d="M18.447 36.157c-8.296 0-15.049-6.748-15.049-15.048S10.151 6.061 18.447 6.061c7.388 0 13.78 5.504 14.872 12.8a.603.603 0 01-.504.684.603.603 0 01-.684-.504c-1.004-6.716-6.888-11.78-13.684-11.78-7.636 0-13.849 6.212-13.849 13.848s6.213 13.848 13.849 13.848c1.008 0 1.992-.104 2.928-.312a.6.6 0 11.26 1.172c-1.02.228-2.096.34-3.188.34"/><path d="M26.03 34.43a.6.6 0 01-.6-.6V20.434c0-.28.196-.524.472-.584l11.976-2.64c.18-.04.364.004.504.12s.224.284.224.468v12.924a.6.6 0 11-1.2 0V18.546L26.63 20.922v12.912a.6.6 0 01-.6.6z"/><path d="M23.73 37.54c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.6c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m11.979 1.49c-1.6 0-2.9-1.301-2.9-2.901s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.601c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m-9.679-4.331a.6.6 0 01-.12-1.188l11.977-2.436a.6.6 0 01.24 1.176L26.15 25.485a.6.6 0 01-.12.012"/></g>'
  },
  "opportunity-springboard-selection": {
    body: '<g fill="currentColor"><path d="M16.468 32.811a2.461 2.461 0 01-1.74-4.197 2.459 2.459 0 111.74 4.197m0-3.851a1.39 1.39 0 00-.985 2.376 1.39 1.39 0 002.377-.985 1.394 1.394 0 00-1.392-1.391"/><path d="M18.393 30.885a.533.533 0 01-.533-.533v-8.298a.533.533 0 111.066 0v8.298a.533.533 0 01-.533.533m5.717-.45a2.458 2.458 0 110-4.916 2.458 2.458 0 010 4.916m0-3.85a1.392 1.392 0 100 2.783 1.392 1.392 0 000-2.783"/><path d="M26.035 28.51a.534.534 0 01-.534-.534v-8.298a.534.534 0 011.067 0v8.299a.533.533 0 01-.533.533"/><path d="M18.393 22.588a.534.534 0 01-.158-1.043l7.642-2.375a.534.534 0 11.316 1.018l-7.642 2.376a.5.5 0 01-.158.024m0 2.994a.532.532 0 01-.158-1.043l7.642-2.375a.533.533 0 11.316 1.018l-7.642 2.377a.6.6 0 01-.158.023m-6.104-12.049h-1.067a1.96 1.96 0 01-1.955-1.955V6.956A1.96 1.96 0 0111.222 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955m-1.067-7.466a.89.89 0 00-.889.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466h-1.067a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0120.467 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.956 1.955m-1.067-7.466a.89.89 0 00-.89.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.89-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466H29.71a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0129.711 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955M29.71 6.067a.89.89 0 00-.889.889v4.622a.89.89 0 00.889.889h1.067a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89z"/><path d="M19.044 10.334h-5.333a.534.534 0 010-1.067h5.333a.533.533 0 010 1.067"/><path d="M35.044 37H6.956A1.96 1.96 0 015 35.045V11.223a1.96 1.96 0 011.956-1.956H9.8a.533.533 0 010 1.067H6.956a.89.89 0 00-.89.889v23.822a.89.89 0 00.89.889h28.088a.89.89 0 00.89-.89v-23.82a.89.89 0 00-.89-.89H32.2a.534.534 0 010-1.066h2.844A1.96 1.96 0 0137 11.223v23.822A1.96 1.96 0 0135.044 37"/><path d="M28.289 10.334h-5.334a.534.534 0 010-1.067h5.334a.533.533 0 010 1.067m8.178 6.222H5.533a.533.533 0 010-1.067h30.934a.533.533 0 010 1.067"/></g>'
  },
  "opportunity-sync-deal": {
    body: '<g fill="currentColor"><path d="M32.49 10.656H22.138l3.642-3.641a.594.594 0 10-.84-.84l-4.09 4.085-4.087-4.087a.594.594 0 10-.84.84l3.641 3.642H9.51c-2.95 0-5.349 2.4-5.349 5.349V32.15c0 2.95 2.4 5.35 5.35 5.35h22.98c2.95 0 5.35-2.4 5.35-5.35V16.005c0-2.95-2.4-5.35-5.35-5.35m4.161 21.495a4.165 4.165 0 01-4.16 4.16H9.509a4.165 4.165 0 01-4.16-4.16V16.005a4.165 4.165 0 014.16-4.16h22.982a4.165 4.165 0 014.16 4.16z"/><path d="M28.231 14.222H9.212c-.983 0-1.783.813-1.783 1.813v15.987c0 1 .8 1.813 1.783 1.813h19.019c.983 0 1.783-.813 1.783-1.813V16.035c0-1-.8-1.813-1.783-1.813m.594 17.8c0 .344-.266.624-.594.624H9.212c-.328 0-.594-.28-.594-.624V16.035c0-.344.266-.624.594-.624h19.019c.328 0 .594.28.594.624zm4.427-4.823c-1.148 0-2.08.933-2.08 2.08s.933 2.08 2.08 2.08 2.08-.933 2.08-2.08-.933-2.08-2.08-2.08m0 2.971a.892.892 0 11.001-1.784.892.892 0 01-.001 1.785m1.486-7.034h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.774h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.773h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.19"/><path d="M17.788 26.982a.604.604 0 01-.602-.602v-4.32a.601.601 0 01.952-.49l3.026 2.16a.603.603 0 010 .978l-3.026 2.162a.6.6 0 01-.35.113m.602-3.755v1.983l1.389-.99z"/></g>'
  },
  "opportunity-temporary-social-media-share": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="m24.369 20.283-4.474-3.217a.37.37 0 00-.378-.03.36.36 0 00-.2.319v6.433a.357.357 0 00.364.358q.116 0 .214-.069l4.474-3.216a.356.356 0 000-.578m-4.325 2.801V18.06l3.495 2.513z"/><path fill="currentColor" d="M27.853 7.19H14.147c-1.077 0-1.954.864-1.954 1.925v24.77c0 1.061.877 1.925 1.954 1.925h13.706c1.077 0 1.954-.864 1.954-1.925V9.115c0-1.061-.877-1.925-1.954-1.925m-14.934 4.324h16.162v17.914H12.919zm1.228-3.608h13.706a1.22 1.22 0 011.228 1.21v1.682H12.919V9.115c0-.667.551-1.21 1.228-1.21m13.706 27.188H14.147a1.22 1.22 0 01-1.228-1.21v-3.74h16.162v3.74a1.22 1.22 0 01-1.228 1.21"/><path fill="currentColor" d="M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m0-19.209c-3.397 0-6.16 2.723-6.16 6.07s2.763 6.07 6.16 6.07 6.162-2.723 6.162-6.07-2.764-6.07-6.162-6.07m0 11.425c-2.997 0-5.435-2.402-5.435-5.355 0-2.952 2.438-5.354 5.435-5.354s5.436 2.402 5.436 5.354S23.997 25.95 21 25.95"/><path fill="currentColor" fill-rule="evenodd" d="M19.517 17.036a.37.37 0 01.378.03l4.474 3.217a.356.356 0 010 .578l-4.474 3.216a.37.37 0 01-.378.03.36.36 0 01-.2-.319v-6.433a.36.36 0 01.2-.32m-.088 7.24a.55.55 0 01-.304-.488v-6.433c0-.206.117-.395.304-.489a.56.56 0 01.58.046l4.473 3.217m-4.473 4.102 4.473-3.217Zm-.58.046a.56.56 0 00.58-.046m.035-1.147 3.495-2.512-3.495-2.513zm.193-.374 2.974-2.138-2.974-2.139zM14.147 7h13.706C29.037 7 30 7.949 30 9.115v24.77C30 35.05 29.037 36 27.853 36H14.147C12.963 36 12 35.051 12 33.885V9.115C12 7.95 12.963 7 14.147 7m14.74 4.704H13.113v17.534h15.776zm-1.034-3.608H14.147c-.57 0-1.035.457-1.035 1.02v1.492h15.776V9.115a1.03 1.03 0 00-1.035-1.02M14.147 34.904h13.706c.57 0 1.035-.457 1.035-1.02v-3.55H13.112v3.55c0 .563.465 1.02 1.035 1.02m4.857-2.217c0-1.077.897-1.95 1.996-1.95 1.1 0 1.996.873 1.996 1.95 0 1.078-.897 1.951-1.996 1.951s-1.996-.873-1.996-1.95m1.112 0c0 .47.394.856.884.856s.884-.387.884-.856-.394-.855-.884-.855-.884.386-.884.855m-5.47-12.093c0-3.452 2.85-6.26 6.354-6.26s6.355 2.808 6.355 6.26-2.85 6.26-6.355 6.26c-3.504 0-6.354-2.808-6.354-6.26m1.112 0c0 2.848 2.352 5.165 5.242 5.165s5.243-2.317 5.243-5.165S23.89 15.43 21 15.43s-5.242 2.317-5.242 5.164M14.147 7.19h13.706c1.077 0 1.954.864 1.954 1.925v24.77c0 1.061-.877 1.925-1.954 1.925H14.147c-1.077 0-1.954-.864-1.954-1.925V9.115c0-1.061.877-1.925 1.954-1.925m-1.228 4.324v17.914h16.162V11.514zm14.934-3.608H14.147a1.22 1.22 0 00-1.228 1.21v1.682h16.162V9.115a1.22 1.22 0 00-1.228-1.21M14.147 35.094h13.706a1.22 1.22 0 001.228-1.21v-3.74H12.919v3.74c0 .668.551 1.21 1.228 1.21M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m-6.16-13.139c0-3.347 2.763-6.07 6.16-6.07s6.162 2.723 6.162 6.07-2.764 6.07-6.162 6.07c-3.397 0-6.16-2.723-6.16-6.07m.725 0c0 2.953 2.438 5.355 5.435 5.355s5.436-2.402 5.436-5.355c0-2.952-2.439-5.354-5.436-5.354s-5.435 2.402-5.435 5.354" clip-rule="evenodd"/><path fill="currentColor" d="M24.709 20.772c.18-.412-.299-.706-.478-.824-.18-.118-4.603 4.004-4.603 4.004l-.21.324.569-.03c1.415-1.03 4.423-2.973 4.722-3.474"/></g>'
  },
  "smile-meter-0": {
    body: '<path fill="currentColor" d="M12.813 15.89c-.391.352-.977.352-1.329-.038A1.97 1.97 0 0010 15.187c-.742 0-1.25.352-1.523.665-.352.39-.938.39-1.329.039-.39-.352-.39-.938-.039-1.328A3.94 3.94 0 0110 13.313c1.328 0 2.305.664 2.852 1.25.351.39.351.976-.04 1.328M5.625 9.876c0-.312.117-.625.352-.86l-1.211-.39c-.313-.117-.47-.469-.391-.82a.654.654 0 01.82-.39l3.75 1.25c.313.116.47.468.39.82-.116.312-.468.468-.82.39l-.39-.156v.156c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25V9.72l-.43.156c-.351.078-.703-.078-.82-.39-.078-.352.078-.704.39-.82l3.75-1.25a.654.654 0 01.82.39c.08.351-.077.703-.39.82l-1.21.39c.234.196.39.547.39.86M0 10.5C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10 0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10m10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-1": {
    body: '<path fill="currentColor" d="M5.586 16.086c-.469-.156-.742-.703-.547-1.211C5.703 13 7.734 11.75 10 11.75c2.227 0 4.258 1.25 4.922 3.125.195.508-.078 1.055-.547 1.21-.508.196-1.055-.077-1.21-.546-.352-1.016-1.563-1.914-3.165-1.914-1.64 0-2.852.898-3.203 1.914-.156.469-.703.742-1.211.547m2.539-7.461c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-2": {
    body: '<path fill="currentColor" d="M5.625 8.625c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m-1.562 4.688a.95.95 0 01.937.937c0 .547-.43.938-.937.938H7.187c-.546 0-.937-.391-.937-.938 0-.508.39-.937.938-.937zM20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10m-10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-3": {
    body: '<path fill="currentColor" d="M10 14.25c1.445 0 2.46-.664 3.047-1.29a.933.933 0 011.328-.077c.39.351.39.937.04 1.328A5.93 5.93 0 0110 16.125c-2.11 0-3.594-.977-4.453-1.914-.352-.39-.352-.977.039-1.328a.933.933 0 011.328.078C7.5 13.586 8.516 14.25 10 14.25M8.125 8.625c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-4": {
    body: '<path fill="currentColor" d="M13.633 12.57c.742-.195 1.406.47.976 1.094-.937 1.484-2.656 2.461-4.648 2.461-1.953 0-3.672-.977-4.648-2.46-.391-.626.273-1.29 1.015-1.095 1.133.274 2.344.39 3.633.39 1.328 0 2.539-.116 3.672-.39M8.477 9.445s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.625-1.875.39-.508.937-.937 1.562-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118m6.25 0s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.624-1.875.391-.508.938-.937 1.563-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  }
}, qi = 42, Ki = 42, Gi = {
  prefix: ji,
  lastModified: Ui,
  icons: Wi,
  width: qi,
  height: Ki
};
/**
* (c) Iconify
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 2.1.0
*/
const Fo = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), Tt = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), dt = Object.freeze({
  ...Fo,
  ...Tt
}), tn = Object.freeze({
  ...dt,
  body: "",
  hidden: !1
}), _i = Object.freeze({
  width: null,
  height: null
}), Oo = Object.freeze({
  // Dimensions
  ..._i,
  // Transformations
  ...Tt
});
function Qi(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function o(i) {
    for (; i < 0; )
      i += 4;
    return i % 4;
  }
  if (n === "") {
    const i = parseInt(e);
    return isNaN(i) ? 0 : o(i);
  } else if (n !== e) {
    let i = 0;
    switch (n) {
      case "%":
        i = 25;
        break;
      case "deg":
        i = 90;
    }
    if (i) {
      let a = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(a) ? 0 : (a = a / i, a % 1 === 0 ? o(a) : 0);
    }
  }
  return t;
}
const Yi = /[\s,]+/;
function Xi(e, t) {
  t.split(Yi).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
const No = {
  ...Oo,
  preserveAspectRatio: ""
};
function qn(e) {
  const t = {
    ...No
  }, n = (o, i) => e.getAttribute(o) || i;
  return t.width = n("width", null), t.height = n("height", null), t.rotate = Qi(n("rotate", "")), Xi(t, n("flip", "")), t.preserveAspectRatio = n("preserveAspectRatio", n("preserveaspectratio", "")), t;
}
function Zi(e, t) {
  for (const n in No)
    if (e[n] !== t[n])
      return !0;
  return !1;
}
const tt = /^[a-z0-9]+(-[a-z0-9]+)*$/, ft = (e, t, n, o = "") => {
  const i = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (i.length < 2 || i.length > 3)
      return null;
    o = i.shift().slice(1);
  }
  if (i.length > 3 || !i.length)
    return null;
  if (i.length > 1) {
    const s = i.pop(), l = i.pop(), c = {
      // Allow provider without '@': "provider:prefix:name"
      provider: i.length > 0 ? i[0] : o,
      prefix: l,
      name: s
    };
    return t && !Ct(c) ? null : c;
  }
  const a = i[0], r = a.split("-");
  if (r.length > 1) {
    const s = {
      provider: o,
      prefix: r.shift(),
      name: r.join("-")
    };
    return t && !Ct(s) ? null : s;
  }
  if (n && o === "") {
    const s = {
      provider: o,
      prefix: "",
      name: a
    };
    return t && !Ct(s, n) ? null : s;
  }
  return null;
}, Ct = (e, t) => e ? !!((e.provider === "" || e.provider.match(tt)) && (t && e.prefix === "" || e.prefix.match(tt)) && e.name.match(tt)) : !1;
function Ji(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const o = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return o && (n.rotate = o), n;
}
function Kn(e, t) {
  const n = Ji(e, t);
  for (const o in tn)
    o in Tt ? o in e && !(o in n) && (n[o] = Tt[o]) : o in t ? n[o] = t[o] : o in e && (n[o] = e[o]);
  return n;
}
function ea(e, t) {
  const n = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
  function a(r) {
    if (n[r])
      return i[r] = [];
    if (!(r in i)) {
      i[r] = null;
      const s = o[r] && o[r].parent, l = s && a(s);
      l && (i[r] = [s].concat(l));
    }
    return i[r];
  }
  return Object.keys(n).concat(Object.keys(o)).forEach(a), i;
}
function ta(e, t, n) {
  const o = e.icons, i = e.aliases || /* @__PURE__ */ Object.create(null);
  let a = {};
  function r(s) {
    a = Kn(
      o[s] || i[s],
      a
    );
  }
  return r(t), n.forEach(r), Kn(e, a);
}
function Lo(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((i) => {
    t(i, null), n.push(i);
  });
  const o = ea(e);
  for (const i in o) {
    const a = o[i];
    a && (t(i, ta(e, i, a)), n.push(i));
  }
  return n;
}
const na = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Fo
};
function qt(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function Bo(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !qt(e, na))
    return null;
  const n = t.icons;
  for (const i in n) {
    const a = n[i];
    if (!i.match(tt) || typeof a.body != "string" || !qt(
      a,
      tn
    ))
      return null;
  }
  const o = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const i in o) {
    const a = o[i], r = a.parent;
    if (!i.match(tt) || typeof r != "string" || !n[r] && !o[r] || !qt(
      a,
      tn
    ))
      return null;
  }
  return t;
}
const St = /* @__PURE__ */ Object.create(null);
function oa(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function ge(e, t) {
  const n = St[e] || (St[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = oa(e, t));
}
function Sn(e, t) {
  return Bo(t) ? Lo(t, (n, o) => {
    o ? e.icons[n] = o : e.missing.add(n);
  }) : [];
}
function ia(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
function aa(e, t) {
  let n = [];
  return (typeof e == "string" ? [e] : Object.keys(St)).forEach((i) => {
    (typeof i == "string" && typeof t == "string" ? [t] : Object.keys(St[i] || {})).forEach((r) => {
      const s = ge(i, r);
      n = n.concat(
        Object.keys(s.icons).map(
          (l) => (i !== "" ? "@" + i + ":" : "") + r + ":" + l
        )
      );
    });
  }), n;
}
let rt = !1;
function Do(e) {
  return typeof e == "boolean" && (rt = e), rt;
}
function st(e) {
  const t = typeof e == "string" ? ft(e, !0, rt) : e;
  if (t) {
    const n = ge(t.provider, t.prefix), o = t.name;
    return n.icons[o] || (n.missing.has(o) ? null : void 0);
  }
}
function Ro(e, t) {
  const n = ft(e, !0, rt);
  if (!n)
    return !1;
  const o = ge(n.provider, n.prefix);
  return ia(o, n.name, t);
}
function Gn(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), rt && !t && !e.prefix) {
    let i = !1;
    return Bo(e) && (e.prefix = "", Lo(e, (a, r) => {
      r && Ro(a, r) && (i = !0);
    })), i;
  }
  const n = e.prefix;
  if (!Ct({
    provider: t,
    prefix: n,
    name: "a"
  }))
    return !1;
  const o = ge(t, n);
  return !!Sn(o, e);
}
function _n(e) {
  return !!st(e);
}
function ra(e) {
  const t = st(e);
  return t ? {
    ...dt,
    ...t
  } : null;
}
function sa(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((i, a) => i.provider !== a.provider ? i.provider.localeCompare(a.provider) : i.prefix !== a.prefix ? i.prefix.localeCompare(a.prefix) : i.name.localeCompare(a.name));
  let o = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((i) => {
    if (o.name === i.name && o.prefix === i.prefix && o.provider === i.provider)
      return;
    o = i;
    const a = i.provider, r = i.prefix, s = i.name, l = n[a] || (n[a] = /* @__PURE__ */ Object.create(null)), c = l[r] || (l[r] = ge(a, r));
    let d;
    s in c.icons ? d = t.loaded : r === "" || c.missing.has(s) ? d = t.missing : d = t.pending;
    const u = {
      provider: a,
      prefix: r,
      name: s
    };
    d.push(u);
  }), t;
}
function Vo(e, t) {
  e.forEach((n) => {
    const o = n.loaderCallbacks;
    o && (n.loaderCallbacks = o.filter((i) => i.id !== t));
  });
}
function la(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const o = e.provider, i = e.prefix;
    t.forEach((a) => {
      const r = a.icons, s = r.pending.length;
      r.pending = r.pending.filter((l) => {
        if (l.prefix !== i)
          return !0;
        const c = l.name;
        if (e.icons[c])
          r.loaded.push({
            provider: o,
            prefix: i,
            name: c
          });
        else if (e.missing.has(c))
          r.missing.push({
            provider: o,
            prefix: i,
            name: c
          });
        else
          return n = !0, !0;
        return !1;
      }), r.pending.length !== s && (n || Vo([e], a.id), a.callback(
        r.loaded.slice(0),
        r.missing.slice(0),
        r.pending.slice(0),
        a.abort
      ));
    });
  }));
}
let ca = 0;
function ua(e, t, n) {
  const o = ca++, i = Vo.bind(null, n, o);
  if (!t.pending.length)
    return i;
  const a = {
    id: o,
    icons: t,
    callback: e,
    abort: i
  };
  return n.forEach((r) => {
    (r.loaderCallbacks || (r.loaderCallbacks = [])).push(a);
  }), i;
}
const nn = /* @__PURE__ */ Object.create(null);
function Qn(e, t) {
  nn[e] = t;
}
function on(e) {
  return nn[e] || nn[""];
}
function da(e, t = !0, n = !1) {
  const o = [];
  return e.forEach((i) => {
    const a = typeof i == "string" ? ft(i, t, n) : i;
    a && o.push(a);
  }), o;
}
var fa = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function ha(e, t, n, o) {
  const i = e.resources.length, a = e.random ? Math.floor(Math.random() * i) : e.index;
  let r;
  if (e.random) {
    let M = e.resources.slice(0);
    for (r = []; M.length > 1; ) {
      const F = Math.floor(Math.random() * M.length);
      r.push(M[F]), M = M.slice(0, F).concat(M.slice(F + 1));
    }
    r = r.concat(M);
  } else
    r = e.resources.slice(a).concat(e.resources.slice(0, a));
  const s = Date.now();
  let l = "pending", c = 0, d, u = null, m = [], f = [];
  typeof o == "function" && f.push(o);
  function h() {
    u && (clearTimeout(u), u = null);
  }
  function b() {
    l === "pending" && (l = "aborted"), h(), m.forEach((M) => {
      M.status === "pending" && (M.status = "aborted");
    }), m = [];
  }
  function v(M, F) {
    F && (f = []), typeof M == "function" && f.push(M);
  }
  function w() {
    return {
      startTime: s,
      payload: t,
      status: l,
      queriesSent: c,
      queriesPending: m.length,
      subscribe: v,
      abort: b
    };
  }
  function C() {
    l = "failed", f.forEach((M) => {
      M(void 0, d);
    });
  }
  function S() {
    m.forEach((M) => {
      M.status === "pending" && (M.status = "aborted");
    }), m = [];
  }
  function I(M, F, q) {
    const K = F !== "success";
    switch (m = m.filter((Y) => Y !== M), l) {
      case "pending":
        break;
      case "failed":
        if (K || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (F === "abort") {
      d = q, C();
      return;
    }
    if (K) {
      d = q, m.length || (r.length ? N() : C());
      return;
    }
    if (h(), S(), !e.random) {
      const Y = e.resources.indexOf(M.resource);
      Y !== -1 && Y !== e.index && (e.index = Y);
    }
    l = "completed", f.forEach((Y) => {
      Y(q);
    });
  }
  function N() {
    if (l !== "pending")
      return;
    h();
    const M = r.shift();
    if (M === void 0) {
      if (m.length) {
        u = setTimeout(() => {
          h(), l === "pending" && (S(), C());
        }, e.timeout);
        return;
      }
      C();
      return;
    }
    const F = {
      status: "pending",
      resource: M,
      callback: (q, K) => {
        I(F, q, K);
      }
    };
    m.push(F), c++, u = setTimeout(N, e.rotate), n(M, t, F.callback);
  }
  return setTimeout(N), w;
}
function Po(e) {
  const t = {
    ...fa,
    ...e
  };
  let n = [];
  function o() {
    n = n.filter((s) => s().status === "pending");
  }
  function i(s, l, c) {
    const d = ha(
      t,
      s,
      l,
      (u, m) => {
        o(), c && c(u, m);
      }
    );
    return n.push(d), d;
  }
  function a(s) {
    return n.find((l) => s(l)) || null;
  }
  return {
    query: i,
    find: a,
    setIndex: (s) => {
      t.index = s;
    },
    getIndex: () => t.index,
    cleanup: o
  };
}
function An(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const Bt = /* @__PURE__ */ Object.create(null), Xe = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], kt = [];
for (; Xe.length > 0; )
  Xe.length === 1 || Math.random() > 0.5 ? kt.push(Xe.shift()) : kt.push(Xe.pop());
Bt[""] = An({
  resources: ["https://api.iconify.design"].concat(kt)
});
function Yn(e, t) {
  const n = An(t);
  return n === null ? !1 : (Bt[e] = n, !0);
}
function Dt(e) {
  return Bt[e];
}
function ma() {
  return Object.keys(Bt);
}
function Xn() {
}
const Kt = /* @__PURE__ */ Object.create(null);
function pa(e) {
  if (!Kt[e]) {
    const t = Dt(e);
    if (!t)
      return;
    const n = Po(t), o = {
      config: t,
      redundancy: n
    };
    Kt[e] = o;
  }
  return Kt[e];
}
function Ho(e, t, n) {
  let o, i;
  if (typeof e == "string") {
    const a = on(e);
    if (!a)
      return n(void 0, 424), Xn;
    i = a.send;
    const r = pa(e);
    r && (o = r.redundancy);
  } else {
    const a = An(e);
    if (a) {
      o = Po(a);
      const r = e.resources ? e.resources[0] : "", s = on(r);
      s && (i = s.send);
    }
  }
  return !o || !i ? (n(void 0, 424), Xn) : o.query(t, i, n)().abort;
}
const Zn = "iconify2", lt = "iconify", jo = lt + "-count", Jn = lt + "-version", Uo = 36e5, va = 168, wa = 50;
function an(e, t) {
  try {
    return e.getItem(t);
  } catch {
  }
}
function In(e, t, n) {
  try {
    return e.setItem(t, n), !0;
  } catch {
  }
}
function eo(e, t) {
  try {
    e.removeItem(t);
  } catch {
  }
}
function rn(e, t) {
  return In(e, jo, t.toString());
}
function sn(e) {
  return parseInt(an(e, jo)) || 0;
}
const Ae = {
  local: !0,
  session: !0
}, Wo = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let En = !1;
function ba(e) {
  En = e;
}
let pt = typeof window > "u" ? {} : window;
function qo(e) {
  const t = e + "Storage";
  try {
    if (pt && pt[t] && typeof pt[t].length == "number")
      return pt[t];
  } catch {
  }
  Ae[e] = !1;
}
function Ko(e, t) {
  const n = qo(e);
  if (!n)
    return;
  const o = an(n, Jn);
  if (o !== Zn) {
    if (o) {
      const s = sn(n);
      for (let l = 0; l < s; l++)
        eo(n, lt + l.toString());
    }
    In(n, Jn, Zn), rn(n, 0);
    return;
  }
  const i = Math.floor(Date.now() / Uo) - va, a = (s) => {
    const l = lt + s.toString(), c = an(n, l);
    if (typeof c == "string") {
      try {
        const d = JSON.parse(c);
        if (typeof d == "object" && typeof d.cached == "number" && d.cached > i && typeof d.provider == "string" && typeof d.data == "object" && typeof d.data.prefix == "string" && // Valid item: run callback
        t(d, s))
          return !0;
      } catch {
      }
      eo(n, l);
    }
  };
  let r = sn(n);
  for (let s = r - 1; s >= 0; s--)
    a(s) || (s === r - 1 ? (r--, rn(n, r)) : Wo[e].add(s));
}
function Go() {
  if (!En) {
    ba(!0);
    for (const e in Ae)
      Ko(e, (t) => {
        const n = t.data, o = t.provider, i = n.prefix, a = ge(
          o,
          i
        );
        if (!Sn(a, n).length)
          return !1;
        const r = n.lastModified || -1;
        return a.lastModifiedCached = a.lastModifiedCached ? Math.min(a.lastModifiedCached, r) : r, !0;
      });
  }
}
function ga(e, t) {
  const n = e.lastModifiedCached;
  if (
    // Matches or newer
    n && n >= t
  )
    return n === t;
  if (e.lastModifiedCached = t, n)
    for (const o in Ae)
      Ko(o, (i) => {
        const a = i.data;
        return i.provider !== e.provider || a.prefix !== e.prefix || a.lastModified === t;
      });
  return !0;
}
function ya(e, t) {
  En || Go();
  function n(o) {
    let i;
    if (!Ae[o] || !(i = qo(o)))
      return;
    const a = Wo[o];
    let r;
    if (a.size)
      a.delete(r = Array.from(a).shift());
    else if (r = sn(i), r >= wa || !rn(i, r + 1))
      return;
    const s = {
      cached: Math.floor(Date.now() / Uo),
      provider: e.provider,
      data: t
    };
    return In(
      i,
      lt + r.toString(),
      JSON.stringify(s)
    );
  }
  t.lastModified && !ga(e, t.lastModified) || Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}
function to() {
}
function xa(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, la(e);
  }));
}
function Ca(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: o } = e, i = e.iconsToLoad;
    delete e.iconsToLoad;
    let a;
    if (!i || !(a = on(n)))
      return;
    a.prepare(n, o, i).forEach((s) => {
      Ho(n, s, (l) => {
        if (typeof l != "object")
          s.icons.forEach((c) => {
            e.missing.add(c);
          });
        else
          try {
            const c = Sn(
              e,
              l
            );
            if (!c.length)
              return;
            const d = e.pendingIcons;
            d && c.forEach((u) => {
              d.delete(u);
            }), ya(e, l);
          } catch (c) {
            console.error(c);
          }
        xa(e);
      });
    });
  }));
}
const $n = (e, t) => {
  const n = da(e, !0, Do()), o = sa(n);
  if (!o.pending.length) {
    let l = !0;
    return t && setTimeout(() => {
      l && t(
        o.loaded,
        o.missing,
        o.pending,
        to
      );
    }), () => {
      l = !1;
    };
  }
  const i = /* @__PURE__ */ Object.create(null), a = [];
  let r, s;
  return o.pending.forEach((l) => {
    const { provider: c, prefix: d } = l;
    if (d === s && c === r)
      return;
    r = c, s = d, a.push(ge(c, d));
    const u = i[c] || (i[c] = /* @__PURE__ */ Object.create(null));
    u[d] || (u[d] = []);
  }), o.pending.forEach((l) => {
    const { provider: c, prefix: d, name: u } = l, m = ge(c, d), f = m.pendingIcons || (m.pendingIcons = /* @__PURE__ */ new Set());
    f.has(u) || (f.add(u), i[c][d].push(u));
  }), a.forEach((l) => {
    const { provider: c, prefix: d } = l;
    i[c][d].length && Ca(l, i[c][d]);
  }), t ? ua(t, o, a) : to;
}, ka = (e) => new Promise((t, n) => {
  const o = typeof e == "string" ? ft(e, !0) : e;
  if (!o) {
    n(e);
    return;
  }
  $n([o || e], (i) => {
    if (i.length && o) {
      const a = st(o);
      if (a) {
        t({
          ...dt,
          ...a
        });
        return;
      }
    }
    n(e);
  });
});
function Ta(e) {
  try {
    const t = typeof e == "string" ? JSON.parse(e) : e;
    if (typeof t.body == "string")
      return {
        ...t
      };
  } catch {
  }
}
function Sa(e, t) {
  const n = typeof e == "string" ? ft(e, !0, !0) : null;
  if (!n) {
    const a = Ta(e);
    return {
      value: e,
      data: a
    };
  }
  const o = st(n);
  if (o !== void 0 || !n.prefix)
    return {
      value: e,
      name: n,
      data: o
      // could be 'null' -> icon is missing
    };
  const i = $n([n], () => t(e, n, st(n)));
  return {
    value: e,
    name: n,
    loading: i
  };
}
let _o = !1;
try {
  _o = navigator.vendor.indexOf("Apple") === 0;
} catch {
}
function Aa(e, t) {
  switch (t) {
    case "svg":
    case "bg":
    case "mask":
      return t;
  }
  return t !== "style" && (_o || e.indexOf("<a") === -1) ? "svg" : e.indexOf("currentColor") === -1 ? "bg" : "mask";
}
const Ia = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Ea = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function ln(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const o = e.split(Ia);
  if (o === null || !o.length)
    return e;
  const i = [];
  let a = o.shift(), r = Ea.test(a);
  for (; ; ) {
    if (r) {
      const s = parseFloat(a);
      isNaN(s) ? i.push(a) : i.push(Math.ceil(s * t * n) / n);
    } else
      i.push(a);
    if (a = o.shift(), a === void 0)
      return i.join("");
    r = !r;
  }
}
function $a(e, t = "defs") {
  let n = "";
  const o = e.indexOf("<" + t);
  for (; o >= 0; ) {
    const i = e.indexOf(">", o), a = e.indexOf("</" + t);
    if (i === -1 || a === -1)
      break;
    const r = e.indexOf(">", a);
    if (r === -1)
      break;
    n += e.slice(i + 1, a).trim(), e = e.slice(0, o).trim() + e.slice(r + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function za(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function Ma(e, t, n) {
  const o = $a(e);
  return za(o.defs, t + o.content + n);
}
const Fa = (e) => e === "unset" || e === "undefined" || e === "none";
function Qo(e, t) {
  const n = {
    ...dt,
    ...e
  }, o = {
    ...Oo,
    ...t
  }, i = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let a = n.body;
  [n, o].forEach((b) => {
    const v = [], w = b.hFlip, C = b.vFlip;
    let S = b.rotate;
    w ? C ? S += 2 : (v.push(
      "translate(" + (i.width + i.left).toString() + " " + (0 - i.top).toString() + ")"
    ), v.push("scale(-1 1)"), i.top = i.left = 0) : C && (v.push(
      "translate(" + (0 - i.left).toString() + " " + (i.height + i.top).toString() + ")"
    ), v.push("scale(1 -1)"), i.top = i.left = 0);
    let I;
    switch (S < 0 && (S -= Math.floor(S / 4) * 4), S = S % 4, S) {
      case 1:
        I = i.height / 2 + i.top, v.unshift(
          "rotate(90 " + I.toString() + " " + I.toString() + ")"
        );
        break;
      case 2:
        v.unshift(
          "rotate(180 " + (i.width / 2 + i.left).toString() + " " + (i.height / 2 + i.top).toString() + ")"
        );
        break;
      case 3:
        I = i.width / 2 + i.left, v.unshift(
          "rotate(-90 " + I.toString() + " " + I.toString() + ")"
        );
        break;
    }
    S % 2 === 1 && (i.left !== i.top && (I = i.left, i.left = i.top, i.top = I), i.width !== i.height && (I = i.width, i.width = i.height, i.height = I)), v.length && (a = Ma(
      a,
      '<g transform="' + v.join(" ") + '">',
      "</g>"
    ));
  });
  const r = o.width, s = o.height, l = i.width, c = i.height;
  let d, u;
  r === null ? (u = s === null ? "1em" : s === "auto" ? c : s, d = ln(u, l / c)) : (d = r === "auto" ? l : r, u = s === null ? ln(d, c / l) : s === "auto" ? c : s);
  const m = {}, f = (b, v) => {
    Fa(v) || (m[b] = v.toString());
  };
  f("width", d), f("height", u);
  const h = [i.left, i.top, l, c];
  return m.viewBox = h.join(" "), {
    attributes: m,
    viewBox: h,
    body: a
  };
}
function zn(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const o in t)
    n += " " + o + '="' + t[o] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function Oa(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Na(e) {
  return "data:image/svg+xml," + Oa(e);
}
function Yo(e) {
  return 'url("' + Na(e) + '")';
}
const La = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let At = La();
function Ba(e) {
  At = e;
}
function Da() {
  return At;
}
function Ra(e, t) {
  const n = Dt(e);
  if (!n)
    return 0;
  let o;
  if (!n.maxURL)
    o = 0;
  else {
    let i = 0;
    n.resources.forEach((r) => {
      i = Math.max(i, r.length);
    });
    const a = t + ".json?icons=";
    o = n.maxURL - i - n.path.length - a.length;
  }
  return o;
}
function Va(e) {
  return e === 404;
}
const Pa = (e, t, n) => {
  const o = [], i = Ra(e, t), a = "icons";
  let r = {
    type: a,
    provider: e,
    prefix: t,
    icons: []
  }, s = 0;
  return n.forEach((l, c) => {
    s += l.length + 1, s >= i && c > 0 && (o.push(r), r = {
      type: a,
      provider: e,
      prefix: t,
      icons: []
    }, s = l.length), r.icons.push(l);
  }), o.push(r), o;
};
function Ha(e) {
  if (typeof e == "string") {
    const t = Dt(e);
    if (t)
      return t.path;
  }
  return "/";
}
const ja = (e, t, n) => {
  if (!At) {
    n("abort", 424);
    return;
  }
  let o = Ha(t.provider);
  switch (t.type) {
    case "icons": {
      const a = t.prefix, s = t.icons.join(","), l = new URLSearchParams({
        icons: s
      });
      o += a + ".json?" + l.toString();
      break;
    }
    case "custom": {
      const a = t.uri;
      o += a.slice(0, 1) === "/" ? a.slice(1) : a;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let i = 503;
  At(e + o).then((a) => {
    const r = a.status;
    if (r !== 200) {
      setTimeout(() => {
        n(Va(r) ? "abort" : "next", r);
      });
      return;
    }
    return i = 501, a.json();
  }).then((a) => {
    if (typeof a != "object" || a === null) {
      setTimeout(() => {
        a === 404 ? n("abort", a) : n("next", i);
      });
      return;
    }
    setTimeout(() => {
      n("success", a);
    });
  }).catch(() => {
    n("next", i);
  });
}, Ua = {
  prepare: Pa,
  send: ja
};
function no(e, t) {
  switch (e) {
    case "local":
    case "session":
      Ae[e] = t;
      break;
    case "all":
      for (const n in Ae)
        Ae[n] = t;
      break;
  }
}
const Gt = "data-style";
let Xo = "";
function Zo(e) {
  Xo = e;
}
function oo(e, t) {
  let n = Array.from(e.childNodes).find((o) => o.hasAttribute && o.hasAttribute(Gt));
  n || (n = document.createElement("style"), n.setAttribute(Gt, Gt), e.appendChild(n)), n.textContent = ":host{display:inline-block;vertical-align:" + (t ? "-0.125em" : "0") + "}span,svg{display:block}" + Xo;
}
function Jo() {
  Qn("", Ua), Do(!0);
  let e;
  try {
    e = window;
  } catch {
  }
  if (e) {
    if (Go(), e.IconifyPreload !== void 0) {
      const n = e.IconifyPreload, o = "Invalid IconifyPreload syntax.";
      typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((i) => {
        try {
          // Check if item is an object and not null/array
          (typeof i != "object" || i === null || i instanceof Array || // Check for 'icons' and 'prefix'
          typeof i.icons != "object" || typeof i.prefix != "string" || // Add icon set
          !Gn(i)) && console.error(o);
        } catch {
          console.error(o);
        }
      });
    }
    if (e.IconifyProviders !== void 0) {
      const n = e.IconifyProviders;
      if (typeof n == "object" && n !== null)
        for (const o in n) {
          const i = "IconifyProviders[" + o + "] is invalid.";
          try {
            const a = n[o];
            if (typeof a != "object" || !a || a.resources === void 0)
              continue;
            Yn(o, a) || console.error(i);
          } catch {
            console.error(i);
          }
        }
    }
  }
  return {
    enableCache: (n) => no(n, !0),
    disableCache: (n) => no(n, !1),
    iconLoaded: _n,
    iconExists: _n,
    // deprecated, kept to avoid breaking changes
    getIcon: ra,
    listIcons: aa,
    addIcon: Ro,
    addCollection: Gn,
    calculateSize: ln,
    buildIcon: Qo,
    iconToHTML: zn,
    svgToURL: Yo,
    loadIcons: $n,
    loadIcon: ka,
    addAPIProvider: Yn,
    appendCustomStyle: Zo,
    _api: {
      getAPIConfig: Dt,
      setAPIModule: Qn,
      sendAPIQuery: Ho,
      setFetch: Ba,
      getFetch: Da,
      listAPIProviders: ma
    }
  };
}
const cn = {
  "background-color": "currentColor"
}, ei = {
  "background-color": "transparent"
}, io = {
  image: "var(--svg)",
  repeat: "no-repeat",
  size: "100% 100%"
}, ao = {
  "-webkit-mask": cn,
  mask: cn,
  background: ei
};
for (const e in ao) {
  const t = ao[e];
  for (const n in io)
    t[e + "-" + n] = io[n];
}
function ro(e) {
  return e ? e + (e.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
}
function Wa(e, t, n) {
  const o = document.createElement("span");
  let i = e.body;
  i.indexOf("<a") !== -1 && (i += "<!-- " + Date.now() + " -->");
  const a = e.attributes, r = zn(i, {
    ...a,
    width: t.width + "",
    height: t.height + ""
  }), s = Yo(r), l = o.style, c = {
    "--svg": s,
    width: ro(a.width),
    height: ro(a.height),
    ...n ? cn : ei
  };
  for (const d in c)
    l.setProperty(d, c[d]);
  return o;
}
let nt;
function qa() {
  try {
    nt = window.trustedTypes.createPolicy("iconify", {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      createHTML: (e) => e
    });
  } catch {
    nt = null;
  }
}
function Ka(e) {
  return nt === void 0 && qa(), nt ? nt.createHTML(e) : e;
}
function Ga(e) {
  const t = document.createElement("span"), n = e.attributes;
  let o = "";
  n.width || (o = "width: inherit;"), n.height || (o += "height: inherit;"), o && (n.style = o);
  const i = zn(e.body, n);
  return t.innerHTML = Ka(i), t.firstChild;
}
function un(e) {
  return Array.from(e.childNodes).find((t) => {
    const n = t.tagName && t.tagName.toUpperCase();
    return n === "SPAN" || n === "SVG";
  });
}
function so(e, t) {
  const n = t.icon.data, o = t.customisations, i = Qo(n, o);
  o.preserveAspectRatio && (i.attributes.preserveAspectRatio = o.preserveAspectRatio);
  const a = t.renderedMode;
  let r;
  switch (a) {
    case "svg":
      r = Ga(i);
      break;
    default:
      r = Wa(i, {
        ...dt,
        ...n
      }, a === "mask");
  }
  const s = un(e);
  s ? r.tagName === "SPAN" && s.tagName === r.tagName ? s.setAttribute("style", r.getAttribute("style")) : e.replaceChild(r, s) : e.appendChild(r);
}
function lo(e, t, n) {
  const o = n && (n.rendered ? n : n.lastRender);
  return {
    rendered: !1,
    inline: t,
    icon: e,
    lastRender: o
  };
}
function _a(e = "iconify-icon") {
  let t, n;
  try {
    t = window.customElements, n = window.HTMLElement;
  } catch {
    return;
  }
  if (!t || !n)
    return;
  const o = t.get(e);
  if (o)
    return o;
  const i = [
    // Icon
    "icon",
    // Mode
    "mode",
    "inline",
    "noobserver",
    // Customisations
    "width",
    "height",
    "rotate",
    "flip"
  ], a = class extends n {
    /**
     * Constructor
     */
    constructor() {
      super();
      // Root
      we(this, "_shadowRoot");
      // Initialised
      we(this, "_initialised", !1);
      // Icon state
      we(this, "_state");
      // Attributes check queued
      we(this, "_checkQueued", !1);
      // Connected
      we(this, "_connected", !1);
      // Observer
      we(this, "_observer", null);
      we(this, "_visible", !0);
      const l = this._shadowRoot = this.attachShadow({
        mode: "open"
      }), c = this.hasAttribute("inline");
      oo(l, c), this._state = lo({
        value: ""
      }, c), this._queueCheck();
    }
    /**
     * Connected to DOM
     */
    connectedCallback() {
      this._connected = !0, this.startObserver();
    }
    /**
     * Disconnected from DOM
     */
    disconnectedCallback() {
      this._connected = !1, this.stopObserver();
    }
    /**
     * Observed attributes
     */
    static get observedAttributes() {
      return i.slice(0);
    }
    /**
     * Observed properties that are different from attributes
     *
     * Experimental! Need to test with various frameworks that support it
     */
    /*
    static get properties() {
        return {
            inline: {
                type: Boolean,
                reflect: true,
            },
            // Not listing other attributes because they are strings or combination
            // of string and another type. Cannot have multiple types
        };
    }
    */
    /**
     * Attribute has changed
     */
    attributeChangedCallback(l) {
      switch (l) {
        case "inline": {
          const c = this.hasAttribute("inline"), d = this._state;
          c !== d.inline && (d.inline = c, oo(this._shadowRoot, c));
          break;
        }
        case "noobserver": {
          this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
          break;
        }
        default:
          this._queueCheck();
      }
    }
    /**
     * Get/set icon
     */
    get icon() {
      const l = this.getAttribute("icon");
      if (l && l.slice(0, 1) === "{")
        try {
          return JSON.parse(l);
        } catch {
        }
      return l;
    }
    set icon(l) {
      typeof l == "object" && (l = JSON.stringify(l)), this.setAttribute("icon", l);
    }
    /**
     * Get/set inline
     */
    get inline() {
      return this.hasAttribute("inline");
    }
    set inline(l) {
      l ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
    }
    /**
     * Get/set observer
     */
    get observer() {
      return this.hasAttribute("observer");
    }
    set observer(l) {
      l ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
    }
    /**
     * Restart animation
     */
    restartAnimation() {
      const l = this._state;
      if (l.rendered) {
        const c = this._shadowRoot;
        if (l.renderedMode === "svg")
          try {
            c.lastChild.setCurrentTime(0);
            return;
          } catch {
          }
        so(c, l);
      }
    }
    /**
     * Get status
     */
    get status() {
      const l = this._state;
      return l.rendered ? "rendered" : l.icon.data === null ? "failed" : "loading";
    }
    /**
     * Queue attributes re-check
     */
    _queueCheck() {
      this._checkQueued || (this._checkQueued = !0, setTimeout(() => {
        this._check();
      }));
    }
    /**
     * Check for changes
     */
    _check() {
      if (!this._checkQueued)
        return;
      this._checkQueued = !1;
      const l = this._state, c = this.getAttribute("icon");
      if (c !== l.icon.value) {
        this._iconChanged(c);
        return;
      }
      if (!l.rendered || !this._visible)
        return;
      const d = this.getAttribute("mode"), u = qn(this);
      (l.attrMode !== d || Zi(l.customisations, u) || !un(this._shadowRoot)) && this._renderIcon(l.icon, u, d);
    }
    /**
     * Icon value has changed
     */
    _iconChanged(l) {
      const c = Sa(l, (d, u, m) => {
        const f = this._state;
        if (f.rendered || this.getAttribute("icon") !== d)
          return;
        const h = {
          value: d,
          name: u,
          data: m
        };
        h.data ? this._gotIconData(h) : f.icon = h;
      });
      c.data ? this._gotIconData(c) : this._state = lo(c, this._state.inline, this._state);
    }
    /**
     * Force render icon on state change
     */
    _forceRender() {
      if (!this._visible) {
        const l = un(this._shadowRoot);
        l && this._shadowRoot.removeChild(l);
        return;
      }
      this._queueCheck();
    }
    /**
     * Got new icon data, icon is ready to (re)render
     */
    _gotIconData(l) {
      this._checkQueued = !1, this._renderIcon(l, qn(this), this.getAttribute("mode"));
    }
    /**
     * Re-render based on icon data
     */
    _renderIcon(l, c, d) {
      const u = Aa(l.data.body, d), m = this._state.inline;
      so(this._shadowRoot, this._state = {
        rendered: !0,
        icon: l,
        inline: m,
        customisations: c,
        attrMode: d,
        renderedMode: u
      });
    }
    /**
     * Start observer
     */
    startObserver() {
      if (!this._observer && !this.hasAttribute("noobserver"))
        try {
          this._observer = new IntersectionObserver((l) => {
            const c = l.some((d) => d.isIntersecting);
            c !== this._visible && (this._visible = c, this._forceRender());
          }), this._observer.observe(this);
        } catch {
          if (this._observer) {
            try {
              this._observer.disconnect();
            } catch {
            }
            this._observer = null;
          }
        }
    }
    /**
     * Stop observer
     */
    stopObserver() {
      this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
    }
  };
  i.forEach((s) => {
    s in a.prototype || Object.defineProperty(a.prototype, s, {
      get: function() {
        return this.getAttribute(s);
      },
      set: function(l) {
        l !== null ? this.setAttribute(s, l) : this.removeAttribute(s);
      }
    });
  });
  const r = Jo();
  for (const s in r)
    a[s] = a.prototype[s] = r[s];
  return t.define(e, a), a;
}
const ti = _a() || Jo(), {
  enableCache: Qa,
  disableCache: Ya,
  iconLoaded: Xa,
  iconExists: Za,
  // deprecated, kept to avoid breaking changes
  getIcon: Ja,
  listIcons: er,
  addIcon: tr,
  addCollection: ni,
  calculateSize: nr,
  buildIcon: or,
  iconToHTML: ir,
  svgToURL: ar,
  loadIcons: rr,
  loadIcon: sr,
  addAPIProvider: lr,
  _api: cr
} = ti, r1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconifyIconComponent: ti,
  _api: cr,
  addAPIProvider: lr,
  addCollection: ni,
  addIcon: tr,
  appendCustomStyle: Zo,
  buildIcon: or,
  calculateSize: nr,
  disableCache: Ya,
  enableCache: Qa,
  getIcon: Ja,
  iconExists: Za,
  iconLoaded: Xa,
  iconToHTML: ir,
  listIcons: er,
  loadIcon: sr,
  loadIcons: rr,
  svgToURL: ar
}, Symbol.toStringTag, { value: "Module" }));
function ur(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var oi = {}, ii = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(o, i) {
    return {
      handler: o,
      config: i
    };
  }
  t.withOptions = function(o, i = () => ({})) {
    const a = function(r) {
      return {
        __options: r,
        handler: o(r),
        config: i(r)
      };
    };
    return a.__isOptionsFunction = !0, a.__pluginFunction = o, a.__configFunction = i, a;
  };
  const n = t;
})(ii);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ n(ii);
  function n(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  const o = t.default;
})(oi);
let _t = oi;
var dr = (_t.__esModule ? _t : { default: _t }).default;
const fr = /* @__PURE__ */ ur(dr), ee = {
  white: "#FFFFFF",
  lin: "#F7F6F0",
  charcoal: "#2B2B2B",
  black: "#131313"
}, ne = {
  700: "#BA5225",
  600: "#CD4D16",
  500: "#EB512F",
  // Corale
  450: "#F9885E",
  400: "#F5B1A2",
  300: "#FCE2DD",
  200: "#FDEFEC",
  100: "#FEF7F5"
}, Z = {
  750: "#1D1D1D",
  700: "#404040",
  600: "#525252",
  500: "#737373",
  400: "#A3A3A3",
  300: "#D4D4D4",
  200: "#E5E5E5",
  150: "#EEEEEE",
  100: "#F5F5F5"
}, je = {
  500: "#1C6BB8",
  // Lapis-lazuli
  450: "#528BDD",
  300: "#71B9FF",
  100: "#EAEFF8"
}, vt = {
  700: "#247A5E",
  200: "#EBF8F3"
}, wt = {
  600: "#C83844",
  500: "#EB4452",
  200: "#F8EFF0"
}, bt = {
  800: "#95672B",
  500: "#FBBA66",
  200: "#FFF8F0"
}, de = {
  500: "#9C3BC9",
  400: "#BF8FE4",
  300: "#D3ADEF",
  100: "#F0DBFF",
  50: "#F8F1FC"
}, oe = {
  "orange-600-25": "#CD4D1640",
  "neutral-800-15": "#17171726",
  "neutral-800-25": "#17171740",
  "lin-25": "#F7F6F040",
  "lavender-300-25": "#D3ADEF40",
  transparent: "#00000000"
}, Qt = {
  DEFAULT: je[450],
  focus: je[450],
  "focus-inverse": je[300],
  selected: ee.charcoal,
  "selected-inverse": ee.white
}, dn = [
  "Circular",
  '"system-ui"',
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  '"Noto Sans"',
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"'
], hr = ["neue-haas-display", ...dn], gt = {
  background: {
    default: Z[150],
    surface: ee.white,
    "surface-hover": Z[100],
    "surface-neutral": Z[100],
    fill: ee.lin,
    "fill-accent": de[300],
    "fill-accent-discrete": de[100],
    "fill-accent-discrete2": de[50],
    "fill-accent-hover": de[400],
    "fill-accent-disabled": oe["lavender-300-25"],
    "fill-alt": ee.charcoal,
    "fill-alt-hover": Z[750],
    "fill-brand": ne[100],
    "fill-hover": Z[150],
    "fill-hover-primary": ne[200],
    "fill-alt-disabled": oe["neutral-800-15"],
    "fill-primary": ne[600],
    "fill-primary-disabled": oe["orange-600-25"],
    "fill-primary-hover": ne[700],
    "fill-tip": je[100],
    "fill-error": wt[200],
    "fill-success": vt[200],
    "fill-caution": bt[200],
    "fill-discrete": Z[300],
    "fill-discrete2": Z[200],
    "fill-discrete3": Z[150],
    "fill-neutral": Z[500],
    "fill-neutral-hover": Z[700],
    "fill-neutral-alt-hover": Z[400],
    "fill-primary-discrete": ne[300],
    "fill-primary-discrete2": ne[200],
    "fill-primary-discrete1": ne[100],
    transparent: oe.transparent
  },
  text: {
    // adding this to make sure there's always a way to access the default color
    "default-color": ee.charcoal,
    accent: de[500],
    "accent-disabled": oe["lavender-300-25"],
    inverse: ee.lin,
    "inverse-accent": de[300],
    "inverse-disabled": ee.lin,
    abovePrimary: ee.lin,
    "abovePrimary-disabled": oe["lin-25"],
    primary: ne[600],
    "primary-disabled": oe["orange-600-25"],
    "primary-discrete": ne[400],
    discrete: Z[600],
    discrete2: Z[500],
    discrete3: Z[400],
    disabled: oe["neutral-800-25"],
    success: vt[700],
    error: wt[600],
    caution: bt[800],
    link: ne[600],
    "link-inverse": ne[450]
  },
  border: {
    default: ee.charcoal,
    // adding this to make sure there's always a way to access the default color
    "default-color": ee.charcoal,
    inverse: ee.lin,
    accent: de[500],
    "accent-disabled": oe["lavender-300-25"],
    "inverse-accent": de[300],
    primary: ne[600],
    "primary-disabled": oe["orange-600-25"],
    error: wt[500],
    success: vt[700],
    tip: je[500],
    caution: bt[500],
    discrete: Z[500],
    discrete2: Z[400],
    discrete3: Z[300],
    disabled: oe["neutral-800-25"],
    brand: ne[400],
    transparent: oe.transparent
  },
  icon: {
    icon: ee.charcoal,
    // default
    "icon-accent": de[500],
    "icon-accent-disabled": oe["lavender-300-25"],
    "icon-inverse-accent": de[300],
    "icon-inverse": ee.lin,
    "icon-primary": ne[600],
    "icon-brand": ne[500],
    "icon-abovePrimary": ee.lin,
    "icon-abovePrimary-disabled": ee.lin,
    "icon-primary-disabled": oe["orange-600-25"],
    "icon-discrete": Z[600],
    "icon-discrete2": Z[500],
    "icon-discrete3": Z[400],
    "icon-disabled": oe["neutral-800-25"],
    "icon-success": vt[700],
    "icon-error": wt[600],
    "icon-tip": je[500],
    "icon-caution": bt[500]
  }
}, mr = {
  screens: {
    sm: "320px",
    md: "768px",
    lg: "1024px"
  },
  fontFamily: {
    DEFAULT: dn,
    sans: dn,
    title: hr
  },
  fontSize: {
    DEFAULT: "1rem",
    // 16px
    "2xs": "0.75rem",
    // 12px
    xs: "0.8125rem",
    // 13px
    sm: "0.875rem",
    // 14px
    base: "1rem",
    // 16px
    lg: "1.125rem",
    // 18px
    xl: "1.25rem",
    // 20px
    "2xl": "1.5rem",
    // 24px
    "3xl": "1.75rem",
    // 28px
    "4xl": "2.25rem",
    // 36px
    "5xl": "3rem",
    // 48px
    "6xl": "3.75rem"
    // 60px
  },
  lineHeight: {
    DEFAULT: "1.5rem",
    // 24px
    sm: "1.25rem",
    // 20px
    "3xl": "2rem",
    // 32px
    "4xl": "3rem",
    // 40px
    "5xl": "3.5rem",
    // 64px
    "6xl": "4.5rem"
    // 72px
  },
  fontWeight: {
    DEFAULT: "450",
    normal: "450",
    medium: "500",
    bold: "700",
    black: "900"
  },
  spacing: {
    zero: "0px",
    "4xs": "1px",
    "3xs": "2px",
    "2xs": "4px",
    xs: "6px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "32px",
    "4xl": "40px",
    "5xl": "48px",
    "6xl": "64px",
    "7xl": "80px",
    "8xl": "120px",
    "9xl": "150px",
    "10xl": "256px"
  },
  borderRadius: {
    DEFAULT: "4px",
    none: "0",
    xs: "2px",
    sm: "4px",
    md: "6px",
    lg: "8px",
    xl: "12px",
    "2xl": "16px",
    "3xl": "24px",
    "4xl": "40px",
    full: "9999px"
  },
  boxShadow: {
    DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    base: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
    "md-reverse": "0 -4px 6px -1px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    reverse: "0 -10px 15px -3 rgb(0 0 0 / 0.05)"
  },
  color: {
    transparent: "transparent",
    black: ee.black,
    white: ee.white
  },
  borderColor: {
    ...gt.border
  },
  outlineColor: () => Qt,
  ringColor: () => Qt,
  ringOffsetColor: () => Qt,
  backgroundColor: {
    ...gt.background
  },
  textColor: {
    ...gt.text,
    ...gt.icon
  },
  transitionTimingFunction: {
    "in-out": "cubic-bezier(0.4, 0, 0.2, 1)",
    "slow-down": "cubic-bezier(0, 0.35, 0, 1)",
    smooth: "cubic-bezier(0.35, 0.1, 0, 1)"
  }
}, pr = {
  theme: {
    ...mr
  }
}, s1 = fr(
  function({ addBase: e, addComponents: t, theme: n }) {
    const o = {
      fontSize: n("fontSize.6xl"),
      fontFamily: n("fontFamily.title"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.6xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.5xl"),
        lineHeight: n("lineHeight.5xl")
      }
    }, i = {
      fontSize: n("fontSize.5xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.5xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.4xl"),
        lineHeight: n("lineHeight.4xl")
      }
    }, a = {
      fontSize: n("fontSize.4xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      lineHeight: n("lineHeight.4xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.3xl"),
        lineHeight: n("lineHeight.3xl")
      }
    }, r = {
      fontSize: n("fontSize.3xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.3xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.2xl"),
        lineHeight: n("lineHeight.2xl")
      }
    }, s = {
      fontSize: n("fontSize.2xl"),
      lineHeight: n("lineHeight.3xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.xl"),
        lineHeight: n("lineHeight.xl")
      }
    }, l = {
      fontSize: n("fontSize.xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.DEFAULT"),
      fontFamily: n("fontFamily.title")
    };
    t({
      ".text-h1": o,
      ".text-h2": i,
      ".text-h3": a,
      ".text-h4": r,
      ".text-h5": s,
      ".text-h6": l,
      ".text-body": {
        fontSize: n("fontSize.DEFAULT"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-lg": {
        fontSize: n("fontSize.lg"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-sm": {
        fontSize: n("fontSize.sm"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-body-xs": {
        fontSize: n("fontSize.xs"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-form-error": {
        color: n("textColor.error"),
        fontSize: n("fontSize.sm"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-heading-uppercase": {
        fontSize: n("fontSize.2xs"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm"),
        textTransform: "uppercase"
      }
    });
  },
  {
    theme: {
      ...pr.theme
    }
  }
), vr = ["icon", "aria-label"], wr = {}, W = /* @__PURE__ */ V({
  ...wr,
  __name: "UIIcon",
  props: {
    name: {},
    size: { default: "base" }
  },
  setup(e) {
    let t;
    ((i) => {
      i.sm = "16", i.base = "20", i.lg = "24", i.xl = "32", i["2xl"] = "40";
    })(t || (t = {}));
    const n = e, o = _({
      height: `${t[n.size]}px`,
      width: `${t[n.size]}px`,
      style: {
        height: `${t[n.size]}px`,
        width: `${t[n.size]}px`
      },
      class: "tw-inline-block",
      role: "img",
      "data-allow-mismatch": !0
    });
    return (i, a) => (p(), k("iconify-icon", pe({ icon: i.name }, o.value, { "aria-label": i.name }), null, 16, vr));
  }
}), br = ["disabled", "checked"], Mn = /* @__PURE__ */ V({
  __name: "BaseChip",
  props: /* @__PURE__ */ ie({
    color: { default: "default" },
    component: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = he(e, "modelValue"), i = x(() => ({
      "tw-flex tw-w-fit tw-items-center tw-gap-2xs tw-rounded-full tw-transition-all": !0
    })), a = x(() => ({
      "tw-cursor-not-allowed": e.disabled,
      "tw-bg-fill-discrete3": e.color === "default",
      "hover:tw-bg-fill-discrete2": e.color === "default" && !e.disabled,
      "tw-bg-fill-alt": e.color === "alt",
      "tw-bg-fill-success": e.color === "success",
      "tw-bg-fill-caution": e.color === "warning",
      "tw-bg-fill-error": e.color === "error",
      "tw-bg-surface": e.color === "dashed" || e.color === "white",
      "hover:tw-bg-surface-hover": (e.color === "dashed" || e.color === "white") && !e.disabled,
      "tw-bg-fill focus-visible:tw-bg-fill-discrete hover:tw-bg-fill-hover": e.color === "selected" && !e.disabled,
      "tw-bg-fill-discrete": e.color === "selected" && e.disabled
    })), r = x(() => ({
      "tw-border-dashed tw-border tw-border-discrete3": e.color === "dashed",
      "tw-border tw-border-1 tw-border-discrete3": e.color === "white",
      "tw-border-transparent tw-border": ![
        "dashed",
        "selected",
        "white"
      ].includes(e.color),
      "tw-border tw-border-2": e.color === "selected",
      "focus-visible:tw-outline": !e.disabled && e.component !== "input",
      "focus-within:tw-outline": !e.disabled && e.component === "input"
    })), s = x(() => ({
      "tw-px-sm tw-py-xs": e.size === "sm",
      "tw-px-md tw-py-sm": e.size === "base"
    })), l = x(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-success": e.color === "success",
      "tw-text-caution": e.color === "warning",
      "tw-text-error": e.color === "error",
      // size
      "tw-text-body-xs": e.size === "sm",
      "tw-text-body-sm": e.size === "base"
    })), c = x(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-icon-success": e.color === "success",
      "tw-text-icon-caution": e.color === "warning",
      "tw-text-icon-error": e.color === "error"
    }));
    return (d, u) => d.component === "input" ? (p(), k("label", {
      key: 0,
      class: z([
        i.value,
        a.value,
        s.value,
        r.value
      ]),
      onClick: u[1] || (u[1] = (m) => n("click")),
      onKeypress: u[2] || (u[2] = at((m) => n("click"), ["space"]))
    }, [
      R("input", {
        type: "checkbox",
        class: "tw-sr-only",
        disabled: d.disabled,
        checked: o.value,
        onClick: u[0] || (u[0] = $e(() => {
        }, ["stop"]))
      }, null, 8, br),
      d.iconLeftName ? (p(), $(W, {
        key: 0,
        name: d.iconLeftName,
        size: "sm",
        class: z(c.value)
      }, null, 8, ["name", "class"])) : A("", !0),
      d.text ? (p(), k("span", {
        key: 1,
        "data-test-id": "chip-text",
        class: z(["tw-px-3xs", [l.value]])
      }, G(d.text), 3)) : A("", !0),
      d.iconRightName ? (p(), $(W, {
        key: 2,
        name: d.iconRightName,
        size: "sm",
        class: z(c.value)
      }, null, 8, ["name", "class"])) : A("", !0)
    ], 34)) : (p(), $(Le(d.component), {
      key: 1,
      class: z([
        i.value,
        a.value,
        s.value,
        r.value
      ]),
      disabled: d.disabled ? !0 : void 0,
      onClick: u[3] || (u[3] = (m) => n("click"))
    }, {
      default: j(() => [
        d.iconLeftName ? (p(), $(W, {
          key: 0,
          name: d.iconLeftName,
          size: "sm",
          class: z(c.value)
        }, null, 8, ["name", "class"])) : A("", !0),
        d.text ? (p(), k("span", {
          key: 1,
          "data-test-id": "chip-text",
          class: z(["tw-px-3xs", [l.value]])
        }, G(d.text), 3)) : A("", !0),
        d.iconRightName ? (p(), $(W, {
          key: 2,
          name: d.iconRightName,
          size: "sm",
          class: z(c.value)
        }, null, 8, ["name", "class"])) : A("", !0)
      ]),
      _: 1
    }, 8, ["class", "disabled"]));
  }
}), gr = ["src", "alt"], yr = {}, l1 = /* @__PURE__ */ V({
  ...yr,
  __name: "UIAvatar",
  props: {
    src: {},
    alt: { default: "" },
    size: { default: "lg" },
    variant: { default: "circle" }
  },
  setup(e) {
    const t = e, n = x(() => {
      switch (t.size) {
        case "xl":
          return "tw-size-[72px]";
        case "lg":
          return "tw-size-[56px]";
        case "md":
          return "tw-size-4xl";
        case "sm":
          return "tw-size-2xl";
        default:
          return "tw-size-[56px]";
      }
    });
    return (o, i) => (p(), k("img", {
      src: o.src,
      alt: o.alt,
      class: z(["tw-object-cover", [
        n.value,
        o.variant === "circle" ? "tw-rounded-full" : "tw-rounded-sm"
      ]]),
      loading: "lazy"
    }, null, 10, gr));
  }
});
function Rt(e) {
  const t = Mi("NuxtLink"), n = ut(), o = x(() => t === "NuxtLink" ? "a" : t), i = x(() => Q(e) || n.href ? o.value : "button"), a = x(() => {
    const l = Q(e) ?? n.href ?? "";
    return i.value === "button" ? {
      type: "button"
    } : { href: r(l) ? l : s(l) };
  });
  function r(l) {
    return l && l.startsWith("http");
  }
  function s(l) {
    return l;
  }
  return typeof useLocalePath == "function" && (s = useLocalePath()), {
    componentAttrs: a,
    isExternalLink: r,
    linkComponent: o,
    linkOrButtonComponent: i,
    localePath: s
  };
}
function Vt(e) {
  return So() ? (Ao(e), !0) : !1;
}
const Yt = /* @__PURE__ */ new WeakMap(), xr = (...e) => {
  var t;
  const n = e[0], o = (t = Cn()) == null ? void 0 : t.proxy;
  if (o == null && !Io())
    throw new Error("injectLocal must be called in setup");
  return o && Yt.has(o) && n in Yt.get(o) ? Yt.get(o)[n] : Ni(...e);
}, Fn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Cr = (e) => e != null, kr = Object.prototype.toString, ai = (e) => kr.call(e) === "[object Object]", Te = () => {
}, fn = /* @__PURE__ */ Tr();
function Tr() {
  var e, t;
  return Fn && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function co(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Sr(e) {
  return Cn();
}
function Ie(e) {
  return Array.isArray(e) ? e : [e];
}
function Ar(...e) {
  if (e.length !== 1)
    return kn(...e);
  const t = e[0];
  return typeof t == "function" ? Li(Bi(() => ({ get: t, set: Te }))) : _(t);
}
function Ir(e, t = !0, n) {
  Sr() ? xn(e, n) : t ? e() : Oi(e);
}
function Er(e = !1, t = {}) {
  const {
    truthyValue: n = !0,
    falsyValue: o = !1
  } = t, i = Fi(e), a = _(e);
  function r(s) {
    if (arguments.length)
      return a.value = s, a.value;
    {
      const l = Q(n);
      return a.value = a.value === l ? Q(o) : l, a.value;
    }
  }
  return i ? r : [a, r];
}
function ri(e, t, n) {
  return le(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const On = Fn ? window : void 0;
function si(e) {
  var t;
  const n = Q(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function hn(...e) {
  const t = [], n = () => {
    t.forEach((s) => s()), t.length = 0;
  }, o = (s, l, c, d) => (s.addEventListener(l, c, d), () => s.removeEventListener(l, c, d)), i = x(() => {
    const s = Ie(Q(e[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), a = ri(
    () => {
      var s, l;
      return [
        (l = (s = i.value) == null ? void 0 : s.map((c) => si(c))) != null ? l : [On].filter((c) => c != null),
        Ie(Q(i.value ? e[1] : e[0])),
        Ie(T(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Q(i.value ? e[3] : e[2])
      ];
    },
    ([s, l, c, d]) => {
      if (n(), !(s != null && s.length) || !(l != null && l.length) || !(c != null && c.length))
        return;
      const u = ai(d) ? { ...d } : d;
      t.push(
        ...s.flatMap(
          (m) => l.flatMap(
            (f) => c.map((h) => o(m, f, h, u))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    a(), n();
  };
  return Vt(n), r;
}
function $r() {
  const e = ze(!1), t = Cn();
  return t && xn(() => {
    e.value = !0;
  }, t), e;
}
function zr(e) {
  const t = $r();
  return x(() => (t.value, !!e()));
}
const Mr = Symbol("vueuse-ssr-width");
function Fr() {
  const e = Io() ? xr(Mr, null) : null;
  return typeof e == "number" ? e : void 0;
}
function Or(e, t = {}) {
  const { window: n = On, ssrWidth: o = Fr() } = t, i = zr(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), a = _(typeof o == "number"), r = ze(), s = ze(!1), l = (c) => {
    s.value = c.matches;
  };
  return Di(() => {
    if (a.value) {
      a.value = !i.value;
      const c = Q(e).split(",");
      s.value = c.some((d) => {
        const u = d.includes("not all"), m = d.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), f = d.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let h = !!(m || f);
        return m && h && (h = o >= co(m[1])), f && h && (h = o <= co(f[1])), u ? !h : h;
      });
      return;
    }
    i.value && (r.value = n.matchMedia(Q(e)), s.value = r.value.matches);
  }), hn(r, "change", l, { passive: !0 }), x(() => s.value);
}
function Nr(e = {}) {
  const {
    window: t = On,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: a = !0,
    type: r = "inner"
  } = e, s = _(n), l = _(o), c = () => {
    if (t)
      if (r === "outer")
        s.value = t.outerWidth, l.value = t.outerHeight;
      else if (r === "visual" && t.visualViewport) {
        const { width: u, height: m, scale: f } = t.visualViewport;
        s.value = Math.round(u * f), l.value = Math.round(m * f);
      } else a ? (s.value = t.innerWidth, l.value = t.innerHeight) : (s.value = t.document.documentElement.clientWidth, l.value = t.document.documentElement.clientHeight);
  };
  c(), Ir(c);
  const d = { passive: !0 };
  if (hn("resize", c, d), t && r === "visual" && t.visualViewport && hn(t.visualViewport, "resize", c, d), i) {
    const u = Or("(orientation: portrait)");
    le(u, () => c());
  }
  return { width: s, height: l };
}
var Je = /* @__PURE__ */ ((e) => (e[e.sm = 320] = "sm", e[e.md = 768] = "md", e[e.lg = 1024] = "lg", e))(Je || {});
function Lr() {
  const { width: e } = Nr(), t = x(() => e.value < Je.md), n = x(
    () => e.value >= Je.md && e.value < Je.lg
  ), o = x(() => e.value >= Je.lg);
  return {
    isSm: t,
    isMd: n,
    isLg: o
  };
}
function li(e) {
  const { isSm: t } = Lr(), n = x(() => {
    const i = Q(e);
    return i === "large" && t.value ? "medium" : i === "medium" && t.value ? "small" : i;
  }), o = x(
    () => n.value === "large" ? "lg" : "base"
  );
  return {
    scaledButtonSize: n,
    scaledIconSize: o
  };
}
function U(e, t = {}) {
  return !Br(e, t);
}
function Br(e, t = {}) {
  return Dr(e == null ? void 0 : e(t));
}
function Dr(e) {
  return !e || Rr(e).every(
    (t) => {
      var n, o;
      return t.type === Ri || t.type === Vi && !((n = t.children) != null && n.length) || t.type === be && !((o = t.children) != null && o.length);
    }
  );
}
function Rr(e) {
  return Array.isArray(e) ? e : e !== null ? [e] : [];
}
const Vr = { class: "tw-flex tw-items-center tw-justify-center tw-gap-x-2xs" }, Pr = {
  key: 2,
  class: "tw-whitespace-nowrap"
}, Hr = {}, ot = /* @__PURE__ */ V({
  ...Hr,
  __name: "UIButton",
  props: {
    color: { default: "default" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    size: { default: "medium" },
    text: { default: null },
    to: { default: void 0 },
    variant: { default: "primary" }
  },
  setup(e) {
    const t = e, n = re(), { linkOrButtonComponent: o, componentAttrs: i } = Rt(
      () => t.to
    ), { scaledButtonSize: a, scaledIconSize: r } = li(
      kn(() => t.size)
    ), s = ut(), l = "tw-p-3xs tw-text-sm tw-leading-sm tw-h-2xl", c = "tw-p-sm tw-text-sm tw-leading-sm tw-h-[36px]", d = "tw-p-md tw-text-base tw-leading tw-h-5xl", u = "tw-p-lg tw-text-lg tw-leading tw-h-[56px]", m = "tw-text-abovePrimary tw-bg-fill-primary tw-border-primary disabled:tw-bg-fill-primary-disabled hover:tw-bg-fill-primary-hover hover:tw-shadow-md", f = "tw-bg-fill-alt tw-text-inverse disabled:tw-bg-fill-alt-disabled hover:tw-bg-fill-alt-hover hover:tw-shadow-md", h = "tw-text-default-color tw-bg-fill-accent disabled:tw-bg-fill-accent-disabled hover:tw-bg-fill-accent-hover hover:tw-shadow-md disabled:tw-text-disabled", b = "tw-border tw-border-primary tw-text-primary disabled:tw-border-primary-disabled disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", v = "tw-border tw-text disabled:tw-border-disabled disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", w = "tw-border tw-border-accent tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", C = "tw-border tw-border-inverse-accent tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", S = "tw-text-primary disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", I = "tw-text tw-text-defaut-color disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", N = "tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", M = "tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", F = x(() => [
      t.variant === "primary" && t.color === "default" && m,
      t.variant === "primary" && t.color === "neutral" && f,
      t.variant === "primary" && t.color === "accent" && h,
      t.variant === "outlined" && t.color === "default" && b,
      t.variant === "outlined" && t.color === "neutral" && v,
      t.variant === "outlined" && t.color === "accent" && w,
      t.variant === "outlined" && t.color === "alt-accent" && C,
      t.variant === "transparent" && t.color === "default" && S,
      t.variant === "transparent" && t.color === "neutral" && I,
      t.variant === "transparent" && t.color === "accent" && N,
      t.variant === "transparent" && t.color === "alt-accent" && M
    ].join(" ").replaceAll("false", "")), q = x(() => [
      a.value === "xsmall" && l,
      a.value === "small" && c,
      a.value === "medium" && d,
      a.value === "large" && u
    ].join(" ").replaceAll("false", ""));
    return (K, Y) => (p(), $(Le(T(o)), pe({
      class: ["tw-font-base tw-ease-linear tw-inline-block tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus disabled:tw-pointer-events-none", [F.value, q.value]],
      "data-allow-mismatch": "class"
    }, { ...T(i), ...T(s) }), {
      default: j(() => [
        R("span", Vr, [
          K.iconLeftName ? (p(), $(W, {
            key: 0,
            name: K.iconLeftName,
            size: T(r)
          }, null, 8, ["name", "size"])) : A("", !0),
          T(U)(n.default) ? O(K.$slots, "default", { key: 1 }) : K.text ? (p(), k("span", Pr, G(K.text), 1)) : A("", !0),
          K.iconRightName ? (p(), $(W, {
            key: 3,
            name: K.iconRightName,
            size: T(r)
          }, null, 8, ["name", "size"])) : A("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), jr = { class: "tw-flex tw-flex-grow tw-flex-col tw-gap-3xs" }, Ur = {
  key: 1,
  class: "tw-flex-grow tw-gap-3xs"
}, Wr = {
  key: 2,
  class: "tw-flex tw-h-xl"
}, qr = /* @__PURE__ */ V({
  __name: "UIBanner",
  props: {
    state: { default: "brand" },
    customIconName: { default: "" },
    isDismissible: { type: Boolean, default: !1 },
    isSplitInTwoLines: { type: Boolean, default: !0 },
    link: { default: "" },
    target: { default: "_blank" },
    ctaText: { default: "" },
    ctaHref: { default: "" },
    ctaTarget: { default: "_blank" }
  },
  emits: ["dismiss", "previous", "next", "click", "ctaClick"],
  setup(e, { emit: t }) {
    const n = t, o = re(), i = x(() => U(o.paginationText)), a = x(() => {
      if (e.customIconName) return e.customIconName;
      const u = {
        success: "mdi:check-circle",
        caution: "mdi:information-slab-circle",
        error: "mdi:alert-circle",
        brand: "groover:logo",
        tip: "mdi:lightbulb-on",
        accent: "groover:groover-plus-logo"
      };
      return u[e.state] || u.brand;
    }), r = x(() => {
      const u = {
        success: "tw-text-icon-success",
        caution: "tw-text-icon-caution",
        error: "tw-text-icon-error",
        brand: "tw-text-icon-brand",
        tip: "tw-text-icon-tip",
        accent: "tw-text-icon-accent"
      };
      return u[e.state] || u.brand;
    }), s = x(() => {
      const u = {
        success: "tw-bg-fill-success tw-border-success",
        caution: "tw-bg-fill-caution tw-border-caution",
        error: "tw-bg-fill-error tw-border-error",
        brand: "tw-bg-fill-brand tw-border-brand",
        tip: "tw-bg-fill-tip tw-border-tip",
        accent: "tw-bg-fill-accent-discrete2 tw-border-inverse-accent"
      };
      return u[e.state] || u.brand;
    }), l = x(() => {
      const u = {
        success: "tw-text-success",
        caution: "tw-text-caution",
        error: "tw-text-error",
        brand: "tw-text-primary",
        tip: "tw-text-black",
        accent: "tw-text-accent"
      };
      return "tw-font-bold " + (u[e.state] || u.brand);
    }), c = x(
      () => e.link ? {
        href: e.link,
        target: e.target,
        rel: "noopener"
      } : {}
    ), d = x(() => {
      const u = {
        success: "neutral",
        caution: "neutral",
        error: "neutral",
        brand: "default",
        tip: "neutral",
        accent: "accent"
      }, m = {
        success: "outlined",
        caution: "outlined",
        error: "outlined",
        brand: "outlined",
        tip: "outlined",
        accent: "primary"
      };
      return {
        color: u[e.state] || u.brand,
        variant: m[e.state] || m.brand,
        text: e.ctaText,
        to: e.ctaHref,
        target: e.ctaHref && e.ctaTarget ? e.ctaTarget : void 0
      };
    });
    return (u, m) => (p(), $(Le(u.link ? "a" : "div"), pe(c.value, {
      onClick: m[5] || (m[5] = (f) => n("click", f))
    }), {
      default: j(() => [
        R("div", {
          role: "note",
          class: z(["tw-text-body-sm tw-flex tw-gap-sm tw-rounded-sm tw-border-2 tw-p-md tw-text-sm tw-leading-sm", s.value])
        }, [
          te(W, {
            name: a.value,
            class: z(r.value)
          }, null, 8, ["name", "class"]),
          u.isSplitInTwoLines ? (p(), k("div", {
            key: 0,
            class: z(["tw-flex tw-flex-grow tw-flex-col tw-gap-xs", [
              i.value ? "lg:tw-flex-col" : "lg:tw-flex-row lg:tw-items-center"
            ]])
          }, [
            R("div", jr, [
              T(U)(o.title) ? (p(), k("p", {
                key: 0,
                class: z(l.value)
              }, [
                O(u.$slots, "title")
              ], 2)) : A("", !0),
              R("p", null, [
                O(u.$slots, "content")
              ])
            ]),
            u.ctaText ? (p(), $(ot, pe({ key: 0 }, d.value, {
              class: "tw-w-fit",
              size: "small",
              onClick: m[0] || (m[0] = (f) => n("ctaClick"))
            }), null, 16)) : A("", !0)
          ], 2)) : (p(), k("div", Ur, [
            R("p", null, [
              T(U)(o.title) ? (p(), k(be, { key: 0 }, [
                R("span", {
                  class: z(l.value)
                }, [
                  O(u.$slots, "title")
                ], 2),
                m[6] || (m[6] = Tn(" "))
              ], 64)) : A("", !0),
              O(u.$slots, "content")
            ]),
            u.ctaText ? (p(), $(ot, pe({ key: 0 }, d.value, {
              class: "tw-mt-xs tw-w-fit",
              size: "small",
              onClick: m[1] || (m[1] = (f) => n("ctaClick"))
            }), null, 16)) : A("", !0)
          ])),
          i.value ? (p(), k("div", Wr, [
            R("button", {
              type: "button",
              "aria-label": "previous-arrow",
              class: "tw-text-icon-discrete",
              onClick: m[2] || (m[2] = $e((f) => n("previous"), ["stop"]))
            }, [
              te(W, { name: "mdi:chevron-left" })
            ]),
            O(u.$slots, "paginationText"),
            R("button", {
              type: "button",
              class: "tw-text-icon-discrete",
              "aria-label": "next-arrow",
              onClick: m[3] || (m[3] = $e((f) => n("next"), ["stop"]))
            }, [
              te(W, { name: "mdi:chevron-right" })
            ])
          ])) : A("", !0),
          u.isDismissible ? (p(), k("button", {
            key: 3,
            type: "button",
            class: "tw-font-semibold tw-mb-auto tw-ml-auto tw-h-xl tw-cursor-pointer tw-text-sm tw-text-icon-discrete",
            onClick: m[4] || (m[4] = (f) => n("dismiss"))
          }, [
            te(W, { name: "mdi:close" })
          ])) : A("", !0)
        ], 2)
      ]),
      _: 3
    }, 16));
  }
}), c1 = /* @__PURE__ */ V({
  __name: "UIBannerMulti",
  props: {
    config: {},
    pageSeparatorText: { default: "-" },
    isDismissible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = re(), n = _(0), o = x(() => e.config[n.value]);
    function i() {
      n.value === e.config.length - 1 ? n.value = 0 : n.value++;
    }
    function a() {
      n.value === 0 ? n.value = e.config.length - 1 : n.value--;
    }
    return e.config.length < 1 && console.error("UIBannerMulti requires at least one UIBanner component"), e.config.length !== Object.keys(t).filter((r) => r.startsWith("content")).length && console.error(
      "UIBannerMulti requires the same number of content slots and single UIBanner configs"
    ), (r, s) => (p(), $(qr, pe(o.value, {
      "is-dismissible": r.isDismissible,
      onNext: i,
      onPrevious: a
    }), {
      paginationText: j(() => [
        Tn(G(n.value + 1) + " " + G(r.pageSeparatorText) + " " + G(r.config.length), 1)
      ]),
      title: j(() => [
        O(r.$slots, `title${n.value + 1}`)
      ]),
      content: j(() => [
        O(r.$slots, `content${n.value + 1}`)
      ]),
      _: 3
    }, 16, ["is-dismissible"]));
  }
}), Kr = { class: "tw-flex tw-w-full tw-max-w-[1200px] tw-items-center tw-justify-between tw-px-xl md:tw-px-3xl min-[1200px]:tw-mx-auto" }, Gr = {}, ci = /* @__PURE__ */ V({
  ...Gr,
  __name: "BaseBar",
  props: {
    color: { default: "white" },
    position: { default: "top" },
    sticky: { type: Boolean, default: !1 }
  },
  setup(e) {
    re();
    const t = x(() => ({
      "tw-transition-all tw-left-0 tw-z-50": !0,
      "tw-top-0 tw-sticky": e.sticky && e.position === "top",
      "tw-bottom-0 tw-sticky": e.sticky && e.position === "bottom"
    })), n = x(() => ({
      "tw-border-b tw-border-0.5 tw-border-b-border": e.position === "top",
      "tw-border-t tw-border-0.5 tw-border-t-border": e.position === "bottom",
      "!tw-border-0": e.color === "white",
      "tw-shadow-md": e.color === "white" && e.position === "top",
      "tw-shadow-md-reverse": e.color === "white" && e.position === "bottom",
      "tw-border-discrete2": e.color === "black",
      "tw-border-discrete3": e.color === "lin"
    })), o = x(() => ({
      "tw-bg-surface": e.color === "white",
      "tw-bg-fill": e.color === "lin",
      "tw-bg-fill-alt": e.color === "black"
    }));
    return (i, a) => (p(), k("div", {
      class: z([t.value, n.value, o.value])
    }, [
      R("div", Kr, [
        O(i.$slots, "default")
      ])
    ], 2));
  }
}), _r = { key: 0 }, Qr = {
  key: 1,
  class: "tw-flex-1"
}, Yr = { key: 2 }, Xr = {}, u1 = /* @__PURE__ */ V({
  ...Xr,
  __name: "UIBar",
  props: {
    color: { default: "white" },
    position: { default: "top" },
    sticky: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = re();
    return (n, o) => (p(), $(ci, {
      "data-testid": "base-bar",
      position: n.position,
      sticky: n.sticky,
      color: n.color,
      class: "tw-py-md"
    }, {
      default: j(() => [
        T(U)(t.left) ? (p(), k("div", _r, [
          O(n.$slots, "left")
        ])) : A("", !0),
        T(U)(t.default) ? (p(), k("div", Qr, [
          O(n.$slots, "default")
        ])) : A("", !0),
        T(U)(t.right) ? (p(), k("div", Yr, [
          O(n.$slots, "right")
        ])) : A("", !0)
      ]),
      _: 3
    }, 8, ["position", "sticky", "color"]));
  }
}), Zr = { key: 0 }, Jr = { key: 1 }, es = { key: 2 }, ts = {}, d1 = /* @__PURE__ */ V({
  ...ts,
  __name: "UIBarStickyFooter",
  props: {
    color: { default: "white" },
    leftButtonText: {},
    centerButtonText: {},
    rightButtonText: {}
  },
  emits: ["leftButtonClick", "centerButtonClick", "rightButtonClick"],
  setup(e, { emit: t }) {
    const n = t, o = re();
    return (i, a) => (p(), $(ci, {
      position: "bottom",
      sticky: "",
      color: i.color,
      class: "tw-py-md"
    }, {
      default: j(() => [
        i.leftButtonText || T(U)(o.left) ? (p(), k("div", Zr, [
          i.leftButtonText ? (p(), $(ot, {
            key: 0,
            text: i.leftButtonText,
            size: "medium",
            variant: "outlined",
            onClick: a[0] || (a[0] = (r) => n("leftButtonClick"))
          }, null, 8, ["text"])) : O(i.$slots, "left", { key: 1 })
        ])) : A("", !0),
        i.centerButtonText || T(U)(o.center) ? (p(), k("div", Jr, [
          i.centerButtonText ? (p(), $(ot, {
            key: 0,
            text: i.centerButtonText,
            size: "medium",
            variant: "primary",
            onClick: a[1] || (a[1] = (r) => n("centerButtonClick"))
          }, null, 8, ["text"])) : O(i.$slots, "center", { key: 1 })
        ])) : A("", !0),
        O(i.$slots, "default"),
        i.rightButtonText || T(U)(o.right) ? (p(), k("div", es, [
          i.rightButtonText ? (p(), $(ot, {
            key: 0,
            text: i.rightButtonText,
            size: "medium",
            variant: "primary",
            onClick: a[2] || (a[2] = (r) => n("rightButtonClick"))
          }, null, 8, ["text"])) : O(i.$slots, "right", { key: 1 })
        ])) : A("", !0)
      ]),
      _: 3
    }, 8, ["color"]));
  }
}), ns = {
  key: 1,
  class: "tw-relative"
}, os = { class: "link-text tw-inline-block tw-w-full tw-transform tw-transition-transform tw-duration-[650ms] tw-ease-smooth" }, is = {}, as = /* @__PURE__ */ V({
  ...is,
  __name: "UIButtonLink",
  props: {
    color: { default: "default" },
    theme: { default: "light" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    to: { default: void 0 },
    size: { default: "medium" },
    isExternal: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { linkOrButtonComponent: n, localePath: o, isExternalLink: i } = Rt(
      () => t.to
    ), a = ut(), { scaledButtonSize: r, scaledIconSize: s } = li(
      kn(() => t.size)
    ), l = "tw-text-sm tw-leading-sm", c = "tw-text-base tw-leading", d = "tw-text-base tw-leading", u = x(() => t.theme === "light"), m = x(
      () => u.value ? "tw-text-primary tw-bg-gradient-to-r tw-from-bg-primary tw-to-bg-primary" : "tw-text-link-inverse tw-bg-gradient-to-r tw-from-bg-primary tw-to-bg-primary"
    ), f = x(
      () => u.value ? "tw-bg-gradient-to-r tw-from-bg-fill-alt" : "tw-text-inverse tw-bg-gradient-to-r tw-from-bg-fill"
    ), h = x(
      () => u.value ? "tw-text-accent tw-bg-gradient-to-r tw-from-bg-fill-accent" : "tw-text-inverse-accent tw-bg-gradient-to-r tw-from-bg-fill-accent"
    ), b = "tw-text-primary-disabled tw-pointer-events-none", v = x(
      () => u.value ? "!tw-text-disabled tw-pointer-events-none" : "!tw-text-inverse-disabled tw-pointer-events-none"
    ), w = "tw-text-accent-disabled tw-pointer-events-none", C = x(() => [
      t.color === "default" && m.value,
      t.color === "neutral" && f.value,
      t.color === "accent" && h.value,
      a.disabled !== void 0 && t.color === "default" && b,
      a.disabled !== void 0 && t.color === "neutral" && v.value,
      a.disabled !== void 0 && t.color === "accent" && w
    ].join(" ").replaceAll("false", "")), S = x(() => [
      r.value === "small" && l,
      r.value === "medium" && c,
      r.value === "large" && d
    ].join(" ").replaceAll("false", ""));
    return (I, N) => (p(), $(Le(T(n)), {
      class: z(["link tw-ease-linear tw-flex tw-w-fit tw-items-center tw-gap-x-2xs tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus", [C.value, S.value]]),
      href: I.isExternal || T(i)(I.to) ? I.to : T(o)(I.to),
      external: I.isExternal === !0 ? !0 : void 0,
      "data-allow-mismatch": "class"
    }, {
      default: j(() => [
        I.iconLeftName ? (p(), $(W, {
          key: 0,
          name: I.iconLeftName,
          size: T(s)
        }, null, 8, ["name", "size"])) : A("", !0),
        T(U)(I.$slots.default) ? (p(), k("span", ns, [
          R("span", os, [
            O(I.$slots, "default", {}, void 0, !0)
          ]),
          N[0] || (N[0] = R("span", { class: "link-underline tw-absolute tw-bottom-zero tw-left-zero tw-h-4xs tw-w-full tw-ease-slow-down motion-safe:tw-transform motion-safe:tw-transition-transform motion-safe:tw-duration-[650ms]" }, null, -1))
        ])) : A("", !0),
        I.iconRightName ? (p(), $(W, {
          key: 2,
          name: I.iconRightName,
          size: T(s)
        }, null, 8, ["name", "size"])) : A("", !0)
      ]),
      _: 3
    }, 8, ["class", "href", "external"]));
  }
}), Nn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, f1 = /* @__PURE__ */ Nn(as, [["__scopeId", "data-v-af341000"]]), rs = { key: 0 }, ss = {
  key: 1,
  class: "tw-flex-1"
}, ls = { key: 2 }, cs = {}, h1 = /* @__PURE__ */ V({
  ...cs,
  __name: "UICard",
  props: {
    hasError: { type: Boolean, default: !1 },
    hasHoverState: { type: Boolean, default: !1 },
    is: { default: "article" },
    shouldWrapContent: { type: Boolean, default: !1 },
    shouldWrapContentOnMobile: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = ut(), o = x(
      () => n.disabled !== void 0 && n.disabled !== !1
    ), i = x(() => [
      t.shouldWrapContent ? "tw-flex-col tw-items-start" : t.shouldWrapContentOnMobile ? "tw-flex-col lg:tw-flex-row lg:tw-items-center" : "tw-flex-row tw-items-center"
    ]);
    return (a, r) => (p(), $(Le(a.is), {
      class: z(["tw-flex tw-gap-md tw-rounded-lg tw-border tw-bg-surface tw-px-lg tw-py-md", [
        [
          a.hasError ? "tw-border-error" : o.value ? "tw-border-disabled tw-opacity-25" : "tw-border-discrete3"
        ],
        i.value,
        {
          "tw-transition-colors hover:tw-outline hover:tw-outline-2 hover:tw-outline-selected": a.hasHoverState && !o.value && !a.hasError
        }
      ]])
    }, {
      default: j(() => [
        T(U)(a.$slots.header) ? (p(), k("header", rs, [
          O(a.$slots, "header")
        ])) : A("", !0),
        T(U)(a.$slots.default) ? (p(), k("main", ss, [
          O(a.$slots, "default")
        ])) : A("", !0),
        T(U)(a.$slots.footer) ? (p(), k("footer", ls, [
          O(a.$slots, "footer")
        ])) : A("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), us = {}, m1 = /* @__PURE__ */ V({
  ...us,
  __name: "UIChipButton",
  props: {
    text: {},
    iconLeftName: {},
    iconRightName: {},
    disabled: { type: Boolean },
    to: { default: () => {
    } }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, { linkOrButtonComponent: o, componentAttrs: i } = Rt(() => e.to);
    return (a, r) => (p(), $(Mn, pe({ component: T(o) }, T(i), {
      text: a.text,
      "icon-left-name": a.iconLeftName,
      "icon-right-name": a.iconRightName,
      disabled: a.disabled,
      onClick: r[0] || (r[0] = (s) => n("click"))
    }), null, 16, ["component", "text", "icon-left-name", "icon-right-name", "disabled"]));
  }
}), ds = {}, fs = /* @__PURE__ */ V({
  ...ds,
  __name: "UIChipDropdown",
  props: {
    text: {},
    isOpen: { type: Boolean, default: !1 },
    count: { default: 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    iconLeftName: { default: "" }
  },
  setup(e) {
    const t = x(() => e.count !== void 0 && e.count > 0 ? `${e.text}・${e.count}` : e.text), n = x(() => e.count !== void 0 && e.count > 0 ? "selected" : "white");
    return (o, i) => (p(), $(Mn, {
      component: "button",
      text: t.value,
      "icon-left-name": o.iconLeftName,
      "icon-right-name": o.isOpen ? "mdi:chevron-up" : "mdi:chevron-down",
      disabled: o.disabled,
      size: o.size,
      color: n.value
    }, null, 8, ["text", "icon-left-name", "icon-right-name", "disabled", "size", "color"]));
  }
}), hs = {}, p1 = /* @__PURE__ */ V({
  ...hs,
  __name: "UIChipSelection",
  props: /* @__PURE__ */ ie({
    text: {},
    disabled: { type: Boolean },
    size: {},
    iconLeftName: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = he(e, "modelValue");
    function i() {
      e.disabled || (o.value = !o.value, n("click"));
    }
    return (a, r) => (p(), $(Mn, {
      modelValue: o.value,
      "onUpdate:modelValue": r[0] || (r[0] = (s) => o.value = s),
      component: "input",
      text: a.text,
      "icon-left-name": a.iconLeftName,
      "icon-right-name": o.value ? "mdi:check" : "mdi:plus",
      disabled: a.disabled,
      size: a.size,
      color: o.value ? "alt" : "dashed",
      onClick: i
    }, null, 8, ["modelValue", "text", "icon-left-name", "icon-right-name", "disabled", "size", "color"]));
  }
}), ms = ["top", "right", "bottom", "left"], qe = Math.min, Ee = Math.max, It = Math.round, yt = Math.floor, ye = (e) => ({
  x: e,
  y: e
}), ps = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, vs = {
  start: "end",
  end: "start"
};
function mn(e, t, n) {
  return Ee(e, qe(t, n));
}
function _e(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Fe(e) {
  return e.split("-")[0];
}
function ht(e) {
  return e.split("-")[1];
}
function ui(e) {
  return e === "x" ? "y" : "x";
}
function Ln(e) {
  return e === "y" ? "height" : "width";
}
function Ke(e) {
  return ["top", "bottom"].includes(Fe(e)) ? "y" : "x";
}
function Bn(e) {
  return ui(Ke(e));
}
function ws(e, t, n) {
  n === void 0 && (n = !1);
  const o = ht(e), i = Bn(e), a = Ln(i);
  let r = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (r = Et(r)), [r, Et(r)];
}
function bs(e) {
  const t = Et(e);
  return [pn(e), t, pn(t)];
}
function pn(e) {
  return e.replace(/start|end/g, (t) => vs[t]);
}
function gs(e, t, n) {
  const o = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], r = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : o : t ? o : i;
    case "left":
    case "right":
      return t ? a : r;
    default:
      return [];
  }
}
function ys(e, t, n, o) {
  const i = ht(e);
  let a = gs(Fe(e), n === "start", o);
  return i && (a = a.map((r) => r + "-" + i), t && (a = a.concat(a.map(pn)))), a;
}
function Et(e) {
  return e.replace(/left|right|bottom|top/g, (t) => ps[t]);
}
function xs(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function di(e) {
  return typeof e != "number" ? xs(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function $t(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: n,
    left: t,
    right: t + o,
    bottom: n + i,
    x: t,
    y: n
  };
}
function uo(e, t, n) {
  let {
    reference: o,
    floating: i
  } = e;
  const a = Ke(t), r = Bn(t), s = Ln(r), l = Fe(t), c = a === "y", d = o.x + o.width / 2 - i.width / 2, u = o.y + o.height / 2 - i.height / 2, m = o[s] / 2 - i[s] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: d,
        y: o.y - i.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: o.y + o.height
      };
      break;
    case "right":
      f = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      f = {
        x: o.x - i.width,
        y: u
      };
      break;
    default:
      f = {
        x: o.x,
        y: o.y
      };
  }
  switch (ht(t)) {
    case "start":
      f[r] -= m * (n && c ? -1 : 1);
      break;
    case "end":
      f[r] += m * (n && c ? -1 : 1);
      break;
  }
  return f;
}
const Cs = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: r
  } = n, s = a.filter(Boolean), l = await (r.isRTL == null ? void 0 : r.isRTL(t));
  let c = await r.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: d,
    y: u
  } = uo(c, o, l), m = o, f = {}, h = 0;
  for (let b = 0; b < s.length; b++) {
    const {
      name: v,
      fn: w
    } = s[b], {
      x: C,
      y: S,
      data: I,
      reset: N
    } = await w({
      x: d,
      y: u,
      initialPlacement: o,
      placement: m,
      strategy: i,
      middlewareData: f,
      rects: c,
      platform: r,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = C ?? d, u = S ?? u, f = {
      ...f,
      [v]: {
        ...f[v],
        ...I
      }
    }, N && h <= 50 && (h++, typeof N == "object" && (N.placement && (m = N.placement), N.rects && (c = N.rects === !0 ? await r.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : N.rects), {
      x: d,
      y: u
    } = uo(c, m, l)), b = -1);
  }
  return {
    x: d,
    y: u,
    placement: m,
    strategy: i,
    middlewareData: f
  };
};
async function zt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: i,
    platform: a,
    rects: r,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: m = !1,
    padding: f = 0
  } = _e(t, e), h = di(f), v = s[m ? u === "floating" ? "reference" : "floating" : u], w = $t(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), C = u === "floating" ? {
    x: o,
    y: i,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, S = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), I = await (a.isElement == null ? void 0 : a.isElement(S)) ? await (a.getScale == null ? void 0 : a.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, N = $t(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: S,
    strategy: l
  }) : C);
  return {
    top: (w.top - N.top + h.top) / I.y,
    bottom: (N.bottom - w.bottom + h.bottom) / I.y,
    left: (w.left - N.left + h.left) / I.x,
    right: (N.right - w.right + h.right) / I.x
  };
}
const ks = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: a,
      platform: r,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: d = 0
    } = _e(e, t) || {};
    if (c == null)
      return {};
    const u = di(d), m = {
      x: n,
      y: o
    }, f = Bn(i), h = Ln(f), b = await r.getDimensions(c), v = f === "y", w = v ? "top" : "left", C = v ? "bottom" : "right", S = v ? "clientHeight" : "clientWidth", I = a.reference[h] + a.reference[f] - m[f] - a.floating[h], N = m[f] - a.reference[f], M = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(c));
    let F = M ? M[S] : 0;
    (!F || !await (r.isElement == null ? void 0 : r.isElement(M))) && (F = s.floating[S] || a.floating[h]);
    const q = I / 2 - N / 2, K = F / 2 - b[h] / 2 - 1, Y = qe(u[w], K), se = qe(u[C], K), P = Y, g = F - b[h] - se, y = F / 2 - b[h] / 2 + q, E = mn(P, y, g), B = !l.arrow && ht(i) != null && y !== E && a.reference[h] / 2 - (y < P ? Y : se) - b[h] / 2 < 0, D = B ? y < P ? y - P : y - g : 0;
    return {
      [f]: m[f] + D,
      data: {
        [f]: E,
        centerOffset: y - E - D,
        ...B && {
          alignmentOffset: D
        }
      },
      reset: B
    };
  }
}), Ts = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: i,
        middlewareData: a,
        rects: r,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: m,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: b = !0,
        ...v
      } = _e(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const w = Fe(i), C = Ke(s), S = Fe(s) === s, I = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), N = m || (S || !b ? [Et(s)] : bs(s)), M = h !== "none";
      !m && M && N.push(...ys(s, b, h, I));
      const F = [s, ...N], q = await zt(t, v), K = [];
      let Y = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (d && K.push(q[w]), u) {
        const y = ws(i, r, I);
        K.push(q[y[0]], q[y[1]]);
      }
      if (Y = [...Y, {
        placement: i,
        overflows: K
      }], !K.every((y) => y <= 0)) {
        var se, P;
        const y = (((se = a.flip) == null ? void 0 : se.index) || 0) + 1, E = F[y];
        if (E)
          return {
            data: {
              index: y,
              overflows: Y
            },
            reset: {
              placement: E
            }
          };
        let B = (P = Y.filter((D) => D.overflows[0] <= 0).sort((D, H) => D.overflows[1] - H.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!B)
          switch (f) {
            case "bestFit": {
              var g;
              const D = (g = Y.filter((H) => {
                if (M) {
                  const L = Ke(H.placement);
                  return L === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  L === "y";
                }
                return !0;
              }).map((H) => [H.placement, H.overflows.filter((L) => L > 0).reduce((L, X) => L + X, 0)]).sort((H, L) => H[1] - L[1])[0]) == null ? void 0 : g[0];
              D && (B = D);
              break;
            }
            case "initialPlacement":
              B = s;
              break;
          }
        if (i !== B)
          return {
            reset: {
              placement: B
            }
          };
      }
      return {};
    }
  };
};
function fo(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ho(e) {
  return ms.some((t) => e[t] >= 0);
}
const Ss = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...i
      } = _e(e, t);
      switch (o) {
        case "referenceHidden": {
          const a = await zt(t, {
            ...i,
            elementContext: "reference"
          }), r = fo(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: r,
              referenceHidden: ho(r)
            }
          };
        }
        case "escaped": {
          const a = await zt(t, {
            ...i,
            altBoundary: !0
          }), r = fo(a, n.floating);
          return {
            data: {
              escapedOffsets: r,
              escaped: ho(r)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function As(e, t) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), r = Fe(n), s = ht(n), l = Ke(n) === "y", c = ["left", "top"].includes(r) ? -1 : 1, d = a && l ? -1 : 1, u = _e(t, e);
  let {
    mainAxis: m,
    crossAxis: f,
    alignmentAxis: h
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof h == "number" && (f = s === "end" ? h * -1 : h), l ? {
    x: f * d,
    y: m * c
  } : {
    x: m * c,
    y: f * d
  };
}
const Is = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: i,
        y: a,
        placement: r,
        middlewareData: s
      } = t, l = await As(t, e);
      return r === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: r
        }
      };
    }
  };
}, Es = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: r = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: w,
              y: C
            } = v;
            return {
              x: w,
              y: C
            };
          }
        },
        ...l
      } = _e(e, t), c = {
        x: n,
        y: o
      }, d = await zt(t, l), u = Ke(Fe(i)), m = ui(u);
      let f = c[m], h = c[u];
      if (a) {
        const v = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", C = f + d[v], S = f - d[w];
        f = mn(C, f, S);
      }
      if (r) {
        const v = u === "y" ? "top" : "left", w = u === "y" ? "bottom" : "right", C = h + d[v], S = h - d[w];
        h = mn(C, h, S);
      }
      const b = s.fn({
        ...t,
        [m]: f,
        [u]: h
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - o,
          enabled: {
            [m]: a,
            [u]: r
          }
        }
      };
    }
  };
};
function Pt() {
  return typeof window < "u";
}
function Be(e) {
  return Dn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ae(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function me(e) {
  var t;
  return (t = (Dn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Dn(e) {
  return Pt() ? e instanceof Node || e instanceof ae(e).Node : !1;
}
function ce(e) {
  return Pt() ? e instanceof Element || e instanceof ae(e).Element : !1;
}
function fe(e) {
  return Pt() ? e instanceof HTMLElement || e instanceof ae(e).HTMLElement : !1;
}
function mo(e) {
  return !Pt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ae(e).ShadowRoot;
}
function mt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: i
  } = ue(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(i);
}
function $s(e) {
  return ["table", "td", "th"].includes(Be(e));
}
function Ht(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Rn(e) {
  const t = Vn(), n = ce(e) ? ue(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function zs(e) {
  let t = xe(e);
  for (; fe(t) && !Ge(t); ) {
    if (Rn(t))
      return t;
    if (Ht(t))
      return null;
    t = xe(t);
  }
  return null;
}
function Vn() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ge(e) {
  return ["html", "body", "#document"].includes(Be(e));
}
function ue(e) {
  return ae(e).getComputedStyle(e);
}
function jt(e) {
  return ce(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function xe(e) {
  if (Be(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    mo(e) && e.host || // Fallback.
    me(e)
  );
  return mo(t) ? t.host : t;
}
function fi(e) {
  const t = xe(e);
  return Ge(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : fe(t) && mt(t) ? t : fi(t);
}
function ct(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = fi(e), a = i === ((o = e.ownerDocument) == null ? void 0 : o.body), r = ae(i);
  if (a) {
    const s = vn(r);
    return t.concat(r, r.visualViewport || [], mt(i) ? i : [], s && n ? ct(s) : []);
  }
  return t.concat(i, ct(i, [], n));
}
function vn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function hi(e) {
  const t = ue(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const i = fe(e), a = i ? e.offsetWidth : n, r = i ? e.offsetHeight : o, s = It(n) !== a || It(o) !== r;
  return s && (n = a, o = r), {
    width: n,
    height: o,
    $: s
  };
}
function Pn(e) {
  return ce(e) ? e : e.contextElement;
}
function Ue(e) {
  const t = Pn(e);
  if (!fe(t))
    return ye(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: i,
    $: a
  } = hi(t);
  let r = (a ? It(n.width) : n.width) / o, s = (a ? It(n.height) : n.height) / i;
  return (!r || !Number.isFinite(r)) && (r = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: r,
    y: s
  };
}
const Ms = /* @__PURE__ */ ye(0);
function mi(e) {
  const t = ae(e);
  return !Vn() || !t.visualViewport ? Ms : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Fs(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ae(e) ? !1 : t;
}
function Oe(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = Pn(e);
  let r = ye(1);
  t && (o ? ce(o) && (r = Ue(o)) : r = Ue(e));
  const s = Fs(a, n, o) ? mi(a) : ye(0);
  let l = (i.left + s.x) / r.x, c = (i.top + s.y) / r.y, d = i.width / r.x, u = i.height / r.y;
  if (a) {
    const m = ae(a), f = o && ce(o) ? ae(o) : o;
    let h = m, b = vn(h);
    for (; b && o && f !== h; ) {
      const v = Ue(b), w = b.getBoundingClientRect(), C = ue(b), S = w.left + (b.clientLeft + parseFloat(C.paddingLeft)) * v.x, I = w.top + (b.clientTop + parseFloat(C.paddingTop)) * v.y;
      l *= v.x, c *= v.y, d *= v.x, u *= v.y, l += S, c += I, h = ae(b), b = vn(h);
    }
  }
  return $t({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function Os(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: i
  } = e;
  const a = i === "fixed", r = me(o), s = t ? Ht(t.floating) : !1;
  if (o === r || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = ye(1);
  const d = ye(0), u = fe(o);
  if ((u || !u && !a) && ((Be(o) !== "body" || mt(r)) && (l = jt(o)), fe(o))) {
    const m = Oe(o);
    c = Ue(o), d.x = m.x + o.clientLeft, d.y = m.y + o.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + d.x,
    y: n.y * c.y - l.scrollTop * c.y + d.y
  };
}
function Ns(e) {
  return Array.from(e.getClientRects());
}
function wn(e, t) {
  const n = jt(e).scrollLeft;
  return t ? t.left + n : Oe(me(e)).left + n;
}
function Ls(e) {
  const t = me(e), n = jt(e), o = e.ownerDocument.body, i = Ee(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), a = Ee(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let r = -n.scrollLeft + wn(e);
  const s = -n.scrollTop;
  return ue(o).direction === "rtl" && (r += Ee(t.clientWidth, o.clientWidth) - i), {
    width: i,
    height: a,
    x: r,
    y: s
  };
}
function Bs(e, t) {
  const n = ae(e), o = me(e), i = n.visualViewport;
  let a = o.clientWidth, r = o.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, r = i.height;
    const c = Vn();
    (!c || c && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: r,
    x: s,
    y: l
  };
}
function Ds(e, t) {
  const n = Oe(e, !0, t === "fixed"), o = n.top + e.clientTop, i = n.left + e.clientLeft, a = fe(e) ? Ue(e) : ye(1), r = e.clientWidth * a.x, s = e.clientHeight * a.y, l = i * a.x, c = o * a.y;
  return {
    width: r,
    height: s,
    x: l,
    y: c
  };
}
function po(e, t, n) {
  let o;
  if (t === "viewport")
    o = Bs(e, n);
  else if (t === "document")
    o = Ls(me(e));
  else if (ce(t))
    o = Ds(t, n);
  else {
    const i = mi(e);
    o = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return $t(o);
}
function pi(e, t) {
  const n = xe(e);
  return n === t || !ce(n) || Ge(n) ? !1 : ue(n).position === "fixed" || pi(n, t);
}
function Rs(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = ct(e, [], !1).filter((s) => ce(s) && Be(s) !== "body"), i = null;
  const a = ue(e).position === "fixed";
  let r = a ? xe(e) : e;
  for (; ce(r) && !Ge(r); ) {
    const s = ue(r), l = Rn(r);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || mt(r) && !l && pi(e, r)) ? o = o.filter((d) => d !== r) : i = s, r = xe(r);
  }
  return t.set(e, o), o;
}
function Vs(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = e;
  const r = [...n === "clippingAncestors" ? Ht(t) ? [] : Rs(t, this._c) : [].concat(n), o], s = r[0], l = r.reduce((c, d) => {
    const u = po(t, d, i);
    return c.top = Ee(u.top, c.top), c.right = qe(u.right, c.right), c.bottom = qe(u.bottom, c.bottom), c.left = Ee(u.left, c.left), c;
  }, po(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Ps(e) {
  const {
    width: t,
    height: n
  } = hi(e);
  return {
    width: t,
    height: n
  };
}
function Hs(e, t, n) {
  const o = fe(t), i = me(t), a = n === "fixed", r = Oe(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ye(0);
  if (o || !o && !a)
    if ((Be(t) !== "body" || mt(i)) && (s = jt(t)), o) {
      const f = Oe(t, !0, a, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else i && (l.x = wn(i));
  let c = 0, d = 0;
  if (i && !o && !a) {
    const f = i.getBoundingClientRect();
    d = f.top + s.scrollTop, c = f.left + s.scrollLeft - // RTL <body> scrollbar.
    wn(i, f);
  }
  const u = r.left + s.scrollLeft - l.x - c, m = r.top + s.scrollTop - l.y - d;
  return {
    x: u,
    y: m,
    width: r.width,
    height: r.height
  };
}
function Xt(e) {
  return ue(e).position === "static";
}
function vo(e, t) {
  if (!fe(e) || ue(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return me(e) === n && (n = n.ownerDocument.body), n;
}
function vi(e, t) {
  const n = ae(e);
  if (Ht(e))
    return n;
  if (!fe(e)) {
    let i = xe(e);
    for (; i && !Ge(i); ) {
      if (ce(i) && !Xt(i))
        return i;
      i = xe(i);
    }
    return n;
  }
  let o = vo(e, t);
  for (; o && $s(o) && Xt(o); )
    o = vo(o, t);
  return o && Ge(o) && Xt(o) && !Rn(o) ? n : o || zs(e) || n;
}
const js = async function(e) {
  const t = this.getOffsetParent || vi, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Hs(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Us(e) {
  return ue(e).direction === "rtl";
}
const Ws = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Os,
  getDocumentElement: me,
  getClippingRect: Vs,
  getOffsetParent: vi,
  getElementRects: js,
  getClientRects: Ns,
  getDimensions: Ps,
  getScale: Ue,
  isElement: ce,
  isRTL: Us
};
function qs(e, t) {
  let n = null, o;
  const i = me(e);
  function a() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function r(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const {
      left: c,
      top: d,
      width: u,
      height: m
    } = e.getBoundingClientRect();
    if (s || t(), !u || !m)
      return;
    const f = yt(d), h = yt(i.clientWidth - (c + u)), b = yt(i.clientHeight - (d + m)), v = yt(c), C = {
      rootMargin: -f + "px " + -h + "px " + -b + "px " + -v + "px",
      threshold: Ee(0, qe(1, l)) || 1
    };
    let S = !0;
    function I(N) {
      const M = N[0].intersectionRatio;
      if (M !== l) {
        if (!S)
          return r();
        M ? r(!1, M) : o = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      n = new IntersectionObserver(I, {
        ...C,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(I, C);
    }
    n.observe(e);
  }
  return r(!0), a;
}
function Ks(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = Pn(e), d = i || a ? [...c ? ct(c) : [], ...ct(t)] : [];
  d.forEach((w) => {
    i && w.addEventListener("scroll", n, {
      passive: !0
    }), a && w.addEventListener("resize", n);
  });
  const u = c && s ? qs(c, n) : null;
  let m = -1, f = null;
  r && (f = new ResizeObserver((w) => {
    let [C] = w;
    C && C.target === c && f && (f.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var S;
      (S = f) == null || S.observe(t);
    })), n();
  }), c && !l && f.observe(c), f.observe(t));
  let h, b = l ? Oe(e) : null;
  l && v();
  function v() {
    const w = Oe(e);
    b && (w.x !== b.x || w.y !== b.y || w.width !== b.width || w.height !== b.height) && n(), b = w, h = requestAnimationFrame(v);
  }
  return n(), () => {
    var w;
    d.forEach((C) => {
      i && C.removeEventListener("scroll", n), a && C.removeEventListener("resize", n);
    }), u == null || u(), (w = f) == null || w.disconnect(), f = null, l && cancelAnimationFrame(h);
  };
}
const Gs = Is, _s = Es, Qs = Ts, Ys = Ss, Xs = ks, Zs = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: Ws,
    ...n
  }, a = {
    ...i.platform,
    _c: o
  };
  return Cs(e, t, {
    ...i,
    platform: a
  });
};
function Js(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function bn(e) {
  if (Js(e)) {
    const t = e.$el;
    return Dn(t) && Be(t) === "#comment" ? null : t;
  }
  return e;
}
function Ve(e) {
  return typeof e == "function" ? e() : T(e);
}
function el(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = bn(Ve(e.element));
      return n == null ? {} : Xs({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function wi(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function wo(e, t) {
  const n = wi(e);
  return Math.round(t * n) / n;
}
function tl(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, i = x(() => {
    var F;
    return (F = Ve(n.open)) != null ? F : !0;
  }), a = x(() => Ve(n.middleware)), r = x(() => {
    var F;
    return (F = Ve(n.placement)) != null ? F : "bottom";
  }), s = x(() => {
    var F;
    return (F = Ve(n.strategy)) != null ? F : "absolute";
  }), l = x(() => {
    var F;
    return (F = Ve(n.transform)) != null ? F : !0;
  }), c = x(() => bn(e.value)), d = x(() => bn(t.value)), u = _(0), m = _(0), f = _(s.value), h = _(r.value), b = ze({}), v = _(!1), w = x(() => {
    const F = {
      position: f.value,
      left: "0",
      top: "0"
    };
    if (!d.value)
      return F;
    const q = wo(d.value, u.value), K = wo(d.value, m.value);
    return l.value ? {
      ...F,
      transform: "translate(" + q + "px, " + K + "px)",
      ...wi(d.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: f.value,
      left: q + "px",
      top: K + "px"
    };
  });
  let C;
  function S() {
    if (c.value == null || d.value == null)
      return;
    const F = i.value;
    Zs(c.value, d.value, {
      middleware: a.value,
      placement: r.value,
      strategy: s.value
    }).then((q) => {
      u.value = q.x, m.value = q.y, f.value = q.strategy, h.value = q.placement, b.value = q.middlewareData, v.value = F !== !1;
    });
  }
  function I() {
    typeof C == "function" && (C(), C = void 0);
  }
  function N() {
    if (I(), o === void 0) {
      S();
      return;
    }
    if (c.value != null && d.value != null) {
      C = o(c.value, d.value, S);
      return;
    }
  }
  function M() {
    i.value || (v.value = !1);
  }
  return le([a, r, s, i], S, {
    flush: "sync"
  }), le([c, d], N, {
    flush: "sync"
  }), le(i, M, {
    flush: "sync"
  }), So() && Ao(I), {
    x: De(u),
    y: De(m),
    strategy: De(f),
    placement: De(h),
    middlewareData: De(b),
    isPositioned: De(v),
    floatingStyles: w,
    update: S
  };
}
const bi = Fn ? window : void 0;
function et(e) {
  var t;
  const n = Q(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function Pe(...e) {
  const t = [], n = () => {
    t.forEach((s) => s()), t.length = 0;
  }, o = (s, l, c, d) => (s.addEventListener(l, c, d), () => s.removeEventListener(l, c, d)), i = x(() => {
    const s = Ie(Q(e[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), a = ri(
    () => {
      var s, l;
      return [
        (l = (s = i.value) == null ? void 0 : s.map((c) => et(c))) != null ? l : [bi].filter((c) => c != null),
        Ie(Q(i.value ? e[1] : e[0])),
        Ie(T(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Q(i.value ? e[3] : e[2])
      ];
    },
    ([s, l, c, d]) => {
      if (n(), !(s != null && s.length) || !(l != null && l.length) || !(c != null && c.length))
        return;
      const u = ai(d) ? { ...d } : d;
      t.push(
        ...s.flatMap(
          (m) => l.flatMap(
            (f) => c.map((h) => o(m, f, h, u))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    a(), n();
  };
  return Vt(n), r;
}
let bo = !1;
function go(e, t, n = {}) {
  const { window: o = bi, ignore: i = [], capture: a = !0, detectIframe: r = !1, controls: s = !1 } = n;
  if (!o)
    return s ? { stop: Te, cancel: Te, trigger: Te } : Te;
  if (fn && !bo) {
    bo = !0;
    const v = { passive: !0 };
    Array.from(o.document.body.children).forEach((w) => Pe(w, "click", Te, v)), Pe(o.document.documentElement, "click", Te, v);
  }
  let l = !0;
  const c = (v) => Q(i).some((w) => {
    if (typeof w == "string")
      return Array.from(o.document.querySelectorAll(w)).some((C) => C === v.target || v.composedPath().includes(C));
    {
      const C = et(w);
      return C && (v.target === C || v.composedPath().includes(C));
    }
  });
  function d(v) {
    const w = Q(v);
    return w && w.$.subTree.shapeFlag === 16;
  }
  function u(v, w) {
    const C = Q(v), S = C.$.subTree && C.$.subTree.children;
    return S == null || !Array.isArray(S) ? !1 : S.some((I) => I.el === w.target || w.composedPath().includes(I.el));
  }
  const m = (v) => {
    const w = et(e);
    if (v.target != null && !(!(w instanceof Element) && d(e) && u(e, v)) && !(!w || w === v.target || v.composedPath().includes(w))) {
      if ("detail" in v && v.detail === 0 && (l = !c(v)), !l) {
        l = !0;
        return;
      }
      t(v);
    }
  };
  let f = !1;
  const h = [
    Pe(o, "click", (v) => {
      f || (f = !0, setTimeout(() => {
        f = !1;
      }, 0), m(v));
    }, { passive: !0, capture: a }),
    Pe(o, "pointerdown", (v) => {
      const w = et(e);
      l = !c(v) && !!(w && !v.composedPath().includes(w));
    }, { passive: !0 }),
    r && Pe(o, "blur", (v) => {
      setTimeout(() => {
        var w;
        const C = et(e);
        ((w = o.document.activeElement) == null ? void 0 : w.tagName) === "IFRAME" && !(C != null && C.contains(o.document.activeElement)) && t(v);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), b = () => h.forEach((v) => v());
  return s ? {
    stop: b,
    cancel: () => {
      l = !1;
    },
    trigger: (v) => {
      l = !0, m(v), l = !1;
    }
  } : b;
}
const nl = {
  mounted(e, t) {
    const n = !t.modifiers.bubble;
    if (typeof t.value == "function")
      e.__onClickOutside_stop = go(e, t.value, { capture: n });
    else {
      const [o, i] = t.value;
      e.__onClickOutside_stop = go(e, o, Object.assign({ capture: n }, i));
    }
  },
  unmounted(e) {
    e.__onClickOutside_stop();
  }
};
function Zt(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function gi(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : gi(n);
  }
}
function ol(e) {
  const t = e || window.event, n = t.target;
  return gi(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const Jt = /* @__PURE__ */ new WeakMap();
function il(e, t = !1) {
  const n = _(t);
  let o = null, i = "";
  le(Ar(e), (s) => {
    const l = Zt(Q(s));
    if (l) {
      const c = l;
      if (Jt.get(c) || Jt.set(c, c.style.overflow), c.style.overflow !== "hidden" && (i = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const a = () => {
    const s = Zt(Q(e));
    !s || n.value || (fn && (o = Pe(
      s,
      "touchmove",
      (l) => {
        ol(l);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", n.value = !0);
  }, r = () => {
    const s = Zt(Q(e));
    !s || !n.value || (fn && (o == null || o()), s.style.overflow = i, Jt.delete(s), n.value = !1);
  };
  return Vt(r), x({
    get() {
      return n.value;
    },
    set(s) {
      s ? a() : r();
    }
  });
}
function al() {
  let e = !1;
  const t = ze(!1);
  return (n, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const i = il(n, o.value);
    le(t, (a) => i.value = a);
  };
}
al();
const rl = {
  ref: "referenceEl",
  class: "tw-w-fit"
}, sl = {}, Hn = /* @__PURE__ */ V({
  ...sl,
  __name: "BaseFloating",
  props: {
    forceShowFloatingEl: { type: Boolean, default: void 0 },
    hasArrow: { type: Boolean, default: !1 },
    isStatic: { type: Boolean, default: !1 },
    offset: { default: 8 },
    placement: { default: "bottom-start" }
  },
  emits: ["click-outside", "show-floating", "hide-floating"],
  setup(e, { emit: t }) {
    const n = e, o = t, [i, a] = Er(!1), r = He("referenceEl"), s = He("floatingEl"), l = He("floatingArrowEl"), c = 8, d = n.isStatic ? [] : [
      Qs({ padding: c }),
      _s({ padding: c })
    ], u = [
      Gs(n.offset),
      ...d,
      el({
        element: l,
        // the distance in px the arrow can show up against the side of the floating element itself.
        // Use to avoid overlapping rounded corners
        padding: 8
      }),
      Ys()
    ], {
      floatingStyles: m,
      middlewareData: f,
      placement: h
    } = tl(r, s, {
      middleware: u,
      /**
       * Update the floating element's position when the reference element's size or scroll position changes.
       *
       * @param referenceEl - The reference element.
       * @param floatingEl - The floating element.
       * @param update - The update function.
       * @returns - The cleanup function.
       */
      whileElementsMounted(w, C, S) {
        return Ks(w, C, S, {
          ancestorScroll: !0,
          elementResize: !0
        });
      },
      placement: n.placement,
      strategy: "fixed"
    }), b = x(() => {
      var M;
      const { x: w, y: C } = ((M = f.value) == null ? void 0 : M.arrow) ?? {}, S = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[h.value.split("-")[0]], N = typeof n.offset == "number" ? n.offset : 8;
      return {
        left: w != null ? `${w}px` : "",
        top: C != null ? `${C}px` : "",
        right: "",
        bottom: "",
        [S]: `-${N / 2}px`
      };
    });
    le(i, (w) => {
      o(w ? "show-floating" : "hide-floating");
    }), le(
      () => n.forceShowFloatingEl,
      (w) => {
        w !== void 0 && a(w);
      },
      { immediate: !0 }
    );
    function v() {
      o("click-outside"), n.forceShowFloatingEl !== !0 && a(!1);
    }
    return (w, C) => Me((p(), k("div", {
      class: "tw-w-fit",
      onKeyup: at(v, ["escape"])
    }, [
      R("div", rl, [
        O(w.$slots, "reference", {
          isFloatingElDisplayed: T(i),
          toggleContentDisplay: T(a)
        })
      ], 512),
      te(Lt, {
        name: "fade",
        mode: "out-in",
        appear: ""
      }, {
        default: j(() => {
          var S;
          return [
            T(i) ? (p(), k("div", {
              key: 0,
              ref: "floatingEl",
              style: Wn({
                ...T(m),
                visibility: (S = T(f).hide) != null && S.referenceHidden ? "hidden" : "visible"
              }),
              class: "tw-z-[999999]"
            }, [
              w.hasArrow ? (p(), k("span", {
                key: 0,
                ref: "floatingArrowEl",
                "data-testid": "floating-arrow",
                class: "tw-absolute tw-size-sm tw-rotate-45 tw-transform tw-bg-fill-alt",
                style: Wn(b.value)
              }, null, 4)) : A("", !0),
              O(w.$slots, "floating", { toggleContentDisplay: T(a) })
            ], 4)) : A("", !0)
          ];
        }),
        _: 3
      })
    ], 32)), [
      [T(nl), v]
    ]);
  }
});
function yi() {
  const e = _();
  function t(i, a = !1, r = 500) {
    a && (clearTimeout(e.value), e.value = setTimeout(() => i(!1), r));
  }
  function n() {
    clearTimeout(e.value);
  }
  function o(i, a = !1) {
    a && (clearTimeout(e.value), i(!0));
  }
  return {
    handleMouseLeave: t,
    handleMouseoverList: n,
    handleMouseoverReference: o
  };
}
const ll = ["aria-controlledby", "role", "onMouseleave", "onClick"], cl = {}, v1 = /* @__PURE__ */ V({
  ...cl,
  __name: "UIDropdownMenu",
  props: {
    displayMenuOnHover: { type: Boolean, default: !1 },
    hideDelay: { default: 500 },
    referenceComponent: {},
    referenceComponentAttrs: { default: () => ({}) },
    role: { default: "menu" }
  },
  setup(e) {
    const t = re(), n = Ce(), { handleMouseLeave: o, handleMouseoverList: i, handleMouseoverReference: a } = yi();
    return U(t.menuLists) || console.error('UIDropdownMenu requires a slot named "menuLists"'), (r, s) => (p(), $(Hn, null, {
      reference: j(({ toggleContentDisplay: l, isFloatingElDisplayed: c }) => [
        r.referenceComponent ? (p(), $(Le(r.referenceComponent), pe({ key: 0 }, r.referenceComponentAttrs, {
          id: T(n),
          "aria-expanded": c,
          onClick: (d) => l(),
          onMouseover: (d) => T(a)(l, r.displayMenuOnHover),
          onMouseleave: (d) => T(o)(l, r.displayMenuOnHover, r.hideDelay)
        }), {
          default: j(() => [
            O(r.$slots, "referenceText")
          ]),
          _: 2
        }, 1040, ["id", "aria-expanded", "onClick", "onMouseover", "onMouseleave"])) : A("", !0)
      ]),
      floating: j(({ toggleContentDisplay: l }) => [
        T(U)(t.menuLists) ? (p(), k("div", {
          key: 0,
          class: "tw-flex tw-min-w-[160px] tw-flex-col tw-gap-y-3xs tw-rounded-lg tw-bg-surface tw-p-2xs tw-shadow-lg",
          "aria-controlledby": T(n),
          role: r.role,
          onMouseover: s[0] || (s[0] = //@ts-ignore
          (...c) => T(i) && T(i)(...c)),
          onMouseleave: (c) => T(o)(l, r.displayMenuOnHover, r.hideDelay),
          onClick: (c) => l(!1)
        }, [
          O(r.$slots, "menuLists")
        ], 40, ll)) : A("", !0)
      ]),
      _: 3
    }));
  }
}), ul = {
  key: 0,
  class: "tw-text-body tw-rounded tw-px-md tw-py-sm tw-text-discrete"
}, dl = {}, w1 = /* @__PURE__ */ V({
  ...dl,
  __name: "UIDropdownMenuList",
  props: {
    title: { default: "" }
  },
  setup(e) {
    return (t, n) => (p(), k("ul", null, [
      t.title ? (p(), k("li", ul, G(t.title), 1)) : A("", !0),
      O(t.$slots, "default")
    ]));
  }
}), fl = { class: "tw-flex tw-flex-1 tw-flex-col tw-items-start tw-gap-y-3xs" }, hl = { class: "tw-text-body" }, ml = {
  key: 0,
  class: "tw-text-body-xs tw-text-discrete"
}, pl = {
  key: 1,
  class: "tw-text-body tw-text-discrete"
}, vl = {}, b1 = /* @__PURE__ */ V({
  ...vl,
  inheritAttrs: !1,
  __name: "UIDropdownMenuListItem",
  props: {
    href: { default: "" },
    isActive: { type: Boolean, default: !1 },
    leftIconName: { default: "" },
    rightIconName: { default: "" },
    rightSideText: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    text: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = ut(), { linkOrButtonComponent: a } = Rt(
      () => n.href || i.to
    ), r = x(() => n.href || i.to ? {
      href: n.href || i.to,
      "aria-current": n.isActive ? "page" : void 0,
      ...i
    } : {
      type: "button",
      "aria-checked": n.isActive ? n.isActive : void 0,
      ...i
    });
    return (s, l) => (p(), k("li", null, [
      (p(), $(Le(T(a)), pe(r.value, {
        class: ["tw-flex tw-w-full tw-min-w-[160px] tw-items-center tw-gap-x-md tw-rounded tw-px-md hover:tw-bg-surface-hover", [
          {
            "tw-bg-fill-discrete3": s.isActive
          },
          s.size === "lg" ? "tw-py-md" : "tw-py-sm"
        ]],
        onClick: l[0] || (l[0] = (c) => o("click"))
      }), {
        default: j(() => [
          s.leftIconName ? (p(), $(W, {
            key: 0,
            name: s.leftIconName,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])) : A("", !0),
          R("span", fl, [
            R("span", hl, G(s.text), 1),
            s.subText ? (p(), k("span", ml, G(s.subText), 1)) : A("", !0)
          ]),
          s.rightSideText ? (p(), k("span", pl, G(s.rightSideText), 1)) : A("", !0),
          s.rightIconName && s.isActive ? (p(), $(W, {
            key: 2,
            name: s.rightIconName,
            class: "tw-text-icon"
          }, null, 8, ["name"])) : A("", !0)
        ]),
        _: 1
      }, 16, ["class"]))
    ]));
  }
}), wl = ["id", "name", "checked", "disabled", "valid", "readonly"], bl = ["for"], gl = {}, jn = /* @__PURE__ */ V({
  ...gl,
  __name: "UIInputCheckbox",
  props: /* @__PURE__ */ ie({
    isDisabled: { type: Boolean, default: !1 },
    isIndeterminate: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    checkboxPosition: { default: "left" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ce(), n = he(e, "modelValue");
    return (o, i) => (p(), k("span", {
      class: z(["tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-md", {
        "tw-pointer-events-none": o.isDisabled,
        "tw-w-full tw-flex-row-reverse": o.checkboxPosition === "right"
      }]),
      onClick: i[1] || (i[1] = $e((a) => !o.isDisabled && (n.value = !n.value), ["prevent"]))
    }, [
      R("span", {
        class: z(["tw-relative tw-flex tw-h-xl tw-w-xl tw-flex-col tw-items-center tw-justify-center tw-rounded tw-border tw-border-discrete2 tw-bg-surface hover:tw-border-default-color disabled:tw-pointer-events-none", {
          "!tw-border-default-color !tw-bg-fill-alt": n.value && !o.isDisabled,
          "tw-border-2 !tw-border-error": o.hasError && !o.isDisabled,
          "!tw-bg-fill-error": o.hasError && !n.value && !o.isDisabled,
          "!tw-border-disabled !tw-bg-fill-alt-disabled": o.isDisabled
        }])
      }, [
        Me(R("input", {
          id: T(t),
          "onUpdate:modelValue": i[0] || (i[0] = (a) => n.value = a),
          type: "checkbox",
          name: T(t),
          checked: n.value,
          disabled: o.isDisabled,
          valid: o.hasError ? !1 : void 0,
          readonly: o.isDisabled,
          class: "tw-absolute tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-appearance-none tw-rounded focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus"
        }, null, 8, wl), [
          [Eo, n.value]
        ]),
        n.value ? (p(), $(W, {
          key: 0,
          name: o.isIndeterminate ? "material-symbols:remove" : "material-symbols:check",
          size: "sm",
          class: z(["tw-text-inverse", {
            "!tw-text-disabled": o.isDisabled
          }])
        }, null, 8, ["name", "class"])) : A("", !0)
      ], 2),
      T(U)(o.$slots.label) ? (p(), k("label", {
        key: 0,
        for: T(t),
        class: z(["tw-flex-1 tw-items-center tw-justify-center", {
          "tw-cursor-pointer": !o.isDisabled,
          "tw-cursor-not-allowed tw-opacity-50": o.isDisabled
        }])
      }, [
        O(o.$slots, "label")
      ], 10, bl)) : A("", !0)
    ], 2));
  }
}), yl = ["for"], xl = {
  key: 0,
  class: "tw-ml-sm tw-font-normal tw-text-discrete2"
}, Cl = {}, xi = /* @__PURE__ */ V({
  ...Cl,
  __name: "UIInputLabel",
  props: {
    htmlFor: {},
    optionalText: { default: "" }
  },
  setup(e) {
    return (t, n) => (p(), k("label", {
      for: t.htmlFor,
      class: "tw-block tw-text-base tw-font-bold"
    }, [
      O(t.$slots, "default"),
      t.optionalText ? (p(), k("span", xl, G(t.optionalText), 1)) : A("", !0)
    ], 8, yl));
  }
}), kl = ["id", "type", "placeholder", "name", "autocomplete", "disabled", "aria-invalid"], Tl = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, Sl = {}, Ci = /* @__PURE__ */ V({
  ...Sl,
  __name: "BaseInput",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    iconLeftName: { default: null },
    type: { default: "text" },
    optionalLabelText: { default: "" },
    autocomplete: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["focus", "blur"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, o = t, i = re(), a = Ce(), r = he(e, "modelValue"), s = `error-message-${a}`, l = x(() => [
      (n.errorText || U(i["error-text"])) && "tw-border-2 tw-border-error tw-bg-fill-error",
      n.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled",
      n.inputSize === "large" ? "tw-h-5xl tw-py-md" : "tw-h-4xl tw-py-sm"
    ].join(" ").replaceAll("false", "")), c = x(() => !!n.errorText || U(i["error-text"])), d = x(() => r.value && n.type === "password" ? "tw-text-success" : "tw-text-discrete2");
    return (u, m) => (p(), k("div", null, [
      T(U)(u.$slots.label) ? (p(), $(xi, {
        key: 0,
        "optional-text": u.optionalLabelText,
        "html-for": T(a),
        class: "tw-mb-2xs"
      }, {
        default: j(() => [
          O(u.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"])) : A("", !0),
      R("div", {
        class: z(["tw-bg tw-relative tw-flex tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-px-md focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", l.value])
      }, [
        u.iconLeftName ? (p(), $(W, {
          key: 0,
          name: u.iconLeftName,
          size: "lg",
          class: "tw-text-icon-discrete2"
        }, null, 8, ["name"])) : A("", !0),
        Me(R("input", {
          id: T(a),
          "onUpdate:modelValue": m[0] || (m[0] = (f) => r.value = f),
          type: u.type,
          placeholder: u.placeholder,
          name: u.name,
          autocomplete: u.autocomplete,
          disabled: u.isDisabled,
          "aria-invalid": c.value,
          "aria-errormessage": s,
          class: "tw-h-2xl tw-w-full tw-rounded tw-bg-transparent tw-outline-none placeholder:tw-text-discrete2",
          onFocus: m[1] || (m[1] = (f) => o("focus")),
          onBlur: m[2] || (m[2] = (f) => o("blur"))
        }, null, 40, kl), [
          [$o, r.value]
        ]),
        O(u.$slots, "icon-button-right")
      ], 2),
      c.value ? (p(), k("span", {
        key: 1,
        id: s
      }, [
        T(U)(i["error-text"]) ? O(u.$slots, "error-text", { key: 0 }) : u.errorText ? (p(), k("span", Tl, G(u.errorText), 1)) : A("", !0)
      ])) : u.helperText ? (p(), k("span", {
        key: 2,
        class: z(["tw-mt-2xs tw-inline-block tw-text-sm", d.value])
      }, G(u.helperText), 3)) : A("", !0)
    ]));
  }
}), Al = ["aria-label"], Il = {}, g1 = /* @__PURE__ */ V({
  ...Il,
  __name: "UIInputPassword",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: { default: "password" },
    placeholder: { default: "" },
    toggleVisibilityAriaText: { default: "" },
    autocomplete: { default: "current-password" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = he(e, "modelValue"), n = _("material-symbols:visibility-outline"), o = _("password");
    function i() {
      o.value === "password" ? (n.value = "material-symbols:visibility-off-outline", o.value = "text") : (n.value = "material-symbols:visibility-outline", o.value = "password");
    }
    return (a, r) => (p(), $(Ci, {
      modelValue: t.value,
      "onUpdate:modelValue": r[0] || (r[0] = (s) => t.value = s),
      "icon-left-name": "material-symbols:lock-outline",
      type: o.value,
      placeholder: a.placeholder,
      name: a.name,
      "helper-text": a.helperText,
      "error-text": a.errorText,
      autocomplete: a.autocomplete,
      "is-disabled": a.isDisabled
    }, zo({
      "icon-button-right": j(() => [
        R("button", {
          class: "tw-h-xl",
          type: "button",
          "aria-label": a.toggleVisibilityAriaText,
          onClick: i
        }, [
          te(W, {
            name: n.value,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])
        ], 8, Al)
      ]),
      _: 2
    }, [
      T(U)(a.$slots.label) ? {
        name: "label",
        fn: j(() => [
          O(a.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "type", "placeholder", "name", "helper-text", "error-text", "autocomplete", "is-disabled"]));
  }
}), El = { class: "tw-flex tw-flex-1 tw-flex-col tw-gap-y-3xs" }, $l = { class: "tw-text-body" }, zl = {
  key: 0,
  class: "tw-text-discrete2"
}, Ml = {
  key: 0,
  class: "tw-text-discrete2"
}, Fl = {}, Ol = /* @__PURE__ */ V({
  ...Fl,
  __name: "BaseSelectOption",
  props: {
    option: {},
    isSelected: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: t }) {
    const n = t;
    function o() {
      e.option.disabled || n("toggle", e.option);
    }
    return (i, a) => (p(), $(jn, {
      "model-value": i.isSelected,
      "is-disabled": i.option.disabled,
      "checkbox-position": "right",
      class: z(["tw-bg-surface tw-px-2xs tw-py-sm hover:tw-bg-surface-hover", {
        "tw-cursor-not-allowed tw-opacity-50": i.option.disabled,
        "tw-cursor-pointer": !i.option.disabled
      }]),
      onClick: a[0] || (a[0] = $e(() => {
      }, ["stop"])),
      "onUpdate:modelValue": o
    }, {
      label: j(() => [
        R("div", El, [
          R("span", $l, [
            Tn(G(i.option.label) + " ", 1),
            i.option.count ? (p(), k("span", zl, " (" + G(i.option.count) + ") ", 1)) : A("", !0)
          ]),
          i.option.helpText ? (p(), k("span", Ml, G(i.option.helpText), 1)) : A("", !0)
        ])
      ]),
      _: 1
    }, 8, ["model-value", "is-disabled", "class"]));
  }
}), Nl = {
  class: "tw-text-body tw-font-bold",
  "data-testid": "group-header-title"
}, Ll = {
  class: "tw-text-body tw-font-bold",
  role: "heading",
  "aria-level": "3",
  "data-testid": "group-header-title"
}, Bl = {}, Dl = /* @__PURE__ */ V({
  ...Bl,
  __name: "BaseSelectOptionGroupHeader",
  props: {
    group: {},
    hasOneSelectedOption: { type: Boolean },
    hasAllSelectedOptions: { type: Boolean },
    isGroupDisabled: { type: Boolean },
    isCollapsed: { type: Boolean }
  },
  emits: ["toggle-group"],
  setup(e, { emit: t }) {
    const n = t;
    function o() {
      n("toggle-group", e.group);
    }
    return (i, a) => i.group.collapsible || !i.group.options.length ? (p(), k("div", {
      key: 0,
      class: z(["tw-flex tw-items-center tw-justify-between tw-px-2xs tw-py-sm", { "tw-cursor-pointer": i.group.collapsible }]),
      "data-testid": "group-collapsible-header",
      onClick: $e(o, ["stop"])
    }, [
      R("h3", Nl, G(i.group.title), 1),
      i.group.collapsible ? (p(), $(W, {
        key: 0,
        name: i.isCollapsed ? "mdi:chevron-right" : "mdi:chevron-down"
      }, null, 8, ["name"])) : A("", !0)
    ], 2)) : i.group.options.length ? (p(), $(jn, {
      key: 1,
      "model-value": i.hasOneSelectedOption,
      "is-disabled": i.isGroupDisabled,
      "is-indeterminate": !i.hasAllSelectedOptions,
      class: "tw-bg-surface tw-px-2xs tw-py-sm",
      "checkbox-position": "right",
      "data-testid": "group-checkbox-header",
      onClick: a[0] || (a[0] = $e(() => {
      }, ["stop"])),
      "onUpdate:modelValue": o
    }, {
      label: j(() => [
        R("span", Ll, G(i.group.title), 1)
      ]),
      _: 1
    }, 8, ["model-value", "is-disabled", "is-indeterminate"])) : A("", !0);
  }
}), Rl = /* @__PURE__ */ V({
  __name: "UITransitionExpand",
  props: {
    name: {},
    type: {},
    css: { type: Boolean },
    duration: { default: 150 },
    enterFromClass: {},
    enterActiveClass: {},
    enterToClass: {},
    appearFromClass: {},
    appearActiveClass: {},
    appearToClass: {},
    leaveFromClass: {},
    leaveActiveClass: {},
    leaveToClass: {},
    mode: { default: "out-in" },
    appear: { type: Boolean },
    persisted: { type: Boolean },
    onBeforeEnter: {},
    onEnter: {},
    onAfterEnter: {},
    onEnterCancelled: {},
    onBeforeLeave: {},
    onLeave: {},
    onAfterLeave: {},
    onLeaveCancelled: {},
    onBeforeAppear: {},
    onAppear: {},
    onAfterAppear: {},
    onAppearCancelled: {}
  },
  emits: ["done-entering", "done-leaving", "start-entering", "start-leaving"],
  setup(e, { emit: t }) {
    const n = e, o = x(
      () => typeof n.duration == "number" ? n.duration : n.duration.enter
    ), i = x(
      () => typeof n.duration == "number" ? n.duration : n.duration.leave
    ), a = t;
    function r(f) {
      m(f, o.value);
      const h = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;
      f.style.transitionDuration = `${h ? 0 : o.value}ms`;
    }
    function s(f) {
      m(f, i.value);
      const h = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;
      f.style.transitionDuration = `${h ? 0 : i.value}ms`;
    }
    function l(f, h) {
      a("start-entering");
      const b = f.offsetWidth;
      f.style.width = `${b}px`, f.style.position = "absolute", f.style.visibility = "hidden", f.style.height = "auto";
      const v = f.offsetHeight;
      f.style.width = "", f.style.position = "", f.style.visibility = "", f.style.height = "0";
      const w = () => {
        f.removeEventListener("transitionend", w), h();
      };
      f.addEventListener("transitionend", w), f.offsetHeight, requestAnimationFrame(() => {
        f.style.height = `${v}px`;
      });
    }
    function c(f) {
      f.style.height = "auto", a("done-entering");
    }
    function d(f, h) {
      a("start-leaving");
      const b = f.offsetHeight;
      f.style.height = `${b}px`;
      const v = () => {
        f.removeEventListener("transitionend", v), h();
      };
      f.addEventListener("transitionend", v), f.offsetHeight, requestAnimationFrame(() => {
        f.style.height = "0";
      });
    }
    function u(f) {
      f.style.height = "auto", a("done-leaving");
    }
    function m(f, h) {
      f.style.overflow = "hidden", f.style.transition = `height ${h}ms`, f.style.transitionTimingFunction = "cubic-bezier(0.4, 0, 0.2, 1)", f.style.willChange = "height, visibility";
    }
    return (f, h) => (p(), $(Lt, {
      name: "expand",
      mode: f.mode,
      css: !1,
      duration: f.duration,
      onBeforeEnter: r,
      onEnter: l,
      onAfterEnter: c,
      onBeforeLeave: s,
      onLeave: d,
      onAfterLeave: u
    }, {
      default: j(() => [
        O(f.$slots, "default")
      ]),
      _: 3
    }, 8, ["mode", "duration"]));
  }
}), Vl = {
  key: 0,
  class: "tw-my-2xs tw-border-t tw-border-discrete3",
  "data-testid": "top-separator"
}, Pl = { key: 0 }, Hl = {}, jl = /* @__PURE__ */ V({
  ...Hl,
  __name: "BaseSelectOptionGroup",
  props: {
    group: {},
    groupIndex: {},
    selectedValues: {},
    isCollapsed: { type: Boolean }
  },
  emits: ["toggle-group", "toggle-option"],
  setup(e, { emit: t }) {
    const n = t, o = x(() => e.group.options.some((c) => e.selectedValues.includes(c.value))), i = x(() => e.group.options.every((c) => e.selectedValues.includes(c.value))), a = x(() => e.group.options.every((c) => c.disabled));
    function r(c) {
      return e.selectedValues.includes(c);
    }
    function s() {
      n("toggle-group", e.group);
    }
    function l(c) {
      n("toggle-option", c);
    }
    return (c, d) => (p(), k("div", null, [
      c.group.hasTopSeparator && c.groupIndex > 0 ? (p(), k("hr", Vl)) : A("", !0),
      c.group.title ? (p(), $(Dl, {
        key: 1,
        group: c.group,
        "has-one-selected-option": o.value,
        "has-all-selected-options": i.value,
        "is-group-disabled": a.value,
        "is-collapsed": c.isCollapsed,
        onToggleGroup: s
      }, null, 8, ["group", "has-one-selected-option", "has-all-selected-options", "is-group-disabled", "is-collapsed"])) : A("", !0),
      te(Rl, null, {
        default: j(() => [
          !c.group.collapsible || !c.isCollapsed ? (p(), k("div", Pl, [
            (p(!0), k(be, null, We(c.group.options, (u) => (p(), $(Ol, {
              key: u.value,
              option: u,
              "is-selected": r(u.value),
              onToggle: l
            }, null, 8, ["option", "is-selected"]))), 128))
          ])) : A("", !0)
        ]),
        _: 1
      })
    ]));
  }
}), Ul = ["aria-controlledby"], Wl = {}, y1 = /* @__PURE__ */ V({
  ...Wl,
  __name: "UIInputSelectChip",
  props: {
    label: {},
    options: {},
    selectedValues: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    iconLeftName: { default: "" },
    isPlacementStatic: { type: Boolean, default: !1 }
  },
  emits: ["select", "mouse-leave"],
  setup(e, { emit: t }) {
    const n = t, o = _(/* @__PURE__ */ new Set()), i = Ce(), a = x(() => e.selectedValues.length), { handleMouseoverList: r, handleMouseoverReference: s } = yi();
    function l(h) {
      if (!(!h.title || f(h))) {
        if (h.collapsible) {
          o.value.has(h.title) ? o.value.delete(h.title) : o.value.add(h.title);
          return;
        }
        m(h) ? n(
          "select",
          e.selectedValues.filter(
            (b) => !h.options.some((v) => v.value === b)
          )
        ) : n("select", [
          ...e.selectedValues,
          ...h.options.filter((b) => !u(b.value)).map((b) => b.value)
        ]);
      }
    }
    function c(h) {
      if (h.disabled) return;
      const { value: b } = h, v = new Set(e.selectedValues);
      v.has(b) ? v.delete(b) : v.add(b), n("select", Array.from(v));
    }
    function d(h) {
      return h ? o.value.has(h) : !1;
    }
    function u(h) {
      return e.selectedValues.includes(h);
    }
    function m(h) {
      return h.options.some((b) => u(b.value));
    }
    function f(h) {
      return h.options.every((b) => b.disabled);
    }
    return (h, b) => (p(), $(Hn, {
      offset: 4,
      "is-static": h.isPlacementStatic
    }, {
      reference: j(({ toggleContentDisplay: v, isFloatingElDisplayed: w }) => [
        te(fs, {
          id: T(i),
          "is-open": w,
          text: h.label,
          count: a.value,
          disabled: h.disabled,
          size: h.size,
          "icon-left-name": h.iconLeftName,
          "aria-expanded": w,
          onClick: (C) => v(),
          onMouseover: (C) => T(s)(v)
        }, null, 8, ["id", "is-open", "text", "count", "disabled", "size", "icon-left-name", "aria-expanded", "onClick", "onMouseover"])
      ]),
      floating: j(() => [
        R("div", {
          role: "listbox",
          "aria-controlledby": T(i),
          class: "tw-max-h-[600px] tw-overflow-y-auto tw-rounded-md tw-bg-surface tw-p-sm tw-shadow-lg",
          onMouseover: b[0] || (b[0] = //@ts-ignore
          (...v) => T(r) && T(r)(...v))
        }, [
          (p(!0), k(be, null, We(h.options, (v, w) => (p(), $(jl, {
            key: w,
            group: v,
            "group-index": w,
            "selected-values": h.selectedValues,
            "is-collapsed": d(v.title),
            onToggleGroup: l,
            onToggleOption: c
          }, null, 8, ["group", "group-index", "selected-values", "is-collapsed"]))), 128))
        ], 40, Ul)
      ]),
      _: 1
    }, 8, ["is-static"]));
  }
}), ql = ["aria-label"], Kl = {}, x1 = /* @__PURE__ */ V({
  ...Kl,
  __name: "UIInputText",
  props: /* @__PURE__ */ ie({
    clearInputAriaText: { default: "" },
    errorText: { default: "" },
    helperText: { default: "" },
    iconLeftName: { default: null },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    isIconRightVisible: { type: Boolean, default: !0 },
    isValidating: { type: Boolean, default: !1 },
    name: {},
    optionalLabelText: { default: "" },
    placeholder: { default: "" },
    type: { default: "text" },
    autocomplete: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = re(), o = he(e, "modelValue"), i = _(!1), a = _(!1), r = x(() => i.value || a.value), s = x(() => t.errorText || U(n["error-text"])), l = x(() => !!(t.isIconRightVisible && r.value && o.value && c.value !== "eos-icons:loading" || s.value && !t.isValidating)), c = x(() => t.isValidating ? "eos-icons:loading" : s.value || l.value ? "mdi:close" : o.value && !s.value ? "material-symbols:check" : ""), d = x(() => o.value && !s.value && !l.value && !t.isValidating ? "tw-text-icon-success" : "tw-text-icon-discrete2"), u = x(() => t.isIconRightVisible && !l.value && c.value);
    le(c, () => {
    });
    function m() {
      o.value = "";
    }
    function f() {
      setTimeout(() => {
        i.value = !1;
      }, 10);
    }
    return (h, b) => (p(), $(Ci, {
      ref: "input",
      modelValue: o.value,
      "onUpdate:modelValue": b[2] || (b[2] = (v) => o.value = v),
      "icon-left-name": h.iconLeftName,
      type: h.type,
      placeholder: h.placeholder,
      name: h.name,
      "helper-text": h.helperText,
      "error-text": h.errorText,
      "input-size": h.inputSize,
      "optional-label-text": h.optionalLabelText,
      "is-disabled": h.isDisabled,
      autocomplete: h.autocomplete,
      onFocus: b[3] || (b[3] = (v) => i.value = !0),
      onBlur: f
    }, zo({
      "icon-button-right": j(() => [
        l.value && !h.isDisabled ? (p(), k("button", {
          key: 0,
          type: "button",
          class: "tw-h-xl",
          "aria-label": h.clearInputAriaText,
          onClick: m,
          onFocus: b[0] || (b[0] = (v) => a.value = !0),
          onBlur: b[1] || (b[1] = (v) => a.value = !1)
        }, [
          te(W, {
            name: c.value,
            class: z(d.value)
          }, null, 8, ["name", "class"])
        ], 40, ql)) : u.value && !h.isDisabled ? (p(), $(W, {
          key: 1,
          name: c.value,
          class: z(d.value)
        }, null, 8, ["name", "class"])) : A("", !0)
      ]),
      _: 2
    }, [
      T(U)(h.$slots.label) ? {
        name: "label",
        fn: j(() => [
          O(h.$slots, "label")
        ]),
        key: "0"
      } : void 0,
      T(U)(n["error-text"]) ? {
        name: "error-text",
        fn: j(() => [
          O(h.$slots, "error-text")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["modelValue", "icon-left-name", "type", "placeholder", "name", "helper-text", "error-text", "input-size", "optional-label-text", "is-disabled", "autocomplete"]));
  }
}), Gl = {
  key: 0,
  class: "tw-mb-2xl tw-mt-sm"
}, _l = ["id", "placeholder", "name", "disabled"], Ql = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, Yl = {
  key: 2,
  class: "tw-mt-2xs tw-inline-block tw-text-sm tw-text-discrete2"
}, C1 = /* @__PURE__ */ V({
  __name: "UIInputTextarea",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    optionalLabelText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = Ce(), o = he(e, "modelValue"), i = x(() => [
      t.errorText && "tw-border-2 tw-border-error tw-bg-fill-error",
      t.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled"
    ].join(" ").replaceAll("false", ""));
    return (a, r) => (p(), k("div", null, [
      te(xi, {
        "optional-text": a.optionalLabelText,
        "html-for": T(n)
      }, {
        default: j(() => [
          O(a.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"]),
      T(U)(a.$slots.tip) ? (p(), k("div", Gl, [
        O(a.$slots, "tip")
      ])) : A("", !0),
      Me(R("textarea", {
        id: T(n),
        "onUpdate:modelValue": r[0] || (r[0] = (s) => o.value = s),
        class: z(["tw-text-body tw-relative tw-flex tw-max-h-[50vh] tw-min-h-[88px] tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-bg-transparent tw-p-md placeholder:tw-text-discrete2 focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", i.value]),
        placeholder: a.placeholder,
        name: a.name,
        disabled: a.isDisabled
      }, null, 10, _l), [
        [$o, o.value]
      ]),
      a.errorText ? (p(), k("span", Ql, G(a.errorText), 1)) : a.helperText ? (p(), k("span", Yl, G(a.helperText), 1)) : A("", !0)
    ]));
  }
}), Xl = ["id", "name", "checked", "disabled", "readonly", "valid"], Zl = {}, k1 = /* @__PURE__ */ V({
  ...Zl,
  __name: "UIInputToggleCheckbox",
  props: /* @__PURE__ */ ie({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    iconName: { default: "mdi:check" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = he(e, "modelValue"), n = Ce(), o = x(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), i = x(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), a = x(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), r = x(() => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? t.value ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-hover" : t.value ? "tw-bg-surface hover:tw-bg-surface-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-alt-hover"), s = x(() => e.theme === "light" ? e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-surface" : e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-fill-alt"), l = x(() => e.disabled ? "tw-text-icon-disabled" : e.theme === "light" ? "tw-text-icon" : "tw-text-icon-inverse");
    return (c, d) => (p(), k("label", {
      class: z(["tw-relative tw-inline-flex tw-items-center", [
        c.disabled ? "tw-pointer-events-none tw-cursor-not-allowed" : "tw-cursor-pointer"
      ]])
    }, [
      Me(R("input", {
        id: T(n),
        "onUpdate:modelValue": d[0] || (d[0] = (u) => t.value = u),
        type: "checkbox",
        name: T(n),
        class: "tw-sr-only tw-appearance-none",
        checked: t.value,
        disabled: c.disabled,
        readonly: c.disabled,
        valid: c.hasError ? !1 : void 0
      }, null, 8, Xl), [
        [Eo, t.value]
      ]),
      R("div", {
        class: z(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [r.value]: !0,
          [o.value]: !0,
          "tw-border-2 tw-border-error": c.hasError && !c.disabled
        }])
      }, [
        R("div", {
          class: z(["tw-rounded-full tw-transition-all tw-duration-200", {
            [s.value]: !t.value,
            [a.value]: !0
          }])
        }, null, 2),
        R("div", {
          class: z(["tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            [s.value]: t.value,
            [i.value]: !0,
            [a.value]: !0
          }])
        }, [
          Me(te(W, {
            name: c.iconName,
            size: c.size,
            class: z(l.value)
          }, null, 8, ["name", "size", "class"]), [
            [Mo, t.value]
          ])
        ], 2)
      ], 2)
    ], 2));
  }
}), Jl = { class: "tw-inline-flex tw-items-center" }, e0 = ["aria-invalid"], t0 = ["for", "aria-label"], n0 = ["id", "readonly", "checked", "value", "disabled", "valid", "onClick"], T1 = /* @__PURE__ */ V({
  __name: "UIInputToggleRadio",
  props: /* @__PURE__ */ ie({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 },
    options: {}
  }, {
    modelValue: void 0,
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = he(
      e,
      "modelValue",
      void 0
    ), i = Ce(), a = x(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), r = x(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), s = x(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), l = x(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-surface hover:tw-bg-surface-hover"
    ), c = x(
      () => e.size === "sm" ? "tw-text-body-sm tw-px-2xs tw-gap-x-2xs" : e.size === "lg" ? "tw-text-body-lg tw-px-sm tw-gap-x-sm" : "tw-text-body tw-px-xs tw-gap-x-xs"
    ), d = x(
      () => e.disabled ? "tw-bg-fill-alt-disabled" : e.theme === "light" ? "tw-bg-surface tw-text-icon" : "tw-bg-fill-alt tw-text-icon-inverse"
    ), u = x(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "dark" ? "tw-text-icon" : "tw-text-icon-inverse"
    ), m = x(
      () => e.theme === "light" ? "tw-text-icon-discrete2" : "tw-text-icon-disabled"
    );
    function f(b) {
      return o.value === b;
    }
    function h(b, v) {
      e.disabled || v || f(b) || (o.value = b, n("update:modelValue", b));
    }
    return (b, v) => (p(), k("div", Jl, [
      R("div", {
        class: z(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [l.value]: !0,
          [a.value]: !0,
          "tw-border-2 tw-border-error": b.hasError && !b.disabled
        }]),
        role: "radiogroup",
        "aria-invalid": b.hasError
      }, [
        (p(!0), k(be, null, We(b.options, ({
          value: w,
          label: C,
          iconName: S,
          disabled: I = !1
        }) => (p(), k("label", {
          key: `${T(i)}-${w}`,
          class: z(["tw-flex tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            "tw-cursor-pointer": !b.disabled && !I,
            "tw-cursor-not-allowed": b.disabled || I,
            [a.value]: !0,
            [s.value]: !0,
            [r.value]: !0,
            [d.value]: f(w),
            [u.value]: !f(w) && !I,
            [m.value]: I || b.disabled
          }]),
          for: `${T(i)}-${w}`,
          "aria-label": C
        }, [
          R("input", {
            id: `${T(i)}-${w}`,
            readonly: b.disabled || I,
            type: "radio",
            class: "tw-sr-only tw-appearance-none",
            checked: f(w),
            value: w,
            disabled: b.disabled || I,
            valid: b.hasError ? !1 : void 0,
            onClick: (N) => h(w, I)
          }, null, 8, n0),
          R("div", {
            class: z(["tw-flex tw-items-center", [c.value]])
          }, [
            S ? (p(), $(W, {
              key: 0,
              name: S,
              size: b.size
            }, null, 8, ["name", "size"])) : A("", !0),
            R("span", null, G(C), 1)
          ], 2)
        ], 10, t0))), 128))
      ], 10, e0)
    ]));
  }
});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var ki = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Mt = /* @__PURE__ */ ki.join(","), Ti = typeof Element > "u", Ne = Ti ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Ft = !Ti && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Ot = function e(t, n) {
  var o;
  n === void 0 && (n = !0);
  var i = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), a = i === "" || i === "true", r = a || n && t && e(t.parentNode);
  return r;
}, o0 = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, Si = function(t, n, o) {
  if (Ot(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(Mt));
  return n && Ne.call(t, Mt) && i.unshift(t), i = i.filter(o), i;
}, Ai = function e(t, n, o) {
  for (var i = [], a = Array.from(t); a.length; ) {
    var r = a.shift();
    if (!Ot(r, !1))
      if (r.tagName === "SLOT") {
        var s = r.assignedElements(), l = s.length ? s : r.children, c = e(l, !0, o);
        o.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: r,
          candidates: c
        });
      } else {
        var d = Ne.call(r, Mt);
        d && o.filter(r) && (n || !t.includes(r)) && i.push(r);
        var u = r.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(r), m = !Ot(u, !1) && (!o.shadowRootFilter || o.shadowRootFilter(r));
        if (u && m) {
          var f = e(u === !0 ? r.children : u.children, !0, o);
          o.flatten ? i.push.apply(i, f) : i.push({
            scopeParent: r,
            candidates: f
          });
        } else
          a.unshift.apply(a, r.children);
      }
  }
  return i;
}, Ii = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Se = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || o0(t)) && !Ii(t) ? 0 : t.tabIndex;
}, i0 = function(t, n) {
  var o = Se(t);
  return o < 0 && n && !Ii(t) ? 0 : o;
}, a0 = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Ei = function(t) {
  return t.tagName === "INPUT";
}, r0 = function(t) {
  return Ei(t) && t.type === "hidden";
}, s0 = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, l0 = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, c0 = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Ft(t), o = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = o(window.CSS.escape(t.name));
  else
    try {
      i = o(t.name);
    } catch (r) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", r.message), !1;
    }
  var a = l0(i, t.form);
  return !a || a === t;
}, u0 = function(t) {
  return Ei(t) && t.type === "radio";
}, d0 = function(t) {
  return u0(t) && !c0(t);
}, f0 = function(t) {
  var n, o = t && Ft(t), i = (n = o) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (o && o !== t) {
    var r, s, l;
    for (a = !!((r = i) !== null && r !== void 0 && (s = r.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !a && i; ) {
      var c, d, u;
      o = Ft(i), i = (c = o) === null || c === void 0 ? void 0 : c.host, a = !!((d = i) !== null && d !== void 0 && (u = d.ownerDocument) !== null && u !== void 0 && u.contains(i));
    }
  }
  return a;
}, yo = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, i = n.height;
  return o === 0 && i === 0;
}, h0 = function(t, n) {
  var o = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = Ne.call(t, "details>summary:first-of-type"), r = a ? t.parentElement : t;
  if (Ne.call(r, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof i == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, c = Ft(t);
        if (l && !l.shadowRoot && i(l) === !0)
          return yo(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = s;
    }
    if (f0(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return yo(t);
  return !1;
}, m0 = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var i = n.children.item(o);
          if (i.tagName === "LEGEND")
            return Ne.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Nt = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Ot(n) || r0(n) || h0(n, t) || // For a details element with a summary, the summary element gets the focus
  s0(n) || m0(n));
}, gn = function(t, n) {
  return !(d0(n) || Se(n) < 0 || !Nt(t, n));
}, p0 = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, v0 = function e(t) {
  var n = [], o = [];
  return t.forEach(function(i, a) {
    var r = !!i.scopeParent, s = r ? i.scopeParent : i, l = i0(s, r), c = r ? e(i.candidates) : s;
    l === 0 ? r ? n.push.apply(n, c) : n.push(s) : o.push({
      documentOrder: a,
      tabIndex: l,
      item: i,
      isScope: r,
      content: c
    });
  }), o.sort(a0).reduce(function(i, a) {
    return a.isScope ? i.push.apply(i, a.content) : i.push(a.content), i;
  }, []).concat(n);
}, w0 = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = Ai([t], n.includeContainer, {
    filter: gn.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: p0
  }) : o = Si(t, n.includeContainer, gn.bind(null, n)), v0(o);
}, b0 = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = Ai([t], n.includeContainer, {
    filter: Nt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = Si(t, n.includeContainer, Nt.bind(null, n)), o;
}, Re = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ne.call(t, Mt) === !1 ? !1 : gn(n, t);
}, g0 = /* @__PURE__ */ ki.concat("iframe").join(","), en = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ne.call(t, g0) === !1 ? !1 : Nt(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function yn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function y0(e) {
  if (Array.isArray(e)) return yn(e);
}
function x0(e, t, n) {
  return (t = A0(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function C0(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function k0() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xo(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Co(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xo(Object(n), !0).forEach(function(o) {
      x0(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xo(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function T0(e) {
  return y0(e) || C0(e) || I0(e) || k0();
}
function S0(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function A0(e) {
  var t = S0(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function I0(e, t) {
  if (e) {
    if (typeof e == "string") return yn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? yn(e, t) : void 0;
  }
}
var ko = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var o = t[t.length - 1];
      o !== n && o._setPausedState(!0);
    }
    var i = t.indexOf(n);
    i === -1 || t.splice(i, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var o = t.indexOf(n);
    o !== -1 && t.splice(o, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, E0 = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, $0 = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, it = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, z0 = function(t) {
  return it(t) && !t.shiftKey;
}, M0 = function(t) {
  return it(t) && t.shiftKey;
}, To = function(t) {
  return setTimeout(t, 0);
}, Ze = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    o[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, o) : t;
}, xt = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, F0 = [], O0 = function(t, n) {
  var o = (n == null ? void 0 : n.document) || document, i = (n == null ? void 0 : n.trapStack) || F0, a = Co({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: z0,
    isKeyBackward: M0
  }, n), r = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(g, y, E) {
    return g && g[y] !== void 0 ? g[y] : a[E || y];
  }, c = function(g, y) {
    var E = typeof (y == null ? void 0 : y.composedPath) == "function" ? y.composedPath() : void 0;
    return r.containerGroups.findIndex(function(B) {
      var D = B.container, H = B.tabbableNodes;
      return D.contains(g) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (E == null ? void 0 : E.includes(D)) || H.find(function(L) {
        return L === g;
      });
    });
  }, d = function(g) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = y.hasFallback, B = E === void 0 ? !1 : E, D = y.params, H = D === void 0 ? [] : D, L = a[g];
    if (typeof L == "function" && (L = L.apply(void 0, T0(H))), L === !0 && (L = void 0), !L) {
      if (L === void 0 || L === !1)
        return L;
      throw new Error("`".concat(g, "` was specified but was not a node, or did not return a node"));
    }
    var X = L;
    if (typeof L == "string") {
      try {
        X = o.querySelector(L);
      } catch (J) {
        throw new Error("`".concat(g, '` appears to be an invalid selector; error="').concat(J.message, '"'));
      }
      if (!X && !B)
        throw new Error("`".concat(g, "` as selector refers to no known node"));
    }
    return X;
  }, u = function() {
    var g = d("initialFocus", {
      hasFallback: !0
    });
    if (g === !1)
      return !1;
    if (g === void 0 || g && !en(g, a.tabbableOptions))
      if (c(o.activeElement) >= 0)
        g = o.activeElement;
      else {
        var y = r.tabbableGroups[0], E = y && y.firstTabbableNode;
        g = E || d("fallbackFocus");
      }
    else g === null && (g = d("fallbackFocus"));
    if (!g)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return g;
  }, m = function() {
    if (r.containerGroups = r.containers.map(function(g) {
      var y = w0(g, a.tabbableOptions), E = b0(g, a.tabbableOptions), B = y.length > 0 ? y[0] : void 0, D = y.length > 0 ? y[y.length - 1] : void 0, H = E.find(function(J) {
        return Re(J);
      }), L = E.slice().reverse().find(function(J) {
        return Re(J);
      }), X = !!y.find(function(J) {
        return Se(J) > 0;
      });
      return {
        container: g,
        tabbableNodes: y,
        focusableNodes: E,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: X,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: B,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: D,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: H,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: L,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ke) {
          var Qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, ve = y.indexOf(ke);
          return ve < 0 ? Qe ? E.slice(E.indexOf(ke) + 1).find(function(Ye) {
            return Re(Ye);
          }) : E.slice(0, E.indexOf(ke)).reverse().find(function(Ye) {
            return Re(Ye);
          }) : y[ve + (Qe ? 1 : -1)];
        }
      };
    }), r.tabbableGroups = r.containerGroups.filter(function(g) {
      return g.tabbableNodes.length > 0;
    }), r.tabbableGroups.length <= 0 && !d("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (r.containerGroups.find(function(g) {
      return g.posTabIndexesFound;
    }) && r.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, f = function(g) {
    var y = g.activeElement;
    if (y)
      return y.shadowRoot && y.shadowRoot.activeElement !== null ? f(y.shadowRoot) : y;
  }, h = function(g) {
    if (g !== !1 && g !== f(document)) {
      if (!g || !g.focus) {
        h(u());
        return;
      }
      g.focus({
        preventScroll: !!a.preventScroll
      }), r.mostRecentlyFocusedNode = g, E0(g) && g.select();
    }
  }, b = function(g) {
    var y = d("setReturnFocus", {
      params: [g]
    });
    return y || (y === !1 ? !1 : g);
  }, v = function(g) {
    var y = g.target, E = g.event, B = g.isBackward, D = B === void 0 ? !1 : B;
    y = y || xt(E), m();
    var H = null;
    if (r.tabbableGroups.length > 0) {
      var L = c(y, E), X = L >= 0 ? r.containerGroups[L] : void 0;
      if (L < 0)
        D ? H = r.tabbableGroups[r.tabbableGroups.length - 1].lastTabbableNode : H = r.tabbableGroups[0].firstTabbableNode;
      else if (D) {
        var J = r.tabbableGroups.findIndex(function(Ut) {
          var Wt = Ut.firstTabbableNode;
          return y === Wt;
        });
        if (J < 0 && (X.container === y || en(y, a.tabbableOptions) && !Re(y, a.tabbableOptions) && !X.nextTabbableNode(y, !1)) && (J = L), J >= 0) {
          var ke = J === 0 ? r.tabbableGroups.length - 1 : J - 1, Qe = r.tabbableGroups[ke];
          H = Se(y) >= 0 ? Qe.lastTabbableNode : Qe.lastDomTabbableNode;
        } else it(E) || (H = X.nextTabbableNode(y, !1));
      } else {
        var ve = r.tabbableGroups.findIndex(function(Ut) {
          var Wt = Ut.lastTabbableNode;
          return y === Wt;
        });
        if (ve < 0 && (X.container === y || en(y, a.tabbableOptions) && !Re(y, a.tabbableOptions) && !X.nextTabbableNode(y)) && (ve = L), ve >= 0) {
          var Ye = ve === r.tabbableGroups.length - 1 ? 0 : ve + 1, Un = r.tabbableGroups[Ye];
          H = Se(y) >= 0 ? Un.firstTabbableNode : Un.firstDomTabbableNode;
        } else it(E) || (H = X.nextTabbableNode(y));
      }
    } else
      H = d("fallbackFocus");
    return H;
  }, w = function(g) {
    var y = xt(g);
    if (!(c(y, g) >= 0)) {
      if (Ze(a.clickOutsideDeactivates, g)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      Ze(a.allowOutsideClick, g) || g.preventDefault();
    }
  }, C = function(g) {
    var y = xt(g), E = c(y, g) >= 0;
    if (E || y instanceof Document)
      E && (r.mostRecentlyFocusedNode = y);
    else {
      g.stopImmediatePropagation();
      var B, D = !0;
      if (r.mostRecentlyFocusedNode)
        if (Se(r.mostRecentlyFocusedNode) > 0) {
          var H = c(r.mostRecentlyFocusedNode), L = r.containerGroups[H].tabbableNodes;
          if (L.length > 0) {
            var X = L.findIndex(function(J) {
              return J === r.mostRecentlyFocusedNode;
            });
            X >= 0 && (a.isKeyForward(r.recentNavEvent) ? X + 1 < L.length && (B = L[X + 1], D = !1) : X - 1 >= 0 && (B = L[X - 1], D = !1));
          }
        } else
          r.containerGroups.some(function(J) {
            return J.tabbableNodes.some(function(ke) {
              return Se(ke) > 0;
            });
          }) || (D = !1);
      else
        D = !1;
      D && (B = v({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: r.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(r.recentNavEvent)
      })), h(B || r.mostRecentlyFocusedNode || u());
    }
    r.recentNavEvent = void 0;
  }, S = function(g) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    r.recentNavEvent = g;
    var E = v({
      event: g,
      isBackward: y
    });
    E && (it(g) && g.preventDefault(), h(E));
  }, I = function(g) {
    (a.isKeyForward(g) || a.isKeyBackward(g)) && S(g, a.isKeyBackward(g));
  }, N = function(g) {
    $0(g) && Ze(a.escapeDeactivates, g) !== !1 && (g.preventDefault(), s.deactivate());
  }, M = function(g) {
    var y = xt(g);
    c(y, g) >= 0 || Ze(a.clickOutsideDeactivates, g) || Ze(a.allowOutsideClick, g) || (g.preventDefault(), g.stopImmediatePropagation());
  }, F = function() {
    if (r.active)
      return ko.activateTrap(i, s), r.delayInitialFocusTimer = a.delayInitialFocus ? To(function() {
        h(u());
      }) : h(u()), o.addEventListener("focusin", C, !0), o.addEventListener("mousedown", w, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", w, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", M, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", I, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", N), s;
  }, q = function() {
    if (r.active)
      return o.removeEventListener("focusin", C, !0), o.removeEventListener("mousedown", w, !0), o.removeEventListener("touchstart", w, !0), o.removeEventListener("click", M, !0), o.removeEventListener("keydown", I, !0), o.removeEventListener("keydown", N), s;
  }, K = function(g) {
    var y = g.some(function(E) {
      var B = Array.from(E.removedNodes);
      return B.some(function(D) {
        return D === r.mostRecentlyFocusedNode;
      });
    });
    y && h(u());
  }, Y = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(K) : void 0, se = function() {
    Y && (Y.disconnect(), r.active && !r.paused && r.containers.map(function(g) {
      Y.observe(g, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return r.active;
    },
    get paused() {
      return r.paused;
    },
    activate: function(g) {
      if (r.active)
        return this;
      var y = l(g, "onActivate"), E = l(g, "onPostActivate"), B = l(g, "checkCanFocusTrap");
      B || m(), r.active = !0, r.paused = !1, r.nodeFocusedBeforeActivation = o.activeElement, y == null || y();
      var D = function() {
        B && m(), F(), se(), E == null || E();
      };
      return B ? (B(r.containers.concat()).then(D, D), this) : (D(), this);
    },
    deactivate: function(g) {
      if (!r.active)
        return this;
      var y = Co({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, g);
      clearTimeout(r.delayInitialFocusTimer), r.delayInitialFocusTimer = void 0, q(), r.active = !1, r.paused = !1, se(), ko.deactivateTrap(i, s);
      var E = l(y, "onDeactivate"), B = l(y, "onPostDeactivate"), D = l(y, "checkCanReturnFocus"), H = l(y, "returnFocus", "returnFocusOnDeactivate");
      E == null || E();
      var L = function() {
        To(function() {
          H && h(b(r.nodeFocusedBeforeActivation)), B == null || B();
        });
      };
      return H && D ? (D(b(r.nodeFocusedBeforeActivation)).then(L, L), this) : (L(), this);
    },
    pause: function(g) {
      return r.active ? (r.manuallyPaused = !0, this._setPausedState(!0, g)) : this;
    },
    unpause: function(g) {
      return r.active ? (r.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, g)) : this;
    },
    updateContainerElements: function(g) {
      var y = [].concat(g).filter(Boolean);
      return r.containers = y.map(function(E) {
        return typeof E == "string" ? o.querySelector(E) : E;
      }), r.active && m(), se(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return r.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(g, y) {
        if (r.paused === g)
          return this;
        if (r.paused = g, g) {
          var E = l(y, "onPause"), B = l(y, "onPostPause");
          E == null || E(), q(), se(), B == null || B();
        } else {
          var D = l(y, "onUnpause"), H = l(y, "onPostUnpause");
          D == null || D(), m(), F(), se(), H == null || H();
        }
        return this;
      }
    }
  }), s.updateContainerElements(t), s;
};
function N0(e, t = {}) {
  let n;
  const { immediate: o, ...i } = t, a = ze(!1), r = ze(!1), s = (m) => n && n.activate(m), l = (m) => n && n.deactivate(m), c = () => {
    n && (n.pause(), r.value = !0);
  }, d = () => {
    n && (n.unpause(), r.value = !1);
  }, u = x(() => {
    const m = Q(e);
    return Ie(m).map((f) => {
      const h = Q(f);
      return typeof h == "string" ? h : si(h);
    }).filter(Cr);
  });
  return le(
    u,
    (m) => {
      m.length && (n = O0(m, {
        ...i,
        onActivate() {
          a.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          a.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), o && s());
    },
    { flush: "post" }
  ), Vt(() => l()), {
    hasFocus: a,
    isPaused: r,
    activate: s,
    deactivate: l,
    pause: c,
    unpause: d
  };
}
const L0 = {
  key: 0,
  class: "tw-fixed tw-bottom-zero tw-left-zero tw-right-zero tw-top-zero tw-z-[999999] tw-flex tw-h-full tw-items-end tw-bg-fill-alt tw-bg-opacity-70 md:tw-items-center md:tw-justify-center"
}, B0 = {
  key: 1,
  class: "tw-flex-1"
}, D0 = { key: 3 }, R0 = {
  key: 0,
  id: "modalContent",
  class: "tw-overflow-y-auto tw-p-lg"
}, V0 = {
  key: 1,
  class: "tw-w-full tw-p-lg"
}, P0 = {}, S1 = /* @__PURE__ */ V({
  ...P0,
  __name: "UIModal",
  props: {
    hasBackButton: { type: Boolean, default: !1 },
    isDismissable: { type: Boolean, default: !0 },
    size: { default: "base" }
  },
  emits: ["close", "previous"],
  setup(e, { emit: t }) {
    const n = t, o = re(), i = He("modal"), { activate: a, deactivate: r } = N0(i, { immediate: !0 }), s = _(!1);
    xn(() => {
      s.value = !0, a(), l();
    }), Pi(() => {
      s.value = !1, r(), c();
    });
    function l() {
      document && document.body && (document.body.style.overflow = "hidden");
    }
    function c() {
      document && document.body && (document.body.style.overflow = "auto");
    }
    return (d, u) => (p(), $(Hi, { to: "body" }, [
      te(Lt, {
        name: "fade",
        mode: "out-in"
      }, {
        default: j(() => [
          s.value ? (p(), k("div", L0, [
            R("article", {
              ref: "modal",
              "aria-modal": "",
              role: "dialog",
              "aria-labelledby": "modalTitle",
              "aria-describedby": "modalContent",
              class: z(["tw-flex tw-max-h-[90%] tw-w-full tw-flex-col tw-rounded-t-xl tw-bg-surface tw-p-sm md:tw-rounded-md", {
                "md:tw-w-[400px]": d.size === "sm",
                "md:tw-w-[640px]": d.size === "base",
                "md:tw-w-[800px]": d.size === "lg",
                "md:tw-w-[1024px]": d.size === "xl"
              }]),
              onKeydown: u[2] || (u[2] = at((m) => d.isDismissable && n("close"), ["escape"]))
            }, [
              R("header", {
                class: z(["tw-p-lg tw-text-center", {
                  "tw-flex tw-items-center": d.hasBackButton || d.isDismissable,
                  "md:tw-text-left": !d.hasBackButton && !d.isDismissable
                }])
              }, [
                d.hasBackButton ? (p(), k("button", {
                  key: 0,
                  type: "button",
                  class: "tw-flex tw-size-2xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: u[0] || (u[0] = (m) => n("previous"))
                }, [
                  te(W, {
                    name: "famicons:chevron-back-sharp",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : A("", !0),
                T(U)(o.title) ? (p(), k("div", B0, [
                  O(d.$slots, "title")
                ])) : A("", !0),
                d.isDismissable ? (p(), k("button", {
                  key: 2,
                  type: "button",
                  class: "tw-flex tw-size-xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: u[1] || (u[1] = (m) => n("close"))
                }, [
                  te(W, {
                    name: "material-symbols:close",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : (p(), k("span", D0))
              ], 2),
              T(U)(o.content) ? (p(), k("section", R0, [
                O(d.$slots, "content")
              ])) : A("", !0),
              T(U)(o.cta) ? (p(), k("footer", V0, [
                O(d.$slots, "cta")
              ])) : A("", !0)
            ], 34)
          ])) : A("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), H0 = /* @__PURE__ */ V({
  __name: "UITag",
  props: {
    color: { default: "default" },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" },
    variant: { default: "filled" }
  },
  setup(e) {
    const t = e;
    t.variant === "transparent" && t.color === "alt" && console.error("Variant `transparent` cannot be used with color `alt`");
    const n = x(() => t.variant === "transparent" ? { "tw-bg-fill-transparent": t.variant === "transparent" } : {
      "tw-bg-fill-discrete3": t.color === "default" || t.color === "disabled",
      "tw-bg-fill-primary-discrete2": t.color === "primary",
      "tw-bg-fill-alt": t.color === "alt",
      "tw-bg-fill-success": t.color === "success",
      "tw-bg-fill-caution": t.color === "warning",
      "tw-bg-fill-error": t.color === "error",
      "tw-bg-fill-accent-discrete": t.color === "accent"
    }), o = x(() => ({
      "tw-p-2xs": t.size === "base",
      "tw-py-3xs tw-px-2xs": t.size === "sm"
    })), i = x(() => [
      {
        // color
        "tw-text-discrete": t.color === "default",
        "tw-text-discrete3": t.color === "disabled",
        "tw-text-primary": t.color === "primary",
        "tw-text-inverse": t.color === "alt",
        "tw-text-success": t.color === "success",
        "tw-text-caution": t.color === "warning",
        "tw-text-error": t.color === "error",
        "tw-text-accent": t.color === "accent",
        // size
        "tw-text-body-xs": t.size === "sm",
        "tw-text-body-sm": t.size === "base"
      }
    ]), a = x(() => ({
      "tw-text-icon-discrete": t.color === "default",
      "tw-text-icon-discrete3": t.color === "disabled",
      "tw-text-icon-primary": t.color === "primary",
      "tw-text-icon-inverse": t.color === "alt",
      "tw-text-icon-success": t.color === "success",
      "tw-text-icon-caution": t.color === "warning",
      "tw-text-icon-error": t.color === "error",
      "tw-text-icon-accent": t.color === "accent"
    }));
    return (r, s) => (p(), k("span", {
      class: z(["tw-flex tw-w-fit tw-items-center tw-rounded-lg", [n.value, o.value]])
    }, [
      r.iconLeftName ? (p(), $(W, {
        key: 0,
        name: r.iconLeftName,
        size: "sm",
        class: z(a.value)
      }, null, 8, ["name", "class"])) : A("", !0),
      r.text ? (p(), k("span", {
        key: 1,
        class: z(["tw-px-3xs", i.value])
      }, G(r.text), 3)) : A("", !0),
      r.iconRightName ? (p(), $(W, {
        key: 2,
        name: r.iconRightName,
        size: "sm",
        class: z(a.value)
      }, null, 8, ["name", "class"])) : A("", !0)
    ], 2));
  }
}), j0 = { class: "tw-flex tw-w-full tw-items-center tw-gap-x-md" }, U0 = { class: "tw-flex tw-flex-1 tw-items-center tw-gap-x-2xs" }, W0 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-y-3xs" }, q0 = {
  key: 0,
  class: "tw-text-body tw-font-medium"
}, K0 = {}, A1 = /* @__PURE__ */ V({
  ...K0,
  __name: "UISelectionCard",
  props: /* @__PURE__ */ ie({
    displayCheckbox: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    iconName: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    tagText: { default: "" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = he(e, "modelValue");
    return (n, o) => (p(), k("label", {
      class: z(["tw-flex tw-w-full tw-min-w-[176px] tw-cursor-pointer tw-items-center tw-justify-between tw-gap-x-md tw-rounded-lg tw-border tw-border-discrete2 tw-bg-surface focus-within:tw-outline hover:tw-bg-fill-hover", [
        {
          "!tw-border-default tw-shadow-[inset_0px_0px_0px_1px] tw-shadow-text-default-color": t.value && !n.isDisabled,
          "tw-pointer-events-none tw-text-discrete3": n.isDisabled,
          "!tw-border-error": n.hasError
        },
        n.size === "sm" ? "tw-p-sm tw-pl-md" : "tw-p-lg"
      ]])
    }, [
      R("span", j0, [
        te(jn, {
          modelValue: t.value,
          "onUpdate:modelValue": o[0] || (o[0] = (i) => t.value = i),
          "has-error": n.hasError,
          "is-disabled": n.isDisabled,
          class: z(["tw-pointer-events-none", {
            "tw-sr-only": !n.displayCheckbox
          }])
        }, null, 8, ["modelValue", "has-error", "is-disabled", "class"]),
        R("span", U0, [
          R("span", W0, [
            n.text ? (p(), k("span", q0, G(n.text), 1)) : A("", !0),
            n.subText ? (p(), k("span", {
              key: 1,
              class: z(n.text ? "tw-text-body-sm" : "tw-text-body")
            }, G(n.subText), 3)) : A("", !0)
          ]),
          n.tagText ? (p(), $(H0, {
            key: 0,
            text: n.tagText,
            color: n.isDisabled ? "disabled" : "default",
            class: z({
              "!tw-bg-fill-discrete2": t.value
            })
          }, null, 8, ["text", "color", "class"])) : A("", !0)
        ]),
        n.iconName ? (p(), $(W, {
          key: 0,
          name: n.iconName,
          size: n.size === "sm" ? "xl" : "2xl",
          class: "tw-text-icon"
        }, null, 8, ["name", "size"])) : A("", !0)
      ])
    ], 2));
  }
}), G0 = {
  class: "tw-relative tw-flex tw-w-full tw-gap-[6px]",
  "data-testid": "stepper"
}, _0 = ["data-testid"], Q0 = /* @__PURE__ */ V({
  __name: "UIStepper",
  props: {
    steps: {},
    currentStep: {}
  },
  setup(e) {
    return (t, n) => (p(), k("div", G0, [
      (p(!0), k(be, null, We(t.steps, (o) => (p(), k("div", {
        key: o,
        class: "tw-relative tw-h-[5px] tw-w-full tw-bg-fill-primary tw-bg-opacity-25",
        "data-testid": "stepper-step"
      }, [
        te(Lt, { name: "unfold" }, {
          default: j(() => [
            o <= t.currentStep ? (p(), k("div", {
              key: 0,
              class: "tw-h-full tw-w-full tw-origin-left tw-transform tw-bg-fill-primary",
              "data-testid": `stepper-step-${o}-is-complete`
            }, null, 8, _0)) : A("", !0)
          ]),
          _: 2
        }, 1024)
      ]))), 128))
    ]));
  }
}), I1 = /* @__PURE__ */ Nn(Q0, [["__scopeId", "data-v-550a2be1"]]), Y0 = { class: "tabs" }, X0 = {
  role: "tablist",
  class: "tw-flex tw-gap-x-2xl"
}, Z0 = ["aria-selected", "aria-controls", "disabled", "tabindex", "onClick", "onKeydown"], J0 = ["id", "aria-labelledby"], e1 = {}, E1 = /* @__PURE__ */ V({
  ...e1,
  __name: "UITab",
  props: {
    tabsTitles: {},
    disabledTabsTitles: { default: () => [] },
    isTextColorInverse: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = re(), i = t, a = _(0), r = He("tabRefs"), s = Object.keys(o), l = x(() => n.tabsTitles.map((u, m) => s.includes(`tab-${m}`) ? m : null).filter((u) => u !== null));
    function c(u) {
      n.disabledTabsTitles.includes(n.tabsTitles[u]) || (a.value = u, i("click"));
    }
    function d(u, m) {
      var f, h;
      if (r.value) {
        if (m.key === "ArrowRight") {
          const b = u === n.tabsTitles.length - 1 ? u : u + 1;
          (f = r.value[b]) == null || f.focus();
        } else if (m.key === "ArrowLeft") {
          const b = u === 0 ? u : u - 1;
          (h = r.value[b]) == null || h.focus();
        }
      }
    }
    return (u, m) => (p(), k("div", Y0, [
      R("div", X0, [
        (p(!0), k(be, null, We(u.tabsTitles, (f, h) => (p(), k("button", {
          key: f,
          ref_for: !0,
          ref_key: "tabRefs",
          ref: r,
          role: "tab",
          "aria-selected": a.value === h,
          "aria-controls": `tab-${h}`,
          disabled: u.disabledTabsTitles.includes(f),
          tabindex: a.value === h ? 0 : -1,
          class: z(["tw-border-b-4 tw-border-b-transparent tw-pb-sm tw-font-bold", {
            "!tw-border-b-primary": a.value === h,
            "tw-text-inverse": u.isTextColorInverse,
            "!tw-text-discrete3": u.disabledTabsTitles.includes(f),
            "hover:!tw-border-b-discrete3": !u.disabledTabsTitles.includes(f)
          }]),
          onClick: (b) => c(h),
          onKeydown: (b) => d(h, b)
        }, G(f), 43, Z0))), 128))
      ]),
      (p(!0), k(be, null, We(l.value, (f) => Me((p(), k("section", {
        id: `tab-${f}`,
        key: f,
        role: "tabpanel",
        "aria-labelledby": u.tabsTitles[f]
      }, [
        O(u.$slots, `tab-${f}`)
      ], 8, J0)), [
        [Mo, a.value === f]
      ])), 128))
    ]));
  }
}), t1 = ["aria-controlledby", "onMouseleave", "onKeydown"], n1 = {}, o1 = /* @__PURE__ */ V({
  ...n1,
  __name: "UITooltip",
  props: {
    forceHidden: { type: Boolean, default: !1 },
    forceShown: { type: Boolean, default: !1 },
    hideArrow: { type: Boolean, default: !1 },
    hideDelay: { default: 0 },
    placement: { default: "bottom" },
    showWhenClicked: { type: Boolean, default: !1 }
  },
  emits: ["show", "hide"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = re(), a = _(), r = Ce(), s = `${r}-tooltip-content`, l = He("tooltipContentRef"), c = _(!1), d = x(() => c.value ? "" : n.placement.includes("top") ? "emptyHoverAreaBottom" : n.placement.includes("bottom") ? "emptyHoverAreaTop" : n.placement.includes("left") ? "emptyHoverAreaRight" : n.placement.includes("right") ? "emptyHoverAreaLeft" : "");
    function u(w, C = !0) {
      !C || c.value || n.forceShown || (clearTimeout(a.value), a.value = setTimeout(() => w(!1), n.hideDelay));
    }
    function m() {
      clearTimeout(a.value);
    }
    function f(w) {
      var C;
      n.forceHidden || n.forceShown || (clearTimeout(a.value), w(!0), (C = l.value) == null || C.focus());
    }
    function h(w, C) {
      var S;
      if (!(!n.showWhenClicked || n.forceHidden || n.forceShown)) {
        if (!c.value) {
          c.value = !0, w(!0), (S = l.value) == null || S.focus();
          return;
        }
        c.value = !c.value, C && w(!1);
      }
    }
    function b(w) {
      w(!1), c.value = !1;
    }
    function v() {
      c.value = !1;
    }
    return (w, C) => (p(), $(Hn, {
      placement: w.placement,
      "has-arrow": !w.hideArrow,
      "force-show-floating-el": w.forceShown,
      onClickOutside: v,
      onHideFloating: C[0] || (C[0] = (S) => o("hide")),
      onShowFloating: C[1] || (C[1] = (S) => o("show"))
    }, {
      reference: j(({ toggleContentDisplay: S, isFloatingElDisplayed: I }) => [
        T(U)(i.referenceEl) ? O(w.$slots, "referenceEl", {
          key: 0,
          id: T(r),
          ariaDescribedby: s,
          ariaExpanded: I,
          onClick: (N) => h(S, I),
          onMouseenter: (N) => f(S),
          onMouseleave: (N) => u(S, I),
          onKeydown: at((N) => b(S), ["escape"])
        }, void 0, !0) : A("", !0)
      ]),
      floating: j(({ toggleContentDisplay: S }) => [
        T(U)(i.tooltipContent) ? (p(), k("div", {
          key: 0,
          id: s,
          ref: "tooltipContentRef",
          class: z(["tw-text-body-xs tw-relative tw-z-[999999] tw-flex tw-max-w-[224px] tw-flex-col tw-gap-y-sm tw-rounded-sm tw-bg-fill-alt tw-p-sm tw-text-inverse focus:tw-outline-none", d.value]),
          "aria-controlledby": T(r),
          tabindex: "-1",
          role: "tooltip",
          onMouseenter: m,
          onMouseleave: (I) => u(S),
          onKeydown: at((I) => b(S), ["escape"])
        }, [
          O(w.$slots, "tooltipContent", {}, void 0, !0)
        ], 42, t1)) : A("", !0)
      ]),
      _: 3
    }, 8, ["placement", "has-arrow", "force-show-floating-el"]));
  }
}), $1 = /* @__PURE__ */ Nn(o1, [["__scopeId", "data-v-5ddfca42"]]);
ni(Gi);
export {
  r1 as Iconify,
  l1 as UIAvatar,
  qr as UIBanner,
  c1 as UIBannerMulti,
  u1 as UIBar,
  d1 as UIBarStickyFooter,
  ot as UIButton,
  f1 as UIButtonLink,
  h1 as UICard,
  Mn as UIChip,
  m1 as UIChipButton,
  fs as UIChipDropdown,
  p1 as UIChipSelection,
  v1 as UIDropdownMenu,
  w1 as UIDropdownMenuList,
  b1 as UIDropdownMenuListItem,
  W as UIIcon,
  jn as UIInputCheckbox,
  g1 as UIInputPassword,
  y1 as UIInputSelectChip,
  x1 as UIInputText,
  C1 as UIInputTextarea,
  k1 as UIInputToggleCheckbox,
  T1 as UIInputToggleRadio,
  S1 as UIModal,
  A1 as UISelectionCard,
  I1 as UIStepper,
  E1 as UITab,
  H0 as UITag,
  $1 as UITooltip,
  Rl as UITransitionExpand,
  s1 as grooverUITailwindPlugin
};
